{
  "admin.alertsScreen.waGroup.title": {
    "defaultMessage": "Grupo do WhatsApp para alertas"
  },
  "admin.dashboard.alertsBody": {
    "defaultMessage": "Configurar notificações de monitoramento"
  },
  "admin.dashboard.alertsBtnText": {
    "defaultMessage": "Gerenciar alertas"
  },
  "admin.dashboard.alertsTitle": {
    "defaultMessage": "Alertas"
  },
  "admin.dashboard.btnLink": {
    "defaultMessage": "Obtain group invite link"
  },
  "admin.dashboard.contentAiBody": {
    "defaultMessage": "Administrar configuração do Content AI"
  },
  "admin.dashboard.contentAiBtnText": {
    "defaultMessage": "Configurar"
  },
  "admin.dashboard.copyLink": {
    "defaultMessage": "Copy link URL"
  },
  "admin.dashboard.coreAdministrationTitle": {
    "defaultMessage": "Administração principal"
  },
  "admin.dashboard.featureConfigurationTitle": {
    "defaultMessage": "Configuração de funcionalidades"
  },
  "admin.dashboard.fragments": {
    "defaultMessage": "Fragmentos"
  },
  "admin.dashboard.fragmentsBody": {
    "defaultMessage": "Gerenciar configuração de fragmentos"
  },
  "admin.dashboard.fragmentsBtnText": {
    "defaultMessage": "Configurar"
  },
  "admin.dashboard.groupsBtnText": {
    "defaultMessage": "Gerenciar grupos"
  },
  "admin.dashboard.socialIntegrationsTitle": {
    "defaultMessage": "Integração com plataformas"
  },
  "admin.dashboard.stationsBody": {
    "defaultMessage": "Existem {count, plural, one {#} other {#} } {count, plural, one {emissora registrada} other {emissoras registradas} }"
  },
  "admin.dashboard.stationsBtnText": {
    "defaultMessage": "Gerenciar emissoras"
  },
  "admin.dashboard.stationsTitle": {
    "defaultMessage": "Emissoras"
  },
  "admin.dashboard.title": {
    "defaultMessage": "Administração"
  },
  "admin.dashboard.usersBody": {
    "defaultMessage": "Existem {count, plural, one {#} other {#} } {count, plural, one {usuário registrado} other {usuários registrados} }"
  },
  "admin.dashboard.usersBtnText": {
    "defaultMessage": "Gerenciar usuários"
  },
  "admin.dashboard.usersTitle": {
    "defaultMessage": "Usuários e grupos"
  },
  "admin.dashboard.videoAnalysisBody": {
    "defaultMessage": "Configurar análise automática de vídeo"
  },
  "admin.dashboard.videoAnalysisBtnText": {
    "defaultMessage": "Configurar"
  },
  "admin.dashboard.videoAnalysisTitle": {
    "defaultMessage": "Análise de Vídeo"
  },
  "admin.dashboard.youtubeBtnText": {
    "defaultMessage": "Configurar"
  },
  "admin.fragments.addNewFooter": {
    "defaultMessage": "Adicionar novo rodapé"
  },
  "admin.fragments.configUpdated": {
    "defaultMessage": "Configuração de fragmentos para {stationName} atualizada"
  },
  "admin.fragments.footers": {
    "defaultMessage": "Rodapés na descrição"
  },
  "admin.fragments.fragmentsConfigUpdated": {
    "defaultMessage": "Configuração de fragmentos para {stationName} atualizada"
  },
  "admin.fragments.newFooterName": {
    "defaultMessage": "Novo rodapé"
  },
  "admin.fragments.noFooters": {
    "defaultMessage": "Nenhum rodapé registrado"
  },
  "admin.fragments.registeredFootersTitle": {
    "defaultMessage": "Rodapés registrados"
  },
  "admin.fragments.tagGroups": {
    "defaultMessage": "Grupos de tags"
  },
  "admin.fragments.title": {
    "defaultMessage": "Fragmentos"
  },
  "admin.fragments.twoDefaultsNotAllowed": {
    "defaultMessage": "Não pode haver dois rodapés definidos como padrão"
  },
  "admin.fragments.useAsDefault": {
    "defaultMessage": "Usar como padrão"
  },
  "admin.fragments.watermark": {
    "defaultMessage": "Marca d'água da mídia"
  },
  "admin.fragments.watermark.active": {
    "defaultMessage": "Ativo"
  },
  "admin.fragments.watermark.configTitle": {
    "defaultMessage": "Configuração"
  },
  "admin.fragments.watermark.imageTitle": {
    "defaultMessage": "Imagem"
  },
  "admin.fragments.watermark.loadLabel": {
    "defaultMessage": "Carregar marca d'água"
  },
  "admin.fragments.watermark.opacity": {
    "defaultMessage": "Opacidade"
  },
  "admin.fragments.watermark.paddingX": {
    "defaultMessage": "Padding X"
  },
  "admin.fragments.watermark.paddingY": {
    "defaultMessage": "Padding Y"
  },
  "admin.fragments.watermark.positionBottom": {
    "defaultMessage": "Base"
  },
  "admin.fragments.watermark.positionCenter": {
    "defaultMessage": "Centro"
  },
  "admin.fragments.watermark.positionLeft": {
    "defaultMessage": "Esquerda"
  },
  "admin.fragments.watermark.positionRight": {
    "defaultMessage": "Direita"
  },
  "admin.fragments.watermark.positionTitle": {
    "defaultMessage": "Posição"
  },
  "admin.fragments.watermark.positionTop": {
    "defaultMessage": "Topo"
  },
  "admin.fragments.watermark.positionX": {
    "defaultMessage": "Posição X"
  },
  "admin.fragments.watermark.positionY": {
    "defaultMessage": "Posição Y"
  },
  "admin.groups.addScreen.helpLinkText": {
    "defaultMessage": "O que é um grupo?"
  },
  "admin.groups.alertsScreen.title": {
    "defaultMessage": "Alertas"
  },
  "admin.groups.deleteScreen.btn": {
    "defaultMessage": "Delete group"
  },
  "admin.groups.deleteScreen.prompt": {
    "defaultMessage": "Você realmente deseja excluir o grupo <b>{name}</b>? {br} Esta ação não pode ser desfeita."
  },
  "admin.groups.deleteScreen.title": {
    "defaultMessage": "Excluir grupo"
  },
  "admin.groups.editScreen.title": {
    "defaultMessage": "Edit group"
  },
  "admin.groups.filters.namePlaceholder": {
    "defaultMessage": "Buscar por nome"
  },
  "admin.groups.form.name.label": {
    "defaultMessage": "Name"
  },
  "admin.groups.form.name.placeholder": {
    "defaultMessage": "Por exemplo \"Usuários das Principais Emissoras\""
  },
  "admin.groups.form.users.help": {
    "defaultMessage": "<b>NOTA:</b> usuários podem pertencer a apenas um grupo. Usuários selecionados que estão vinculados a outros grupos serão sobrescritos."
  },
  "admin.groups.form.users.label": {
    "defaultMessage": "Usuários atribuídos"
  },
  "admin.groups.form.users.noMore": {
    "defaultMessage": "Não há mais usuários disponíveis"
  },
  "admin.groups.help.assignGroup": {
    "defaultMessage": "Ao definir o grupo de um usuário, ele terá acesso a todas as estações às quais o grupo tem acesso. Você pode gerenciar as permissões de cada grupo em <strong>Administração {'>'} Estação {'>'} Permissões de grupos</strong>."
  },
  "admin.groups.help.intro": {
    "defaultMessage": "Os <strong>grupos</strong> são um método útil para organizar usuários e controlar acesso e permissões de estações de forma simples."
  },
  "admin.groups.help.oneGroup": {
    "defaultMessage": "Um usuário pode pertencer apenas a <strong>um</strong> grupo. Se precisar dar acesso específico a um usuário além do grupo atribuído, você pode atribuir uma permissão individual em <strong>Administração {'>'} Estação {'>'} Permissões de usuário</strong>."
  },
  "admin.groups.listScreen.links.createGroup": {
    "defaultMessage": "Criar grupo"
  },
  "admin.groups.listScreen.noGroups": {
    "defaultMessage": "Nenhum grupo encontrado"
  },
  "admin.groups.listScreen.title": {
    "defaultMessage": "Gerenciar grupos"
  },
  "admin.groups.listScreen.usersCountHeader": {
    "defaultMessage": "# Usuários"
  },
  "admin.groups.notifications.created": {
    "defaultMessage": "Grupo criado"
  },
  "admin.groups.notifications.deleted": {
    "defaultMessage": "Group deleted"
  },
  "admin.groups.notifications.updated": {
    "defaultMessage": "Grupo atualizado"
  },
  "admin.groups.viewScreen.actionsPermissionsTab": {
    "defaultMessage": "Permissões de ações"
  },
  "admin.groups.viewScreen.assignedUsers.body": {
    "defaultMessage": "Este grupo <b> {count, plural, =0 {não tem} one {tem #} other {tem #} } </b> {count, plural, one {usuário atribuído} other {usuários atribuídos} }"
  },
  "admin.groups.viewScreen.assignedUsers.title": {
    "defaultMessage": "Usuários atribuídos"
  },
  "admin.groups.viewScreen.basicInfoTab": {
    "defaultMessage": "Info"
  },
  "admin.groups.viewScreen.notDeletableHelp": {
    "defaultMessage": "Este grupo não pode ser excluído porque contém usuários atribuídos"
  },
  "admin.groups.viewScreen.permissions.filterPlaceholder": {
    "defaultMessage": "Filtrar emissoras"
  },
  "admin.groups.viewScreen.permissions.noFilterMatch": {
    "defaultMessage": "No matching stations found"
  },
  "admin.groups.viewScreen.permissions.updateError": {
    "defaultMessage": "Não foi possível atualizar a permissão"
  },
  "admin.groups.viewScreen.stationsPermissionsTab": {
    "defaultMessage": "Permissões de emissoras"
  },
  "admin.integrations.accept": {
    "defaultMessage": "Aceitar"
  },
  "admin.integrations.cancel": {
    "defaultMessage": "Cancelar"
  },
  "admin.integrations.warningTitle": {
    "defaultMessage": "Atenção"
  },
  "admin.permissions.reset": {
    "defaultMessage": "Restabelecer"
  },
  "admin.permissions.resetPermissions": {
    "defaultMessage": "Restabelecer permissões"
  },
  "admin.permissions.resetPermissionsPrompt": {
    "defaultMessage": "Tem certeza de que deseja restabelecer todas as permissões? Esta ação não pode ser desfeita."
  },
  "admin.permissionsLabel": {
    "defaultMessage": "Admin"
  },
  "admin.socialExport.body": {
    "defaultMessage": "Configurar upload para {platformName} para fragmentos"
  },
  "admin.socialExport.title": {
    "defaultMessage": "Integração com {name}"
  },
  "admin.stations.editScreen.title": {
    "defaultMessage": "Editar emissora"
  },
  "admin.stations.filters.namePlaceholder": {
    "defaultMessage": "Buscar por nome"
  },
  "admin.stations.listScreen.title": {
    "defaultMessage": "Emissoras"
  },
  "admin.stations.viewScreen.basicInfo": {
    "defaultMessage": "Info"
  },
  "admin.stations.viewScreen.groups": {
    "defaultMessage": "Grupos"
  },
  "admin.stations.viewScreen.groupsFilter": {
    "defaultMessage": "Filtrar grupos"
  },
  "admin.stations.viewScreen.groupsPermissions": {
    "defaultMessage": "Permissões de grupos"
  },
  "admin.stations.viewScreen.logo": {
    "defaultMessage": "Logo"
  },
  "admin.stations.viewScreen.noGroups": {
    "defaultMessage": "Nenhum grupo encontrado"
  },
  "admin.stations.viewScreen.noGroupsFound": {
    "defaultMessage": "No matching groups found"
  },
  "admin.stations.viewScreen.noUsersFound": {
    "defaultMessage": "Nenhum usuário encontrado"
  },
  "admin.stations.viewScreen.permissionInherited": {
    "defaultMessage": "Permissão herdada do grupo {groupName}"
  },
  "admin.stations.viewScreen.permissionUpdateError": {
    "defaultMessage": "Não foi possível atualizar a permissão"
  },
  "admin.stations.viewScreen.userLinkText": {
    "defaultMessage": "View user info"
  },
  "admin.stations.viewScreen.usersFilter": {
    "defaultMessage": "Filtrar usuários"
  },
  "admin.stations.viewScreen.usersPermissions": {
    "defaultMessage": "Permissões de usuários"
  },
  "admin.tagGroups.deleteGroupConfirm": {
    "defaultMessage": "Tem certeza de que deseja excluir o grupo?"
  },
  "admin.tagGroups.deleteGroupTitle": {
    "defaultMessage": "Excluir grupo"
  },
  "admin.tagGroups.newGroupName": {
    "defaultMessage": "Novo grupo"
  },
  "admin.sidebar.configuration": {
    "defaultMessage": "Features"
  },
  "admin.sidebar.groups": {
    "defaultMessage": "Grupos"
  },
  "admin.sidebar.integrations": {
    "defaultMessage": "Plataformas"
  },
  "admin.sidebar.stationGroups": {
    "defaultMessage": "Grupos de emissoras"
  },
  "admin.stationGroups.breadcrumb": {
    "defaultMessage": "Grupos de emissoras"
  },
  "admin.stationGroups.filters.namePlaceholder": {
    "defaultMessage": "Buscar por nome"
  },
  "admin.stationGroups.listScreen.stationsCountHeader": {
    "defaultMessage": "# Emissoras"
  },
  "admin.stationGroups.listScreen.title": {
    "defaultMessage": "Grupos de emissoras"
  },
  "admin.stationGroups.viewScreen.accessType": {
    "defaultMessage": "Acesso"
  },
  "admin.stationGroups.viewScreen.accessType.owned": {
    "defaultMessage": "Próprio"
  },
  "admin.stationGroups.viewScreen.accessType.shared": {
    "defaultMessage": "Compartilhado"
  },
  "admin.stationGroups.viewScreen.noStations": {
    "defaultMessage": "Não há emissoras neste grupo"
  },
  "admin.stationGroups.viewScreen.slug": {
    "defaultMessage": "Slug"
  },
  "admin.stationGroups.viewScreen.stations": {
    "defaultMessage": "Emissoras"
  },
  "admin.sidebar.organization": {
    "defaultMessage": "Organização"
  },
  "admin.title": {
    "defaultMessage": "Admin"
  },
  "admin.users.addScreen.title": {
    "defaultMessage": "Criar usuário"
  },
  "admin.users.deleteScreen.prompt": {
    "defaultMessage": "Do you want to delete the user <b>{email}</b>? {br} This action can not be undone."
  },
  "admin.users.deleteScreen.title": {
    "defaultMessage": "Excluir usuário"
  },
  "admin.users.editScreen.title": {
    "defaultMessage": "Editar usuário"
  },
  "admin.users.form.errors.errorUserExistsNotification": {
    "defaultMessage": "Usuário já existe"
  },
  "admin.users.form.group.label": {
    "defaultMessage": "Grupo"
  },
  "admin.users.form.group.noGroup": {
    "defaultMessage": "Sem grupo"
  },
  "admin.users.form.name.label": {
    "defaultMessage": "Nome"
  },
  "admin.users.filters.emailPlaceholder": {
    "defaultMessage": "Buscar por email"
  },
  "admin.users.filters.namePlaceholder": {
    "defaultMessage": "Buscar por nome"
  },
  "admin.users.form.surname.label": {
    "defaultMessage": "Sobrenome"
  },
  "admin.users.lastLogin": {
    "defaultMessage": "Último login"
  },
  "admin.users.listScreen.links.createUser": {
    "defaultMessage": "Criar usuário"
  },
  "admin.users.listScreen.title": {
    "defaultMessage": "Gerenciar usuários"
  },
  "admin.users.loginMethod.label": {
    "defaultMessage": "Método de login"
  },
  "admin.users.loginMethod.SOCIAL_LOGIN.description": {
    "defaultMessage": "O usuário utilizará sua conta de email existente no Google para entrar."
  },
  "admin.users.loginMethod.SOCIAL_LOGIN.label": {
    "defaultMessage": "Login com Google"
  },
  "admin.users.loginMethod.USERNAME_PASSWORD.description": {
    "defaultMessage": "O usuário receberá um email com instruções para configurar sua conta"
  },
  "admin.users.loginMethod.USERNAME_PASSWORD.label": {
    "defaultMessage": "Usuário e senha"
  },
  "admin.users.name": {
    "defaultMessage": "Nome"
  },
  "admin.users.notifications.created": {
    "defaultMessage": "Usuário criado"
  },
  "admin.users.notifications.deleted": {
    "defaultMessage": "User deleted"
  },
  "admin.users.notifications.updated": {
    "defaultMessage": "Usuário atualizado"
  },
  "admin.users.role": {
    "defaultMessage": "Função"
  },
  "admin.users.roles.label": {
    "defaultMessage": "Função do usuário"
  },
  "admin.users.roles.values.CLIENT_ADMIN.description": {
    "defaultMessage": "Usuário administrador do cliente"
  },
  "admin.users.roles.values.CLIENT_ADMIN.label": {
    "defaultMessage": "Administrador"
  },
  "admin.users.roles.values.CLIENT_USER.description": {
    "defaultMessage": "Usuário padrão do cliente"
  },
  "admin.users.roles.values.CLIENT_USER.label": {
    "defaultMessage": "Básico"
  },
  "admin.users.roles.values.SUPERADMIN.description": {
    "defaultMessage": "Administrador do sistema"
  },
  "admin.users.roles.values.SUPERADMIN.label": {
    "defaultMessage": "Super administrador"
  },
  "admin.users.title": {
    "defaultMessage": "Usuários"
  },
  "admin.users.viewScreen.actionsPermissionsTab": {
    "defaultMessage": "Permissões de ações"
  },
  "admin.users.viewScreen.assignedGroup.noGroup": {
    "defaultMessage": "- Sem grupo -"
  },
  "admin.users.viewScreen.assignedGroup.title": {
    "defaultMessage": "Grupo atribuído"
  },
  "admin.users.viewScreen.basicInfoTab": {
    "defaultMessage": "Info"
  },
  "admin.users.viewScreen.fullName": {
    "defaultMessage": "Nome completo"
  },
  "admin.users.viewScreen.permissions.clientAdminAllStationsAccess": {
    "defaultMessage": "Os usuários administradores têm acesso a todas as emissoras por padrão."
  },
  "admin.users.viewScreen.permissions.filterPlaceholder": {
    "defaultMessage": "Filtrar emissoras"
  },
  "admin.users.viewScreen.permissions.noFilterMatch": {
    "defaultMessage": "No matching stations found"
  },
  "admin.users.viewScreen.permissions.updateError": {
    "defaultMessage": "Não foi possível atualizar a permissão"
  },
  "admin.users.viewScreen.stationsPermissionsTab": {
    "defaultMessage": "Permissões de emissoras"
  },
  "admin.users.viewScreen.userRole": {
    "defaultMessage": "Função do usuário"
  },
  "admin.videoAnalysis.adOverlays.ignoredEntities": {
    "defaultMessage": "Entidades ignoradas"
  },
  "admin.videoAnalysis.adOverlays.notEnabledForStation": {
    "defaultMessage": "Ad Overlays não ativado para esta emissora"
  },
  "admin.videoAnalysis.adOverlays.numericAllowlist": {
    "defaultMessage": "Lista numérica permitida"
  },
  "admin.videoAnalysis.adOverlays.title": {
    "defaultMessage": "Ad Overlays"
  },
  "admin.videoAnalysis.settingsUpdated": {
    "defaultMessage": "Configuração atualizada"
  },
  "assets.fileUploaded": {
    "defaultMessage": "Arquivo enviado"
  },
  "assets.upload.error": {
    "defaultMessage": "Ocorreu um erro ao carregar o arquivo, tente novamente"
  },
  "assets.upload.errorFileSizeExceeded": {
    "defaultMessage": "Os arquivos não devem exceder {maxSizeMb}MB"
  },
  "assets.upload.label": {
    "defaultMessage": "Enviar recurso"
  },
  "assets.upload.maxSize": {
    "defaultMessage": "Máx. {max}MB."
  },
  "assets.viewFile": {
    "defaultMessage": "Ver arquivo"
  },
  "audit.adaptiveRun.noActions": {
    "defaultMessage": "Sem ações"
  },
  "audit.adoverlayScreen.brand": {
    "defaultMessage": "Marca"
  },
  "audit.adoverlayScreen.duration": {
    "defaultMessage": "Duração"
  },
  "audit.adoverlayScreen.image": {
    "defaultMessage": "Imagem"
  },
  "audit.adoverlayScreen.loading": {
    "defaultMessage": "Carregando ad overlays"
  },
  "audit.adoverlayScreen.noResults": {
    "defaultMessage": "Nenhum ad overlay encontrado"
  },
  "audit.aod.actions.acceptRun": {
    "defaultMessage": "Aceitar"
  },
  "audit.aod.actions.acceptRun.description": {
    "defaultMessage": "Aceitar o resultado do relatório e executar novamente para que seja exportado"
  },
  "audit.aod.actions.acceptRun.reason": {
    "defaultMessage": "Motivo (opcional)"
  },
  "audit.aod.actions.acceptRun.reason.placeholder": {
    "defaultMessage": "Digite um motivo opcional para aceitar esta execução"
  },
  "audit.aod.actions.downloadExport": {
    "defaultMessage": "Baixar export"
  },
  "audit.aod.actions.goToReport": {
    "defaultMessage": "Ir para o relatório"
  },
  "audit.aod.actions.orderReprocess": {
    "defaultMessage": "Reprocessar ordem {orderId}"
  },
  "audit.aod.actions.orderReprocess.completed": {
    "defaultMessage": "Ordem {orderId} reprocessada"
  },
  "audit.aod.actions.orderReprocess.completed.multiple": {
    "defaultMessage": "Ordens reprocessadas: {currentOrders}"
  },
  "audit.aod.actions.orderReprocess.confirm.button": {
    "defaultMessage": "Confirmar"
  },
  "audit.aod.actions.orderReprocess.confirm.message": {
    "defaultMessage": "Tem certeza de que deseja iniciar o reprocessamento do pedido {orderId}?"
  },
  "audit.aod.actions.orderReprocess.confirm.message.withKey": {
    "defaultMessage": "Tem certeza de que deseja iniciar o reprocessamento do pedido {orderId}? (key: {key})"
  },
  "audit.aod.actions.orderReprocess.confirm.title": {
    "defaultMessage": "Confirmar reprocessamento"
  },
  "audit.aod.actions.orderReprocess.multiple": {
    "defaultMessage": "Reprocessar {count} ordens"
  },
  "audit.aod.actions.orderReprocess.processing": {
    "defaultMessage": "Reprocessando ordem {orderId}"
  },
  "audit.aod.actions.orderReprocess.processing.multiple": {
    "defaultMessage": "Reprocessando ordens {currentOrders}"
  },
  "audit.aod.actions.orderReprocess.reprocessedOn": {
    "defaultMessage": "Reprocessado em {date}"
  },
  "audit.aod.actions.orderReprocess.reprocessedOn.withKey": {
    "defaultMessage": "Reprocessado em {date} (key: {key})"
  },
  "audit.aod.actions.refreshRun": {
    "defaultMessage": "Atualizar"
  },
  "audit.aod.actions.refreshRun.description": {
    "defaultMessage": "Reexecutar a execução com os resultados existentes sem alterar as condições de export"
  },
  "audit.aod.actions.refreshRun.description.missingMaterials": {
    "defaultMessage": "Depois de carregar os materiais faltantes, atualize a execução para reavaliar o relatório."
  },
  "audit.aod.actions.restartRun": {
    "defaultMessage": "Reiniciar execução"
  },
  "audit.aod.actions.restartRun.message": {
    "defaultMessage": "Tem certeza de que deseja reiniciar esta execução? Esta ação removerá seu relatório e recolocará o processamento na fila."
  },
  "audit.aod.actions.restartRun.title": {
    "defaultMessage": "Reiniciar execução"
  },
  "audit.aod.actions.triggerReprocess": {
    "defaultMessage": "Reprocessar"
  },
  "audit.aod.actions.triggerReprocess.completed": {
    "defaultMessage": "Reprocessamento concluído"
  },
  "audit.aod.actions.triggerReprocess.description": {
    "defaultMessage": "Iniciar o reprocessamento da ordem e depois reexecutar a execução"
  },
  "audit.aod.actions.triggerReprocess.error": {
    "defaultMessage": "Não foi possível iniciar o reprocessamento"
  },
  "audit.aod.actions.triggerReprocess.error.missingMaterials": {
    "defaultMessage": "Não é possível reprocessar: faltam materiais. Carregue os áudios e atualize a execução."
  },
  "audit.aod.actions.triggerReprocess.failed.message": {
    "defaultMessage": "Há problemas que precisam ser resolvidos com o reprocessamento:"
  },
  "audit.aod.actions.triggerReprocess.failed.missingSegments": {
    "defaultMessage": "Segmentos faltantes:"
  },
  "audit.aod.actions.triggerReprocess.failed.missingSpotMedia": {
    "defaultMessage": "Mídias de spots faltantes:"
  },
  "audit.aod.actions.triggerReprocess.failed.title": {
    "defaultMessage": "Erro no reprocessamento"
  },
  "audit.aod.actions.triggerReprocess.missingMaterials.description": {
    "defaultMessage": "Os schedules sem match não têm mídias de spot vinculadas. Carregue os materiais e atualize a execução; o reprocessamento OLAF não ajuda sem áudio."
  },
  "audit.aod.actions.triggerReprocess.missingMaterials.title": {
    "defaultMessage": "Reprocessar indisponível"
  },
  "audit.aod.actions.triggerReprocess.startedAt": {
    "defaultMessage": "Iniciado em"
  },
  "audit.aod.actions.triggerReprocess.waiting": {
    "defaultMessage": "O reprocessamento está aguardando para iniciar"
  },
  "audit.aod.actions.viewResults": {
    "defaultMessage": "Ver resultados"
  },
  "audit.aod.exportConditions.description": {
    "defaultMessage": "Descrição"
  },
  "audit.aod.exportConditions.description.placeholder": {
    "defaultMessage": "Descrição opcional desta execução manual"
  },
  "audit.aod.exportConditions.enableEfficiency": {
    "defaultMessage": "Verificar eficiência mínima"
  },
  "audit.aod.exportConditions.minEfficiency": {
    "defaultMessage": "Eficiência mínima"
  },
  "audit.aod.exportConditions.minEfficiency.help": {
    "defaultMessage": "Eficiência mínima (0 a 100%)"
  },
  "audit.aod.exportConditions.minEfficiency.placeholder": {
    "defaultMessage": "0 - 100"
  },
  "audit.aod.gip.atLeastOneAdvertiser": {
    "defaultMessage": "Pelo menos um anunciante deve ser selecionado"
  },
  "audit.aod.gip.export.packageStorageStrategy.PER_RULE": {
    "defaultMessage": "Por regra"
  },
  "audit.aod.gip.export.packageStorageStrategy.PER_RUN": {
    "defaultMessage": "Por execução"
  },
  "audit.aod.gip.export.packageStorageStrategyLabel": {
    "defaultMessage": "Armazenamento do pacote"
  },
  "audit.aod.gip.order": {
    "defaultMessage": "Ordem"
  },
  "audit.aod.review.evidenceExportTitle": {
    "defaultMessage": "Exportação de evidências"
  },
  "audit.aod.review.exportConditionsTitle": {
    "defaultMessage": "Condições de exportação"
  },
  "audit.aod.review.reportConfigTitle": {
    "defaultMessage": "Configuração do relatório"
  },
  "audit.aod.rules.active": {
    "defaultMessage": "Ativa"
  },
  "audit.aod.rules.add": {
    "defaultMessage": "Criar regra"
  },
  "audit.aod.rules.add.reportType": {
    "defaultMessage": "Tipo de relatório"
  },
  "audit.aod.rules.addScreen.title": {
    "defaultMessage": "Criar regra AOD"
  },
  "audit.aod.rules.createdAt": {
    "defaultMessage": "Criada"
  },
  "audit.aod.rules.createdBy": {
    "defaultMessage": "por"
  },
  "audit.aod.rules.delete.message": {
    "defaultMessage": "Você tem certeza de que deseja excluir a regra \"{name}\"? Esta ação não pode ser desfeita."
  },
  "audit.aod.rules.delete.title": {
    "defaultMessage": "Excluir regra AOD"
  },
  "audit.aod.rules.edit.updateBtn": {
    "defaultMessage": "Atualizar regra"
  },
  "audit.aod.rules.editScreen.title": {
    "defaultMessage": "Editar regra AOD"
  },
  "audit.aod.rules.field.active": {
    "defaultMessage": "Estado"
  },
  "audit.aod.rules.field.createdAt": {
    "defaultMessage": "Criada"
  },
  "audit.aod.rules.field.name": {
    "defaultMessage": "Nome"
  },
  "audit.aod.rules.field.reportType": {
    "defaultMessage": "Tipo de relatório"
  },
  "audit.aod.rules.field.trigger": {
    "defaultMessage": "Trigger"
  },
  "audit.aod.rules.managers": {
    "defaultMessage": "Responsáveis"
  },
  "audit.aod.rules.managers.help": {
    "defaultMessage": "Selecione os usuários que serão responsáveis por esta regra"
  },
  "audit.aod.rules.managers.placeholder": {
    "defaultMessage": "Selecionar usuários"
  },
  "audit.aod.rules.manualRun.exportConditions": {
    "defaultMessage": "Condições de export"
  },
  "audit.aod.rules.manualRun.exportConditionsDescription": {
    "defaultMessage": "Modifique as condições de export para esta execução manual. As alterações serão aplicadas apenas a esta execução."
  },
  "audit.aod.rules.manualRun.notifications.error": {
    "defaultMessage": "Erro ao iniciar a execução manual"
  },
  "audit.aod.rules.manualRun.notifications.triggered": {
    "defaultMessage": "Execução manual iniciada"
  },
  "audit.aod.rules.manualRun.submit": {
    "defaultMessage": "Iniciar execução manual"
  },
  "audit.aod.rules.manualRunScreen.title": {
    "defaultMessage": "Executar regra AOD manualmente"
  },
  "audit.aod.rules.name": {
    "defaultMessage": "Nome"
  },
  "audit.aod.rules.name.placeholder": {
    "defaultMessage": "Digite o nome da regra"
  },
  "audit.aod.rules.notificationPolicy.ALWAYS": {
    "defaultMessage": "Sempre (fim de semana e fim de pedido)"
  },
  "audit.aod.rules.notificationPolicy.label": {
    "defaultMessage": "Política de notificação"
  },
  "audit.aod.rules.notificationPolicy.NONE": {
    "defaultMessage": "Sem notificações"
  },
  "audit.aod.rules.notificationPolicy.ORDER_END_ONLY": {
    "defaultMessage": "Apenas fim de pedido"
  },
  "audit.aod.rules.notifications.created": {
    "defaultMessage": "Regra AOD criada"
  },
  "audit.aod.rules.notifications.createError": {
    "defaultMessage": "Erro ao criar a regra AOD."
  },
  "audit.aod.rules.notifications.deleted": {
    "defaultMessage": "Regra AOD excluída"
  },
  "audit.aod.rules.notifications.deleteError": {
    "defaultMessage": "Erro ao excluir a regra AOD"
  },
  "audit.aod.rules.notifications.updated": {
    "defaultMessage": "Regra AOD atualizada"
  },
  "audit.aod.rules.notifications.updateError": {
    "defaultMessage": "Erro ao atualizar a regra AOD"
  },
  "audit.aod.rules.reportType": {
    "defaultMessage": "Tipo de relatório"
  },
  "audit.aod.rules.review.basicInfo": {
    "defaultMessage": "Informações Básicas"
  },
  "audit.aod.rules.review.createBtn": {
    "defaultMessage": "Criar regra"
  },
  "audit.aod.rules.rule": {
    "defaultMessage": "Regra"
  },
  "audit.aod.rules.title": {
    "defaultMessage": "Regras"
  },
  "audit.aod.rules.trigger": {
    "defaultMessage": "Trigger"
  },
  "audit.aod.rules.trigger.EOW": {
    "defaultMessage": "Fechamento semanal"
  },
  "audit.aod.rules.trigger.EOW_AND_ORDER_END": {
    "defaultMessage": "Fechamento semanal + fim da ordem"
  },
  "audit.aod.rules.trigger.EOW_AND_ORDER_END_SHORT": {
    "defaultMessage": "Fechamento + fim"
  },
  "audit.aod.rules.trigger.MANUAL": {
    "defaultMessage": "Manual"
  },
  "audit.aod.rules.trigger.ORDER_END": {
    "defaultMessage": "Fim da ordem"
  },
  "audit.aod.rules.view.runs.navigation.activeAndPast": {
    "defaultMessage": "Execuções ativas/passadas"
  },
  "audit.aod.rules.view.runs.navigation.future": {
    "defaultMessage": "Execuções Programadas"
  },
  "audit.aod.rules.view.runs.noFutureRuns": {
    "defaultMessage": "Não há execuções programadas para esta regra."
  },
  "audit.aod.rules.view.runs.triggerManual": {
    "defaultMessage": "Executar manualmente"
  },
  "audit.aod.rules.view.tabs.exportConditions": {
    "defaultMessage": "Condições de Export"
  },
  "audit.aod.rules.view.tabs.exportOptions": {
    "defaultMessage": "Opções de Export"
  },
  "audit.aod.rules.view.tabs.info": {
    "defaultMessage": "Informações"
  },
  "audit.aod.rules.view.tabs.reportConfig": {
    "defaultMessage": "Configuração de Relatório"
  },
  "audit.aod.rules.view.tabs.runs": {
    "defaultMessage": "Execuções"
  },
  "audit.aod.rules.wizard.basicInfo": {
    "defaultMessage": "Informações básicas"
  },
  "audit.aod.rules.wizard.exportConditions": {
    "defaultMessage": "Condições de export"
  },
  "audit.aod.rules.wizard.exportOptions": {
    "defaultMessage": "Export de evidências"
  },
  "audit.aod.rules.wizard.reportConfig": {
    "defaultMessage": "Configuração do relatório"
  },
  "audit.aod.rules.wizard.review": {
    "defaultMessage": "Revisão"
  },
  "audit.aod.runs.actions.triggerRunCopy": {
    "defaultMessage": "Executar cópia agora"
  },
  "audit.aod.runs.actions.triggerRunCopySuccess": {
    "defaultMessage": "Execução iniciada"
  },
  "audit.aod.runs.actions.viewRule": {
    "defaultMessage": "Ir para regra"
  },
  "audit.aod.runs.completionReason.LOW_EFFICIENCY": {
    "defaultMessage": "Baixa eficiência"
  },
  "audit.aod.runs.completionReason.MISSING_MATERIALS": {
    "defaultMessage": "Materiais faltantes"
  },
  "audit.aod.runs.datetime": {
    "defaultMessage": "Executada"
  },
  "audit.aod.runs.field.actions": {
    "defaultMessage": "Ações"
  },
  "audit.aod.runs.field.completionComment": {
    "defaultMessage": "Comentário"
  },
  "audit.aod.runs.field.completionReason": {
    "defaultMessage": "Motivo"
  },
  "audit.aod.runs.field.deficiencyNotificationsSent": {
    "defaultMessage": "Notificações de deficiência enviadas"
  },
  "audit.aod.runs.field.deficiencyNotificationsUsers": {
    "defaultMessage": "Usuários notificados"
  },
  "audit.aod.runs.field.description": {
    "defaultMessage": "Descrição"
  },
  "audit.aod.runs.field.efficiency": {
    "defaultMessage": "Eficiência"
  },
  "audit.aod.runs.field.interval": {
    "defaultMessage": "Intervalo"
  },
  "audit.aod.runs.field.minEfficiency": {
    "defaultMessage": "Eficiência mínima requerida"
  },
  "audit.aod.runs.field.order": {
    "defaultMessage": "Ordem"
  },
  "audit.aod.runs.field.ruleName": {
    "defaultMessage": "Regra"
  },
  "audit.aod.runs.field.runAt": {
    "defaultMessage": "Executada em"
  },
  "audit.aod.runs.field.status": {
    "defaultMessage": "Status"
  },
  "audit.aod.runs.field.type": {
    "defaultMessage": "Tipo"
  },
  "audit.aod.runs.interval": {
    "defaultMessage": "Intervalo"
  },
  "audit.aod.runs.name": {
    "defaultMessage": "Nome"
  },
  "audit.aod.runs.order": {
    "defaultMessage": "Ordem"
  },
  "audit.aod.runs.reportType": {
    "defaultMessage": "Tipo de relatório"
  },
  "audit.aod.runs.rule": {
    "defaultMessage": "Regra"
  },
  "audit.aod.runs.ruleName": {
    "defaultMessage": "Regra"
  },
  "audit.aod.runs.scheduledAt": {
    "defaultMessage": "Programada"
  },
  "audit.aod.runs.status": {
    "defaultMessage": "Status"
  },
  "audit.aod.runs.status.completed_with_export": {
    "defaultMessage": "Executada com export"
  },
  "audit.aod.runs.status.completed_without_export": {
    "defaultMessage": "Executada sem export"
  },
  "audit.aod.runs.status.failed": {
    "defaultMessage": "Falhou"
  },
  "audit.aod.runs.status.in_progress": {
    "defaultMessage": "Em progresso"
  },
  "audit.aod.runs.status.pending": {
    "defaultMessage": "Pendente"
  },
  "audit.aod.runs.status.waiting_for_reprocess": {
    "defaultMessage": "Aguardando reprocessamento"
  },
  "audit.aod.runs.title": {
    "defaultMessage": "Execuções"
  },
  "audit.aod.runs.type": {
    "defaultMessage": "Trigger"
  },
  "audit.aod.runs.userAccepted.intro": {
    "defaultMessage": "Execução aceita manualmente pelo usuário"
  },
  "audit.aod.runs.userAccepted.reason": {
    "defaultMessage": "Motivo:"
  },
  "audit.aod.runs.userReprocess.intro": {
    "defaultMessage": "Reprocessamento manual solicitado pelo usuário"
  },
  "audit.aod.runs.userReprocess.onDate": {
    "defaultMessage": "em"
  },
  "audit.aod.runs.userReprocess.unknownUser": {
    "defaultMessage": "usuário desconhecido"
  },
  "audit.aod.tabs.rules": {
    "defaultMessage": "Regras AOD"
  },
  "audit.aod.tabs.runsPast": {
    "defaultMessage": "Execuções Passadas"
  },
  "audit.aod.tabs.runsScheduled": {
    "defaultMessage": "Execuções Agendadas"
  },
  "audit.aod.titleLong": {
    "defaultMessage": "Automatic Order Delivery"
  },
  "audit.audiosScreen.customData.name": {
    "defaultMessage": "Nome"
  },
  "audit.audiosScreen.customData.value": {
    "defaultMessage": "Valor"
  },
  "audit.audiosScreen.customDataTitle": {
    "defaultMessage": "Dados personalizados de {customId}"
  },
  "audit.audiosScreen.group": {
    "defaultMessage": "Grupo"
  },
  "audit.audiosScreen.mediaTitle": {
    "defaultMessage": "Media"
  },
  "audit.audiosScreen.props.audioId": {
    "defaultMessage": "ID do áudio"
  },
  "audit.audiosScreen.props.date": {
    "defaultMessage": "Carregado em"
  },
  "audit.audiosScreen.props.duration": {
    "defaultMessage": "Duração"
  },
  "audit.audiosScreen.props.filename": {
    "defaultMessage": "Nome do arquivo"
  },
  "audit.audiosScreen.showCustomData": {
    "defaultMessage": "Mostrar dados personalizados"
  },
  "audit.audiosScreen.showTranscription": {
    "defaultMessage": "Mostrar transcrição"
  },
  "audit.audiosScreen.tabTitle": {
    "defaultMessage": "Media"
  },
  "audit.audiosScreen.title": {
    "defaultMessage": "Áudios carregados"
  },
  "audit.audiosScreen.transcriptionTitle": {
    "defaultMessage": "Transcrição de {customId}"
  },
  "audit.auditConfig.materials": {
    "defaultMessage": "Materiais"
  },
  "audit.bcr.label": {
    "defaultMessage": "BCR"
  },
  "audit.bcr.verifiedWithBcr": {
    "defaultMessage": "Verificado com BCR"
  },
  "audit.bcrMatchesReport.emptyState.help": {
    "defaultMessage": "Compara os logs BCR importados com os matches do sistema para o dia selecionado. Permite verificar quais emissões do log externo foram confirmadas e quais não."
  },
  "audit.branding.headerBackgroundColor": {
    "defaultMessage": "Cor de fundo do cabeçalho"
  },
  "audit.broadcastEvidence.downloadPackage": {
    "defaultMessage": "Baixar evidência (ZIP)"
  },
  "audit.broadcastEvidence.downloadPending": {
    "defaultMessage": "Pacote de evidência não disponível"
  },
  "audit.broadcastEvidence.evidenceTitle": {
    "defaultMessage": "Evidências"
  },
  "audit.broadcastEvidence.jobStatus": {
    "defaultMessage": "Status"
  },
  "audit.broadcastEvidence.localDate": {
    "defaultMessage": "Data"
  },
  "audit.broadcastEvidence.orderId": {
    "defaultMessage": "Ordem"
  },
  "audit.broadcastEvidence.packageTitle": {
    "defaultMessage": "Export de evidência"
  },
  "audit.broadcastEvidence.scheduledMaterial": {
    "defaultMessage": "Material pautado"
  },
  "audit.broadcastEvidence.station": {
    "defaultMessage": "Emissora"
  },
  "audit.broadcastEvidence.summary.alternativeConfirmed": {
    "defaultMessage": "Confirmados"
  },
  "audit.broadcastEvidence.summary.olafMatched": {
    "defaultMessage": "OLAF"
  },
  "audit.broadcastEvidence.summary.outsideTolerance": {
    "defaultMessage": "Fora da tolerância"
  },
  "audit.broadcastEvidence.summary.scheduled": {
    "defaultMessage": "Pautados"
  },
  "audit.broadcastEvidence.summary.withinTolerance": {
    "defaultMessage": "Na tolerância"
  },
  "audit.broadcastEvidence.table.broadcastDatetime": {
    "defaultMessage": "Emissão"
  },
  "audit.broadcastEvidence.table.broadcastMaterialId": {
    "defaultMessage": "Material emitido"
  },
  "audit.broadcastEvidence.table.methods": {
    "defaultMessage": "Métodos"
  },
  "audit.broadcastEvidence.table.observation": {
    "defaultMessage": "Observação"
  },
  "audit.broadcastEvidence.table.scheduledMaterialId": {
    "defaultMessage": "Material pautado"
  },
  "audit.broadcastEvidence.table.status": {
    "defaultMessage": "Estado"
  },
  "audit.broadcastEvidence.table.withinTolerance": {
    "defaultMessage": "Tolerância"
  },
  "audit.broadcastEvidence.withinTolerance.no": {
    "defaultMessage": "Não"
  },
  "audit.broadcastEvidence.withinTolerance.yes": {
    "defaultMessage": "Sim"
  },
  "audit.column.moveToEnd": {
    "defaultMessage": "Mover para o fim"
  },
  "audit.column.moveToStart": {
    "defaultMessage": "Mover para o início"
  },
  "audit.configScreen.excludedCustomIds.hint": {
    "defaultMessage": "Lista de IDs personalizados separados por vírgula que serão excluídos dos relatórios de auditoria"
  },
  "audit.configScreen.excludedCustomIds.label": {
    "defaultMessage": "Excluir IDs personalizados"
  },
  "audit.configScreen.successMessage": {
    "defaultMessage": "Configuração de auditoria atualizada"
  },
  "audit.configScreen.title": {
    "defaultMessage": "Configuração de auditoria"
  },
  "audit.confirmedBySchedule.filterByOrder": {
    "defaultMessage": "Ver schedules da ordem {order}"
  },
  "audit.confirmedBySchedule.scheduleDatetime": {
    "defaultMessage": "Programação"
  },
  "audit.consecutiveSchedules.datetimeNext": {
    "defaultMessage": "Data e hora seguinte"
  },
  "audit.consecutiveSchedules.title": {
    "defaultMessage": "Schedules consecutivos"
  },
  "audit.controls.markers": {
    "defaultMessage": "Anotações"
  },
  "audit.diarization.processing": {
    "defaultMessage": "Processando transcrição"
  },
  "audit.equalMd5Report.customIds": {
    "defaultMessage": "IDs personalizados duplicados"
  },
  "audit.equalMd5Report.emptyState.help": {
    "defaultMessage": "Lista os arquivos de mídia que compartilham o mesmo hash MD5 (ou seja, o mesmo conteúdo de arquivo), mas estão registrados com IDs de material diferentes. Útil para detectar e limpar mídia duplicada."
  },
  "audit.equalMd5Report.md5": {
    "defaultMessage": "Hash do arquivo"
  },
  "audit.filesUpload.audioIdLabel": {
    "defaultMessage": "ID de áudio:"
  },
  "audit.filesUpload.entriesFoundToLoad": {
    "defaultMessage": "Foram encontradas {n} entradas {type} para carregar. Confirme a carga ou cancele para voltar."
  },
  "audit.filesUpload.fileLabel": {
    "defaultMessage": "Arquivo:"
  },
  "audit.filesUpload.filesLabel": {
    "defaultMessage": "Arquivos:"
  },
  "audit.filesUpload.links.adAudios": {
    "defaultMessage": "Mídia Spot"
  },
  "audit.filesUpload.links.adSchedulesAsc": {
    "defaultMessage": "Grade Spot (ASC)"
  },
  "audit.filesUpload.links.adSchedulesPlk": {
    "defaultMessage": "Grade Spot (PLK)"
  },
  "audit.filesUpload.links.avgUpload": {
    "defaultMessage": "Carregar AVG"
  },
  "audit.filesUpload.links.bcrUpload": {
    "defaultMessage": "Carregar BCR"
  },
  "audit.filesUpload.links.liveMentionSchedulesCsv": {
    "defaultMessage": "Grade de menções (CSV)"
  },
  "audit.filesUpload.links.ltxUpload": {
    "defaultMessage": "Carregar LTX"
  },
  "audit.filesUpload.materialId": {
    "defaultMessage": "ID do material"
  },
  "audit.filesUpload.selectFileLabel": {
    "defaultMessage": "Selecionar ficheiro(s) .{type}"
  },
  "audit.filesUpload.selectFileType": {
    "defaultMessage": "Selecione um tipo de arquivo no menu lateral"
  },
  "audit.filesUpload.uploadError": {
    "defaultMessage": "Ocurrió un error al subir el archivo:"
  },
  "audit.filesUpload.uploadFile": {
    "defaultMessage": "Confirmar carregamento"
  },
  "audit.filesUpload.uploadFiles": {
    "defaultMessage": "Confirmar carregamento"
  },
  "audit.filesUpload.uploading": {
    "defaultMessage": "A carregar..."
  },
  "audit.filesUpload.uploadSuccess": {
    "defaultMessage": "Arquivo enviado com sucesso"
  },
  "audit.filesUpload.uploadSuccessMultiple": {
    "defaultMessage": "Ficheiros enviados com sucesso"
  },
  "audit.filesUpload.validateError": {
    "defaultMessage": "Ocorreu um erro ao validar o ficheiro:"
  },
  "audit.gip.exportConditions.enableEfficiency": {
    "defaultMessage": "Verificar eficiência mínima"
  },
  "audit.gip.exportConditions.minEfficiency": {
    "defaultMessage": "Eficiência mínima"
  },
  "audit.gip.report.efficiency": {
    "defaultMessage": "Eficiência"
  },
  "audit.gip.report.efficiencyHelp": {
    "defaultMessage": "Percentual de agendamentos processados que têm uma correspondência confirmada."
  },
  "audit.gip.report.missingMaterials": {
    "defaultMessage": "Materiais faltantes"
  },
  "audit.gip.report.missingMaterialsHelp": {
    "defaultMessage": "Quantidade de materiais referenciados por agendamentos que ainda não foram carregados."
  },
  "audit.gip.report.results": {
    "defaultMessage": "Resultados"
  },
  "audit.gip.report.scheduleProgress": {
    "defaultMessage": "Progresso dos agendamentos"
  },
  "audit.gip.report.scheduleProgressHelp": {
    "defaultMessage": "Percentual de agendamentos já processados sobre o total. Pendentes e futuros ainda não contam como processados."
  },
  "audit.gip.report.summary": {
    "defaultMessage": "Resumo"
  },
  "audit.gip.report.totalSchedules": {
    "defaultMessage": "Total de agendamentos"
  },
  "audit.gip.report.withMatch": {
    "defaultMessage": "Com correspondência"
  },
  "audit.gip.report.withoutMatch": {
    "defaultMessage": "Sem correspondência"
  },
  "audit.gipReport.columnMaterial": {
    "defaultMessage": "Material"
  },
  "audit.gipReport.columnStation": {
    "defaultMessage": "Emissora"
  },
  "audit.gipReport.configTitle": {
    "defaultMessage": "Configuração do relatório"
  },
  "audit.gipReport.createModal.createdNotification": {
    "defaultMessage": "Relatório salvo"
  },
  "audit.gipReport.createModal.createdNotificationLink": {
    "defaultMessage": "Ir para relatórios criados"
  },
  "audit.gipReport.createModal.nameLabel": {
    "defaultMessage": "Título do relatório:"
  },
  "audit.gipReport.createModal.namePlaceholder": {
    "defaultMessage": "Insira o nome do relatório aqui"
  },
  "audit.gipReport.createModal.title": {
    "defaultMessage": "Criar relatório GIP"
  },
  "audit.gipReport.error.dateRangeExceeded": {
    "defaultMessage": "O intervalo de datas não pode exceder {maxDays} dias."
  },
  "audit.gipReport.error.fromMustBeBeforeTo": {
    "defaultMessage": "A data de início deve ser anterior à data de fim."
  },
  "audit.gipReport.excludedMatchesCount": {
    "defaultMessage": "{count, plural, one {match excluído} other {matches excluídos}}"
  },
  "audit.gipReport.excludedMatchesLabel": {
    "defaultMessage": "Matches excluídos do export"
  },
  "audit.gipReport.export.advancedLink": {
    "defaultMessage": "Avançado"
  },
  "audit.gipReport.export.audioMatchIncludeAfterLabel": {
    "defaultMessage": "Segundos a incluir após o match"
  },
  "audit.gipReport.export.audioMatchIncludeBeforeLabel": {
    "defaultMessage": "Segundos a incluir antes do match"
  },
  "audit.gipReport.export.audioMatchIncludeHelper": {
    "defaultMessage": "Entre 0 e 300 segundos"
  },
  "audit.gipReport.export.customTextInPath": {
    "defaultMessage": "Texto personalizado no caminho"
  },
  "audit.gipReport.export.definition": {
    "defaultMessage": "Modelo"
  },
  "audit.gipReport.export.excludeVersion": {
    "defaultMessage": "Excluir versão"
  },
  "audit.gipReport.export.filesConfig": {
    "defaultMessage": "Configuração de arquivos"
  },
  "audit.gipReport.export.noTemplatesAvailable": {
    "defaultMessage": "Nenhum modelo disponível"
  },
  "audit.gipReport.export.pathFormat": {
    "defaultMessage": "Formato do caminho"
  },
  "audit.gipReport.export.publicLink": {
    "defaultMessage": "Incluir link público"
  },
  "audit.gipReport.export.retryBtn": {
    "defaultMessage": "Exportar novamente"
  },
  "audit.gipReport.export.startBtn": {
    "defaultMessage": "Iniciar"
  },
  "audit.gipReport.export.startNotification": {
    "defaultMessage": "Export iniciado"
  },
  "audit.gipReport.export.startNotificationError": {
    "defaultMessage": "Não foi possível iniciar o export"
  },
  "audit.gipReport.export.title": {
    "defaultMessage": "Exportar relatório"
  },
  "audit.gipReport.export.xlsConfig": {
    "defaultMessage": "Configuração XLS"
  },
  "audit.gipReport.exportModal.createdNotificationError": {
    "defaultMessage": "Erro ao criar relatório"
  },
  "audit.gipReport.form.advertisers": {
    "defaultMessage": "Anunciantes"
  },
  "audit.gipReport.form.allAdvertisers": {
    "defaultMessage": "Todos os anunciantes"
  },
  "audit.gipReport.form.allCampaigns": {
    "defaultMessage": "Todas as campanhas"
  },
  "audit.gipReport.form.allOrders": {
    "defaultMessage": "Todas as ordens"
  },
  "audit.gipReport.form.allStationsDefault": {
    "defaultMessage": "Todas as rádios"
  },
  "audit.gipReport.form.allVersions": {
    "defaultMessage": "Todas as versões"
  },
  "audit.gipReport.form.campaigns": {
    "defaultMessage": "Campanhas"
  },
  "audit.gipReport.form.customField": {
    "defaultMessage": "Custom field"
  },
  "audit.gipReport.form.customFieldValue": {
    "defaultMessage": "Custom field"
  },
  "audit.gipReport.form.customIds": {
    "defaultMessage": "Custom ID"
  },
  "audit.gipReport.form.endDate": {
    "defaultMessage": "Data final"
  },
  "audit.gipReport.form.endTime": {
    "defaultMessage": "Hora final"
  },
  "audit.gipReport.form.loadOrderParams": {
    "defaultMessage": "Carregar parâmetros do pedido"
  },
  "audit.gipReport.form.loadOrderParamsMultiple": {
    "defaultMessage": "Carregar parâmetros dos pedidos"
  },
  "audit.gipReport.form.orders": {
    "defaultMessage": "Ordens"
  },
  "audit.gipReport.form.selectCustom": {
    "defaultMessage": "Selecione campo personalizado"
  },
  "audit.gipReport.form.startDate": {
    "defaultMessage": "Data inicial"
  },
  "audit.gipReport.form.startTime": {
    "defaultMessage": "Hora inicial"
  },
  "audit.gipReport.form.stations": {
    "defaultMessage": "Stations"
  },
  "audit.gipReport.form.typeToSearch": {
    "defaultMessage": "Digite pelo menos 2 caracteres iniciais"
  },
  "audit.gipReport.form.versions": {
    "defaultMessage": "Versões"
  },
  "audit.gipReport.includeAllMatches": {
    "defaultMessage": "Incluir todos os matches encontrados no export"
  },
  "audit.gipReport.info.createBtn": {
    "defaultMessage": "Save report"
  },
  "audit.gipReport.info.end": {
    "defaultMessage": "End date/time"
  },
  "audit.gipReport.info.start": {
    "defaultMessage": "Start date/time"
  },
  "audit.gipReport.noCustomFieldFilter": {
    "defaultMessage": "Nenhum filtro de campo personalizado"
  },
  "audit.gipReport.result.advertiser": {
    "defaultMessage": "Anunciante"
  },
  "audit.gipReport.result.campaign": {
    "defaultMessage": "Campanha"
  },
  "audit.gipReport.result.contract": {
    "defaultMessage": "Contrato"
  },
  "audit.gipReport.result.date": {
    "defaultMessage": "Data"
  },
  "audit.gipReport.result.dateTime": {
    "defaultMessage": "Data e hora"
  },
  "audit.gipReport.result.duration": {
    "defaultMessage": "Duração"
  },
  "audit.gipReport.result.matchDateTime": {
    "defaultMessage": "Data e hora da match"
  },
  "audit.gipReport.result.material.missing": {
    "defaultMessage": "Material {customId} faltando"
  },
  "audit.gipReport.result.order": {
    "defaultMessage": "N. Ordem"
  },
  "audit.gipReport.result.schedule": {
    "defaultMessage": "Agendamento"
  },
  "audit.gipReport.result.showOffTolerance": {
    "defaultMessage": "Mostrar resultados fora de tolerância"
  },
  "audit.gipReport.result.station": {
    "defaultMessage": "Emissora"
  },
  "audit.gipReport.result.tabs.future": {
    "defaultMessage": "Futuros"
  },
  "audit.gipReport.result.tabs.long.future": {
    "defaultMessage": "Schedules futuros"
  },
  "audit.gipReport.result.tabs.long.missingMaterials": {
    "defaultMessage": "Schedules com materiais faltando"
  },
  "audit.gipReport.result.tabs.long.toBeProcessed": {
    "defaultMessage": "Schedules a processar"
  },
  "audit.gipReport.result.tabs.long.withMatches": {
    "defaultMessage": "Schedules com matches"
  },
  "audit.gipReport.result.tabs.long.withoutMatches": {
    "defaultMessage": "Schedules sem matches"
  },
  "audit.gipReport.result.tabs.missingMaterials": {
    "defaultMessage": "Materiais faltando"
  },
  "audit.gipReport.result.tabs.toBeProcessed": {
    "defaultMessage": "A processar"
  },
  "audit.gipReport.result.tabs.withMatches": {
    "defaultMessage": "Com matches"
  },
  "audit.gipReport.result.tabs.withoutMatches": {
    "defaultMessage": "Sem matches"
  },
  "audit.gipReport.result.type": {
    "defaultMessage": "Tipo"
  },
  "audit.gipReport.result.version": {
    "defaultMessage": "Versão"
  },
  "audit.gipReport.resultOptions": {
    "defaultMessage": "Opções de resultados"
  },
  "audit.gipReport.title": {
    "defaultMessage": "Relatório GIP"
  },
  "audit.globalMissingAudios.groupByHelp.groupByCustomId": {
    "defaultMessage": "Agrupar por <b>ID personalizado</b>: os agendamentos são agrupados por ID personalizado, devolvendo um agendamento por áudio faltante em qualquer uma das rádios selecionadas."
  },
  "audit.globalMissingAudios.groupByHelp.groupByCustomIdAndRadio": {
    "defaultMessage": "Agrupar por <b>ID personalizado e rádio</b>: devolve um agendamento por cada emissora e cada ID personalizado."
  },
  "audit.globalMissingAudios.groupByHelp.intro": {
    "defaultMessage": "Esta opção permite agrupar os agendamentos sem áudios encontrados:"
  },
  "audit.globalMissingAudios.groupByHelp.noGroup": {
    "defaultMessage": "<b>Não agrupar</b>: devolve todos os agendamentos encontrados. Pode haver vários agendamentos com o mesmo ID personalizado."
  },
  "audit.globalReports.title": {
    "defaultMessage": "Relatórios globais"
  },
  "audit.liveMention.badge": {
    "defaultMessage": "Menção ao vivo"
  },
  "audit.liveMentions.acceptMention": {
    "defaultMessage": "Accept mention"
  },
  "audit.liveMentions.created": {
    "defaultMessage": "Menção manual criada"
  },
  "audit.liveMentions.createError": {
    "defaultMessage": "Menção não criada, tente novamente"
  },
  "audit.liveMentions.mentionMatch": {
    "defaultMessage": "Mention Match"
  },
  "audit.liveMentions.processingMessage": {
    "defaultMessage": "Live mentions are being processed. Results will be available shortly."
  },
  "audit.liveMentions.rejectConfirm": {
    "defaultMessage": "Confirma rejeitar menção? Neste caso, será excluída e reprocessada em busca de melhores resultados."
  },
  "audit.liveMentions.rejected": {
    "defaultMessage": "Menção rejeitada"
  },
  "audit.liveMentions.rejectMention": {
    "defaultMessage": "Reject mention"
  },
  "audit.liveMentions.selectFromSchedules": {
    "defaultMessage": "Selecionar uma menção dos agendamentos"
  },
  "audit.liveMentions.status.ACCEPTED": {
    "defaultMessage": "Aceita"
  },
  "audit.liveMentions.status.AUTO": {
    "defaultMessage": "Auto"
  },
  "audit.liveMentions.status.MANUAL": {
    "defaultMessage": "Manual"
  },
  "audit.liveMentions.status.REJECTED": {
    "defaultMessage": "Rejeitada"
  },
  "audit.liveMentionsAdd.createCustomMention": {
    "defaultMessage": "Criar uma menção personalizada"
  },
  "audit.liveMentionsAdd.mentionFromSchedules": {
    "defaultMessage": "Menção desde agendamentos"
  },
  "audit.liveMentionsAdd.title": {
    "defaultMessage": "Criar menção manual"
  },
  "audit.liveMentionsScreen.noResults": {
    "defaultMessage": "No results found"
  },
  "audit.lowerthird.duration": {
    "defaultMessage": "Duração"
  },
  "audit.lowerthird.title": {
    "defaultMessage": "Lowerthird"
  },
  "audit.lowerthirdScreen.loading": {
    "defaultMessage": "Carregando lower thirds"
  },
  "audit.lowerthirdScreen.noResults": {
    "defaultMessage": "Nenhum lower third encontrado"
  },
  "audit.ltxMatchesReport.emptyState.help": {
    "defaultMessage": "Compara os logs LTX importados com os matches do sistema para o dia selecionado. Permite verificar quais emissões do log externo foram confirmadas e quais não."
  },
  "audit.matchCategory.adOverlays": {
    "defaultMessage": "Overlays de anúncios"
  },
  "audit.matchCategory.customAds": {
    "defaultMessage": "Anúncios personalizados"
  },
  "audit.matchCategory.mentions": {
    "defaultMessage": "Menções"
  },
  "audit.matches.spotMatch": {
    "defaultMessage": "Spot Match"
  },
  "audit.matchesAdd.created": {
    "defaultMessage": "Match manual criado"
  },
  "audit.matchesAdd.createError": {
    "defaultMessage": "Match não criado, tente novamente"
  },
  "audit.matchesAdd.playedDuration": {
    "defaultMessage": "Duração do match (em ms)"
  },
  "audit.matchesAdd.title": {
    "defaultMessage": "Criar match manual"
  },
  "audit.matchesAdd.useAudioDuration": {
    "defaultMessage": "Usar a duração total do áudio"
  },
  "audit.matchesScreen.downloadBtn": {
    "defaultMessage": "Baixar media"
  },
  "audit.matchesScreen.showOnStreamBtn": {
    "defaultMessage": "Mostrar no stream"
  },
  "audit.matchesScreen.title": {
    "defaultMessage": "Matches"
  },
  "audit.mediaPlayer.viewMedia": {
    "defaultMessage": "Reproduzir mídia"
  },
  "audit.missingAudios.emptyState.help": {
    "defaultMessage": "Lista os IDs de material para aqueles schedules no intervalo selecionado cuja mídia de referência não foi carregada para a emissora vinculada. Serve para encontrar schedules sem mídia para detectar."
  },
  "audit.missingAudios.groupBy.custom_id": {
    "defaultMessage": "Custom ID"
  },
  "audit.missingAudios.groupBy.custom_id_station_id": {
    "defaultMessage": "Custom ID e emissora"
  },
  "audit.missingAudios.groupBy.none": {
    "defaultMessage": "Não agrupar"
  },
  "audit.missingAudios.scheduleDatetime": {
    "defaultMessage": "Data e hora do schedule"
  },
  "audit.missingAudios.title": {
    "defaultMessage": "Áudios faltantes"
  },
  "audit.missingAudios.viewScheduleBtn": {
    "defaultMessage": "Ver detalhes do agendamento"
  },
  "audit.noMatchesReport.emptyState.help": {
    "defaultMessage": "Mostra os arquivos de mídia carregados no intervalo selecionado para os quais não foi detectado nenhum match nesse intervalo ou no outro intervalo ajustado."
  },
  "audit.notEnabled.htmlTitle": {
    "defaultMessage": "{stationName} - Audit não ativado"
  },
  "audit.notEnabledForStation.body": {
    "defaultMessage": "Entre em contato para ativar o Audit para {stationName}."
  },
  "audit.notEnabledForStation.title": {
    "defaultMessage": "Este recurso não está ativado para esta emissora"
  },
  "audit.preview.generating": {
    "defaultMessage": "A gerar..."
  },
  "audit.preview.preview": {
    "defaultMessage": "Pré-visualizar"
  },
  "audit.preview.previewCsv": {
    "defaultMessage": "Pré-visualização CSV"
  },
  "audit.preview.previewXls": {
    "defaultMessage": "Pré-visualização XLS"
  },
  "audit.props.advertiser": {
    "defaultMessage": "Anunciante"
  },
  "audit.props.audioDuration": {
    "defaultMessage": "Duração do arquivo"
  },
  "audit.props.campaign": {
    "defaultMessage": "Campanha"
  },
  "audit.props.creationRange": {
    "defaultMessage": "Período de criação do áudio"
  },
  "audit.props.customId": {
    "defaultMessage": "ID personalizado"
  },
  "audit.props.datetime": {
    "defaultMessage": "Data e hora alvo"
  },
  "audit.props.duration": {
    "defaultMessage": "Duração reproduzida"
  },
  "audit.props.manualMatch": {
    "defaultMessage": "Match manual"
  },
  "audit.props.matches": {
    "defaultMessage": "Matches"
  },
  "audit.props.mentionId": {
    "defaultMessage": "ID da menção"
  },
  "audit.props.order": {
    "defaultMessage": "N. Ordem"
  },
  "audit.props.score": {
    "defaultMessage": "Pontuação"
  },
  "audit.props.time": {
    "defaultMessage": "Hora"
  },
  "audit.props.tolerance": {
    "defaultMessage": "Tolerância"
  },
  "audit.props.tolerance.help": {
    "defaultMessage": "Os valores são em minutos. Formato: minutos antes / minutos depois da data e hora programada."
  },
  "audit.props.type": {
    "defaultMessage": "Tipo"
  },
  "audit.props.version": {
    "defaultMessage": "Versão"
  },
  "audit.report.created": {
    "defaultMessage": "Criado"
  },
  "audit.report.name": {
    "defaultMessage": "Nome"
  },
  "audit.reportDefinitionEditor.columnLabel": {
    "defaultMessage": "Título"
  },
  "audit.reportDefinitionEditor.columnType.boolean": {
    "defaultMessage": "Booleano"
  },
  "audit.reportDefinitionEditor.columnType.boolean.falseLabel": {
    "defaultMessage": "Rótulo para falso"
  },
  "audit.reportDefinitionEditor.columnType.boolean.trueLabel": {
    "defaultMessage": "Rótulo para verdadeiro"
  },
  "audit.reportDefinitionEditor.columnType.date": {
    "defaultMessage": "Data"
  },
  "audit.reportDefinitionEditor.columnType.date.format": {
    "defaultMessage": "Formato de data"
  },
  "audit.reportDefinitionEditor.columnType.datetime": {
    "defaultMessage": "Data e hora"
  },
  "audit.reportDefinitionEditor.columnType.datetime.format": {
    "defaultMessage": "Formato de data e hora"
  },
  "audit.reportDefinitionEditor.columnType.number": {
    "defaultMessage": "Número"
  },
  "audit.reportDefinitionEditor.columnType.string": {
    "defaultMessage": "Texto"
  },
  "audit.reportDefinitionEditor.columnType.string.case": {
    "defaultMessage": "Formato do texto"
  },
  "audit.reportDefinitionEditor.columnType.string.case.lowercase": {
    "defaultMessage": "Minúsculas"
  },
  "audit.reportDefinitionEditor.columnType.string.case.none": {
    "defaultMessage": "Sem formato"
  },
  "audit.reportDefinitionEditor.columnType.string.case.title": {
    "defaultMessage": "Título"
  },
  "audit.reportDefinitionEditor.columnType.string.case.uppercase": {
    "defaultMessage": "Maiúsculas"
  },
  "audit.reportDefinitionEditor.columnType.time": {
    "defaultMessage": "Hora"
  },
  "audit.reportDefinitionEditor.columnType.time.format": {
    "defaultMessage": "Formato de hora"
  },
  "audit.reportDefinitionEditor.columnType.unknown": {
    "defaultMessage": "Desconhecido"
  },
  "audit.reportDefinitionEditor.columnType.url": {
    "defaultMessage": "URL"
  },
  "audit.reportDefinitionEditor.metadata.default": {
    "defaultMessage": "Modelo padrão"
  },
  "audit.reportDefinitionEditor.metadata.name": {
    "defaultMessage": "Nome"
  },
  "audit.reportDefinitionEditor.metadata.name.helper": {
    "defaultMessage": "Nome para identificar este modelo"
  },
  "audit.reportDefinitionEditor.metadata.title": {
    "defaultMessage": "Informações"
  },
  "audit.reportDefinitionEditor.title": {
    "defaultMessage": "Modelo de relatório"
  },
  "audit.reportDefinitionList.actions": {
    "defaultMessage": "Ações"
  },
  "audit.reportDefinitionList.createdAt": {
    "defaultMessage": "Criado"
  },
  "audit.reportDefinitionList.defaultTemplate": {
    "defaultMessage": "Modelo padrão"
  },
  "audit.reportDefinitionList.editTooltip": {
    "defaultMessage": "Editar"
  },
  "audit.reportDefinitionList.name": {
    "defaultMessage": "Nome"
  },
  "audit.reportDefinitionList.nameFilterPlaceholder": {
    "defaultMessage": "Buscar por nome"
  },
  "audit.reportDefinitionList.title": {
    "defaultMessage": "Modelos de relatório"
  },
  "audit.reportDefinitions.availableColumns.empty": {
    "defaultMessage": "Nenhuma coluna disponível"
  },
  "audit.reportDefinitions.cannotDeleteDefault": {
    "defaultMessage": "O modelo padrão não pode ser excluído"
  },
  "audit.reportDefinitions.cloneButton": {
    "defaultMessage": "Clonar"
  },
  "audit.reportDefinitions.cloneError": {
    "defaultMessage": "Erro ao clonar o modelo"
  },
  "audit.reportDefinitions.cloneSuccess": {
    "defaultMessage": "Modelo clonado com sucesso"
  },
  "audit.reportDefinitions.createError": {
    "defaultMessage": "Erro ao criar o modelo"
  },
  "audit.reportDefinitions.deleteError": {
    "defaultMessage": "Erro ao excluir o modelo"
  },
  "audit.reportDefinitions.deleteSuccess": {
    "defaultMessage": "Modelo excluído com sucesso"
  },
  "audit.reportDefinitions.deleteTemplateConfirm": {
    "defaultMessage": "Tem certeza de que deseja excluir o modelo \"{name}\"? Esta ação não pode ser desfeita."
  },
  "audit.reportDefinitions.deleteTemplateTitle": {
    "defaultMessage": "Excluir modelo"
  },
  "audit.reportDefinitions.loadCustomLogo": {
    "defaultMessage": "Carregar logo personalizado"
  },
  "audit.reportDefinitions.newTemplateButton": {
    "defaultMessage": "Novo modelo"
  },
  "audit.reportDefinitions.previewError": {
    "defaultMessage": "Erro ao gerar a visualização"
  },
  "audit.reportDefinitions.reportTemplateTitle": {
    "defaultMessage": "Modelo de relatório"
  },
  "audit.reportDefinitions.reportTypeRequired": {
    "defaultMessage": "O tipo de relatório é obrigatório"
  },
  "audit.reportDefinitions.saveError": {
    "defaultMessage": "Erro ao salvar o modelo de relatório"
  },
  "audit.reportDefinitions.saveSuccess": {
    "defaultMessage": "Modelo de relatório salvo com sucesso"
  },
  "audit.reportDefinitions.segmentation.groupBy": {
    "defaultMessage": "Coluna"
  },
  "audit.reportDefinitions.segmentation.grouping": {
    "defaultMessage": "Segmentação"
  },
  "audit.reportDefinitions.segmentation.helperText": {
    "defaultMessage": "Em arquivos XLS será gerada uma planilha para cada valor do campo selecionado. Em arquivos CSV será gerado um arquivo distinto dentro de um .zip"
  },
  "audit.reportDefinitions.segmentation.hideColumn": {
    "defaultMessage": "Ocultar esta coluna no relatório"
  },
  "audit.reportDefinitions.segmentation.noColumns": {
    "defaultMessage": "Você deve selecionar pelo menos uma coluna para poder agrupar."
  },
  "audit.reportDefinitions.segmentation.removedNotification": {
    "defaultMessage": "A segmentação foi desativada porque a coluna associada foi removida."
  },
  "audit.reportDefinitions.segmentation.splitReport": {
    "defaultMessage": "Dividir em seções para uma das colunas"
  },
  "audit.reportDefinitions.segmentation.tour.description": {
    "defaultMessage": "Ative esta opção para dividir o relatório em seções (ex.: uma planilha XLS por valor da coluna escolhida)."
  },
  "audit.reportDefinitions.segmentation.tour.title": {
    "defaultMessage": "Segmentação do relatório"
  },
  "audit.reportDefinitions.selectedColumns.empty": {
    "defaultMessage": "Nenhuma coluna selecionada. Use o botão de seta nas colunas disponíveis para adicioná-las."
  },
  "audit.reportDefinitions.sorting.noRules": {
    "defaultMessage": "Nenhuma regra de ordenação. Clique em \"Adicionar ordem\" para adicionar uma."
  },
  "audit.reportDefinitions.sorting.order": {
    "defaultMessage": "Ordem"
  },
  "audit.reportDefinitions.styleTitle": {
    "defaultMessage": "Estilo"
  },
  "audit.reportDefinitions.templatesForReport": {
    "defaultMessage": "Modelos para o reporte {name}"
  },
  "audit.reportDefinitions.templatesTitle": {
    "defaultMessage": "Modelos"
  },
  "audit.reportDefinitions.useClientLogo": {
    "defaultMessage": "Usar logo do cliente"
  },
  "audit.reportDelete.deleted": {
    "defaultMessage": "Relatório excluído"
  },
  "audit.reportDelete.deleteError": {
    "defaultMessage": "Não foi possível excluir o relatório"
  },
  "audit.reportDelete.prompt": {
    "defaultMessage": "Do you want to delete this report? {br} This action can not be undone."
  },
  "audit.reportDelete.title": {
    "defaultMessage": "Excluir relatório"
  },
  "audit.reportNames.AUDIT_BROADCAST_EVIDENCE": {
    "defaultMessage": "Evidência de emissão"
  },
  "audit.reportNames.AUDIT_GIP_ALTERNATIVE_REPORT": {
    "defaultMessage": "GIP alternativo"
  },
  "audit.reportNames.AUDIT_GIP_STATUS": {
    "defaultMessage": "GIP"
  },
  "audit.reportNames.BCR_MATCHES": {
    "defaultMessage": "BCR Matches"
  },
  "audit.reports.bcrMatches.noBcrEntries": {
    "defaultMessage": "Nenhuma entrada BCR encontrada para o relatório"
  },
  "audit.reports.branding.logo": {
    "defaultMessage": "Logo"
  },
  "audit.reports.ltxMatches.noLtxEntries": {
    "defaultMessage": "Nenhuma entrada LTX encontrada para o relatório"
  },
  "audit.reports.section.availableColumns": {
    "defaultMessage": "Colunas disponíveis"
  },
  "audit.reports.section.reportColumns": {
    "defaultMessage": "Colunas do relatório"
  },
  "audit.reports.sorting.add": {
    "defaultMessage": "Adicionar"
  },
  "audit.reports.viewNotFound": {
    "defaultMessage": "Visualização não encontrada para o relatório {type}"
  },
  "audit.reportsList.createdBy": {
    "defaultMessage": "Criado por"
  },
  "audit.reportsList.exportStatus": {
    "defaultMessage": "Status de export"
  },
  "audit.reportsList.noExport": {
    "defaultMessage": "Não exportado"
  },
  "audit.reportsList.onlyMine": {
    "defaultMessage": "Somente os meus"
  },
  "audit.reportsList.title": {
    "defaultMessage": "Relatórios criados"
  },
  "audit.reportsScreen.bcrMatches.customId": {
    "defaultMessage": "Custom ID (opcional)"
  },
  "audit.reportsScreen.bcrMatches.date": {
    "defaultMessage": "Data"
  },
  "audit.reportsScreen.bcrMatches.noSchedule": {
    "defaultMessage": "Sem schedule"
  },
  "audit.reportsScreen.bcrMatches.tabs.unverifiedBcrEntries": {
    "defaultMessage": "Entradas BCR não verificadas"
  },
  "audit.reportsScreen.bcrMatches.tabs.unverifiedMatches": {
    "defaultMessage": "Matches não verificados"
  },
  "audit.reportsScreen.bcrMatches.tabs.verified": {
    "defaultMessage": "Matches verificados"
  },
  "audit.reportsScreen.bcrMatches.title": {
    "defaultMessage": "BCR Matches"
  },
  "audit.reportsScreen.bcrMatches.unverifiedBcrEntries.name": {
    "defaultMessage": "Nome"
  },
  "audit.reportsScreen.bcrMatches.verified.bcrEntryDatetime": {
    "defaultMessage": "Horário de entrada BCR"
  },
  "audit.reportsScreen.bcrMatches.verified.bcrName": {
    "defaultMessage": "Nome BCR"
  },
  "audit.reportsScreen.bcrMatches.verified.matchedSchedule": {
    "defaultMessage": "Schedule"
  },
  "audit.reportsScreen.equalMd5.title": {
    "defaultMessage": "Áudios com mesmo conteúdo"
  },
  "audit.reportsScreen.ltxMatches.customId": {
    "defaultMessage": "Custom ID (opcional)"
  },
  "audit.reportsScreen.ltxMatches.date": {
    "defaultMessage": "Data"
  },
  "audit.reportsScreen.ltxMatches.noSchedule": {
    "defaultMessage": "Sem schedule"
  },
  "audit.reportsScreen.ltxMatches.tabs.unverifiedLtxEntries": {
    "defaultMessage": "Entradas LTX não verificadas"
  },
  "audit.reportsScreen.ltxMatches.tabs.unverifiedMatches": {
    "defaultMessage": "Matches não verificados"
  },
  "audit.reportsScreen.ltxMatches.tabs.verified": {
    "defaultMessage": "Matches verificados"
  },
  "audit.reportsScreen.ltxMatches.title": {
    "defaultMessage": "LTX Matches"
  },
  "audit.reportsScreen.ltxMatches.unverifiedLtxEntries.name": {
    "defaultMessage": "Nome"
  },
  "audit.reportsScreen.ltxMatches.unverifiedLtxEntries.type": {
    "defaultMessage": "Tipo"
  },
  "audit.reportsScreen.ltxMatches.verified.ltxEntryDatetime": {
    "defaultMessage": "Hora da entrada LTX"
  },
  "audit.reportsScreen.ltxMatches.verified.ltxName": {
    "defaultMessage": "Nome LTX"
  },
  "audit.reportsScreen.ltxMatches.verified.matchedSchedule": {
    "defaultMessage": "Schedule"
  },
  "audit.reportsScreen.missingAudios.datetime": {
    "defaultMessage": "Data e hora programada (primeira entrada)"
  },
  "audit.reportsScreen.missingAudios.title": {
    "defaultMessage": "Áudios faltantes"
  },
  "audit.reportsScreen.missingAudios.viewScheduleBtn": {
    "defaultMessage": "View schedule detail"
  },
  "audit.reportsScreen.noMatches.creationRange": {
    "defaultMessage": "Período de criação do arquivo"
  },
  "audit.reportsScreen.noMatches.matchRange": {
    "defaultMessage": "Período de matches"
  },
  "audit.reportsScreen.noMatches.sameAudioMatch.matchesLink": {
    "defaultMessage": "Ver matches de {audioId}"
  },
  "audit.reportsScreen.noMatches.sameAudioMatch.message": {
    "defaultMessage": "Existe um áudio com conteúdo igual que tem matches:"
  },
  "audit.reportsScreen.noMatches.title": {
    "defaultMessage": "Arquivos sem matches"
  },
  "audit.reportsScreen.noMatches.useSameRangeLabel": {
    "defaultMessage": "Usar mesmo período de criação do áudio"
  },
  "audit.reportsScreen.title": {
    "defaultMessage": "Relatórios"
  },
  "audit.reportsView.cloneBtn": {
    "defaultMessage": "Visualizar resultados"
  },
  "audit.reportsView.created": {
    "defaultMessage": "Data de criação"
  },
  "audit.reportsView.createdBy": {
    "defaultMessage": "Criado por"
  },
  "audit.reportsView.createdByUnknown": {
    "defaultMessage": "Sem dados"
  },
  "audit.reportsView.export": {
    "defaultMessage": "Export do relatório"
  },
  "audit.reportsView.exportBtn": {
    "defaultMessage": "Baixar relatório"
  },
  "audit.reportsView.exportDialog.confirm": {
    "defaultMessage": "Baixar"
  },
  "audit.reportsView.exportDialog.format": {
    "defaultMessage": "Formato"
  },
  "audit.reportsView.exportDialog.noDefinitions": {
    "defaultMessage": "Nenhum modelo disponível"
  },
  "audit.reportsView.exportDialog.title": {
    "defaultMessage": "Baixar relatório"
  },
  "audit.reportsView.exportFailed": {
    "defaultMessage": "Export falhou"
  },
  "audit.reportsView.exportInfo": {
    "defaultMessage": "Configuração de export"
  },
  "audit.reportsView.name": {
    "defaultMessage": "Nome do relatório"
  },
  "audit.reportsView.type": {
    "defaultMessage": "Tipo"
  },
  "audit.schedulesList.matchDatetime": {
    "defaultMessage": "Match"
  },
  "audit.schedulesList.mentions.diffLabel": {
    "defaultMessage": "Diff"
  },
  "audit.schedulesListScreen.inheritedTolerance": {
    "defaultMessage": "Herdada da configuração do cliente"
  },
  "audit.schedulesListScreen.noAudio": {
    "defaultMessage": "Sem áudio"
  },
  "audit.schedulesListScreen.noMatch": {
    "defaultMessage": "Sem match"
  },
  "audit.schedulesListScreen.props.status": {
    "defaultMessage": "Status"
  },
  "audit.schedulesListScreen.title": {
    "defaultMessage": "Schedules"
  },
  "audit.schedulesListScreen.viewScheduleBtn": {
    "defaultMessage": "View detail"
  },
  "audit.schedulesNoMatches.includeMissingAudio": {
    "defaultMessage": "Incluir agendamentos com arquivos faltantes"
  },
  "audit.schedulesNoMatches.title": {
    "defaultMessage": "Schedules sem matches"
  },
  "audit.schedulesPreview.advertiser": {
    "defaultMessage": "Anunciante"
  },
  "audit.schedulesPreview.campaign": {
    "defaultMessage": "Campanha"
  },
  "audit.schedulesPreview.dateTime": {
    "defaultMessage": "Data/hora"
  },
  "audit.schedulesPreview.tolerance": {
    "defaultMessage": "Tolerância"
  },
  "audit.schedulesPreview.version": {
    "defaultMessage": "Versão"
  },
  "audit.scheduleStatusPntScreen.confidence": {
    "defaultMessage": "Confiança"
  },
  "audit.scheduleStatusPntScreen.status.help": {
    "defaultMessage": "Os números indicam matches com schedule / schedules.\n\nCompleto: todos os schedules têm um match.\nParcial: faltam matches para cobrir todos os schedules.\nSem emissão: há schedules e nenhum match.\nSem matches: não há matches nem schedules.\n\nO ícone de aviso indica que algum match está fora da tolerância."
  },
  "audit.scheduleStatusScreen.detailModal.matchDatetime": {
    "defaultMessage": "Data e hora transmitida"
  },
  "audit.scheduleStatusScreen.detailModal.matchedSchedule": {
    "defaultMessage": "Matched schedule"
  },
  "audit.scheduleStatusScreen.detailModal.matches": {
    "defaultMessage": "Match confirmado"
  },
  "audit.scheduleStatusScreen.detailModal.noMatchedSchedule": {
    "defaultMessage": "Sem schedule"
  },
  "audit.scheduleStatusScreen.detailModal.offTolerance": {
    "defaultMessage": "A confirmação do agendamento está fora da tolerância permitida"
  },
  "audit.scheduleStatusScreen.detailModal.schedules": {
    "defaultMessage": "Schedules"
  },
  "audit.scheduleStatusScreen.detailModal.unmatchedMatches": {
    "defaultMessage": "Matches sem schedule"
  },
  "audit.scheduleStatusScreen.filter.idPlaceholder": {
    "defaultMessage": "Todos"
  },
  "audit.scheduleStatusScreen.noAudio": {
    "defaultMessage": "Sem material"
  },
  "audit.scheduleStatusScreen.overview.all": {
    "defaultMessage": "Todos"
  },
  "audit.scheduleStatusScreen.status": {
    "defaultMessage": "Estado"
  },
  "audit.scheduleStatusScreen.status.chipTooltip": {
    "defaultMessage": "{matchesCount} matches / {matchesWithScheduleCount} com schedule / {schedulesCount} schedules"
  },
  "audit.scheduleStatusScreen.status.chipTooltipOffTolerance": {
    "defaultMessage": "{matchesCount} matches / {matchesWithScheduleCount} com schedule / {schedulesCount} schedules ({offToleranceCount} fora da tolerância)"
  },
  "audit.scheduleStatusScreen.status.complete": {
    "defaultMessage": "Completo"
  },
  "audit.scheduleStatusScreen.status.help": {
    "defaultMessage": "Os números indicam matches com schedule / schedules.\n\nCompleto: todos os schedules têm um match.\nParcial: faltam matches para cobrir todos os schedules.\nSem emissão: há schedules e nenhum match.\nSem matches: não há matches nem schedules.\n\nO ícone de aviso indica que algum match está fora da tolerância."
  },
  "audit.scheduleStatusScreen.status.missingEmission": {
    "defaultMessage": "Sem emissão"
  },
  "audit.scheduleStatusScreen.status.none": {
    "defaultMessage": "Sem matches"
  },
  "audit.scheduleStatusScreen.status.offTolerance": {
    "defaultMessage": "Fora da tolerância"
  },
  "audit.scheduleStatusScreen.status.partial": {
    "defaultMessage": "Parcial"
  },
  "audit.scheduleStatusScreen.title": {
    "defaultMessage": "Schedule"
  },
  "audit.schedulesViewScreen.loading": {
    "defaultMessage": "Carregando schedule"
  },
  "audit.schedulesViewScreen.matchDiff": {
    "defaultMessage": "Diferença (minutos)"
  },
  "audit.schedulesViewScreen.matchesCount": {
    "defaultMessage": "{count, plural, =0 {No results found for the date} one {1 match found} other {# matches found} }"
  },
  "audit.schedulesViewScreen.matchTime": {
    "defaultMessage": "Data e hora"
  },
  "audit.schedulesViewScreen.title": {
    "defaultMessage": "Schedule #{id}"
  },
  "audit.screenbug.title": {
    "defaultMessage": "Screenbug"
  },
  "audit.sidenav.aod": {
    "defaultMessage": "AOD"
  },
  "audit.sidenav.config": {
    "defaultMessage": "Config"
  },
  "audit.sidenav.globalReports": {
    "defaultMessage": "Relatórios globais"
  },
  "audit.sidenav.stationAudit": {
    "defaultMessage": "Auditoria da emissora"
  },
  "audit.sorting.ascending": {
    "defaultMessage": "Ascendente"
  },
  "audit.sorting.descending": {
    "defaultMessage": "Descendente"
  },
  "audit.streamScreen.adoverlay": {
    "defaultMessage": "Ad Overlay"
  },
  "audit.streamScreen.audioMatches": {
    "defaultMessage": "Audio Matches"
  },
  "audit.streamScreen.liveMentions": {
    "defaultMessage": "Live Mentions"
  },
  "audit.streamScreen.lowerthird": {
    "defaultMessage": "Lowerthird"
  },
  "audit.streamScreen.transcriptions": {
    "defaultMessage": "Transcrições"
  },
  "audit.title": {
    "defaultMessage": "Auditoria"
  },
  "audit.transcriptionScreen.confidence": {
    "defaultMessage": "Confiança"
  },
  "audit.transcriptionScreen.high": {
    "defaultMessage": "Alta"
  },
  "audit.transcriptionScreen.loading": {
    "defaultMessage": "Carregando transcrições"
  },
  "audit.transcriptionScreen.low": {
    "defaultMessage": "Baixa"
  },
  "audit.transcriptionScreen.medium": {
    "defaultMessage": "Média"
  },
  "audit.transcriptionScreen.music": {
    "defaultMessage": "[Música / Silêncio]"
  },
  "audit.transcriptionScreen.noResults": {
    "defaultMessage": "Nenhuma transcrição encontrada"
  },
  "audit.transcriptionScreen.sentence": {
    "defaultMessage": "Sentença"
  },
  "audit.transcriptionScreen.speakers": {
    "defaultMessage": "Rótulos de Speaker"
  },
  "audit.uploadScreen.item.code": {
    "defaultMessage": "(Error code: {code})"
  },
  "audit.uploadScreen.item.completed": {
    "defaultMessage": "Successfully uploaded"
  },
  "audit.uploadScreen.item.error": {
    "defaultMessage": "Erro: {message}"
  },
  "audit.uploadScreen.item.notStarted": {
    "defaultMessage": "Not uploaded"
  },
  "audit.uploadScreen.item.overridden": {
    "defaultMessage": "(previous audio version was updated)"
  },
  "audit.uploadScreen.item.remove": {
    "defaultMessage": "Remove"
  },
  "audit.uploadScreen.item.started": {
    "defaultMessage": "Uploading"
  },
  "audit.uploadScreen.item.status": {
    "defaultMessage": "Status:"
  },
  "audit.uploadScreen.leavePrompt": {
    "defaultMessage": "Há um ou mais uploads em andamento. Tem certeza de que deseja sair da página?"
  },
  "audit.uploadScreen.reset": {
    "defaultMessage": "Reset"
  },
  "audit.uploadScreen.selectedCount": {
    "defaultMessage": "{count, plural, one {1 selected file} other {# selected files} }"
  },
  "audit.uploadScreen.title": {
    "defaultMessage": "Carregar arquivos"
  },
  "audit.uploadScreen.upload": {
    "defaultMessage": "Upload"
  },
  "audit.verifyMatch.accept": {
    "defaultMessage": "Aceitar"
  },
  "audit.verifyMatch.actionTitle": {
    "defaultMessage": "Verificar detecção"
  },
  "audit.verifyMatch.broadcastTitle": {
    "defaultMessage": "Emissão detectada"
  },
  "audit.verifyMatch.creativeTitle": {
    "defaultMessage": "Mídia de referência"
  },
  "audit.verifyMatch.dialogTitle": {
    "defaultMessage": "Verificar detecção"
  },
  "audit.verifyMatch.mentionContentTitle": {
    "defaultMessage": "Conteúdo da menção"
  },
  "audit.verifyMatch.navigationPosition": {
    "defaultMessage": "{current} / {total}"
  },
  "audit.verifyMatch.next": {
    "defaultMessage": "Seguinte"
  },
  "audit.verifyMatch.noMentionContent": {
    "defaultMessage": "Não há conteúdo de menção disponível para esta detecção."
  },
  "audit.verifyMatch.noScheduleConfirmation": {
    "defaultMessage": "Sem confirmação"
  },
  "audit.verifyMatch.noTranscription": {
    "defaultMessage": "Não há transcrição disponível para esta media."
  },
  "audit.verifyMatch.previous": {
    "defaultMessage": "Anterior"
  },
  "audit.verifyMatch.reject": {
    "defaultMessage": "Rejeitar"
  },
  "audit.verifyMatch.transcriptionTitle": {
    "defaultMessage": "Transcrição da mídia"
  },
  "auth.errors.ERR_AUTH_FAILED": {
    "defaultMessage": "Tente novamente ou entre em contato com o suporte."
  },
  "auth.errors.ERR_USER_NOT_REGISTERED": {
    "defaultMessage": "O usuário não está registrado na plataforma. Entre em contato com o suporte."
  },
  "auth.loginScreen.errorTitle": {
    "defaultMessage": "Não foi possível entrar"
  },
  "auth.loginScreen.loginBtn": {
    "defaultMessage": "Login"
  },
  "auth.loginScreen.title": {
    "defaultMessage": "Login"
  },
  "auth.noPermissionForPage": {
    "defaultMessage": "Você não tem permissão para acessar esta página"
  },
  "auth.tokenGate.errorLabel": {
    "defaultMessage": "Erro de autenticação:"
  },
  "auth.userInfo.changeUser": {
    "defaultMessage": "Trocar usuário"
  },
  "common.action.clear": {
    "defaultMessage": "Limpar"
  },
  "common.actions": {
    "defaultMessage": "Ações"
  },
  "common.actions.back": {
    "defaultMessage": "Voltar"
  },
  "common.actions.cancel": {
    "defaultMessage": "Cancelar"
  },
  "common.actions.clone": {
    "defaultMessage": "Clonar"
  },
  "common.actions.create": {
    "defaultMessage": "Criar novo"
  },
  "common.actions.createEntity": {
    "defaultMessage": "Criar"
  },
  "common.actions.delete": {
    "defaultMessage": "Excluir"
  },
  "common.actions.discard": {
    "defaultMessage": "Descartar"
  },
  "common.actions.draft": {
    "defaultMessage": "Rascunho"
  },
  "common.actions.edit": {
    "defaultMessage": "Editar"
  },
  "common.actions.export": {
    "defaultMessage": "Exportar"
  },
  "common.actions.exportAsCsv": {
    "defaultMessage": "Exportar como CSV"
  },
  "common.actions.exportAsXls": {
    "defaultMessage": "Exportar como XLS"
  },
  "common.actions.filterByValue": {
    "defaultMessage": "Filtrar por este valor"
  },
  "common.actions.refresh": {
    "defaultMessage": "Atualizar"
  },
  "common.actions.resetFilters": {
    "defaultMessage": "Limpar"
  },
  "common.actions.save": {
    "defaultMessage": "Salvar"
  },
  "common.actions.select": {
    "defaultMessage": "Selecionar..."
  },
  "common.actions.selectAll": {
    "defaultMessage": "Selecionar tudo"
  },
  "common.actions.selectNone": {
    "defaultMessage": "Desmarcar tudo"
  },
  "common.allStations": {
    "defaultMessage": "Todas as emissoras"
  },
  "common.audio": {
    "defaultMessage": "áudio"
  },
  "common.breadcrumb": {
    "defaultMessage": "Navegação"
  },
  "common.cancel": {
    "defaultMessage": "Cancelar"
  },
  "common.clear": {
    "defaultMessage": "Limpar"
  },
  "common.close": {
    "defaultMessage": "Fechar"
  },
  "common.columnIndex": {
    "defaultMessage": "#"
  },
  "common.confirm": {
    "defaultMessage": "Confirmar"
  },
  "common.createdAt": {
    "defaultMessage": "Criado"
  },
  "common.customId": {
    "defaultMessage": "ID personalizado"
  },
  "common.customImage": {
    "defaultMessage": "Imagem personalizada"
  },
  "common.date": {
    "defaultMessage": "Data"
  },
  "common.dateEnd": {
    "defaultMessage": "Data final"
  },
  "common.dateRangeSelector.apply": {
    "defaultMessage": "Aplicar"
  },
  "common.dateRangeSelector.labelToNow": {
    "defaultMessage": "{from} até agora"
  },
  "common.dateRangeSelector.preset.customFixedDateRange": {
    "defaultMessage": "Intervalo de datas fixo personalizado..."
  },
  "common.dateRangeSelector.preset.customSingleDate": {
    "defaultMessage": "Data personalizada..."
  },
  "common.dateRangeSelector.preset.fromCustomDateUntilNow": {
    "defaultMessage": "De data personalizada até agora..."
  },
  "common.dateRangeSelector.preset.last14Days": {
    "defaultMessage": "Últimos 14 dias"
  },
  "common.dateRangeSelector.preset.last180Days": {
    "defaultMessage": "Últimos 180 dias"
  },
  "common.dateRangeSelector.preset.last24Hours": {
    "defaultMessage": "Últimas 24 horas"
  },
  "common.dateRangeSelector.preset.last30Days": {
    "defaultMessage": "Últimos 30 dias"
  },
  "common.dateRangeSelector.preset.last7Days": {
    "defaultMessage": "Últimos 7 dias"
  },
  "common.dateRangeSelector.preset.last90Days": {
    "defaultMessage": "Últimos 90 dias"
  },
  "common.dateRangeSelector.preset.lastHour": {
    "defaultMessage": "Última hora"
  },
  "common.dateRangeSelector.preset.lastMonth": {
    "defaultMessage": "Mês passado"
  },
  "common.dateRangeSelector.preset.lastNHours": {
    "defaultMessage": "Últimas {hours} horas"
  },
  "common.dateRangeSelector.preset.lastWeek": {
    "defaultMessage": "Semana passada"
  },
  "common.dateRangeSelector.preset.thisMonth": {
    "defaultMessage": "Este mês"
  },
  "common.dateRangeSelector.preset.thisWeek": {
    "defaultMessage": "Esta semana"
  },
  "common.dateRangeSelector.preset.today": {
    "defaultMessage": "Hoje"
  },
  "common.dateRangeSelector.preset.yearToDate": {
    "defaultMessage": "Desde o início do ano"
  },
  "common.dateRangeSelector.preset.yesterday": {
    "defaultMessage": "Ontem"
  },
  "common.dateRangeSelector.selectDateRangeTitle": {
    "defaultMessage": "Selecionar um intervalo de datas"
  },
  "common.dateRangeSelector.selectedLabel": {
    "defaultMessage": "Selecionado: {from} – {to}"
  },
  "common.dateSelector.preset.dayMinus2": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus3": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus4": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus5": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.dayMinus6": {
    "defaultMessage": ""
  },
  "common.dateSelector.preset.today": {
    "defaultMessage": "Hoje"
  },
  "common.dateSelector.preset.yesterday": {
    "defaultMessage": "Ontem"
  },
  "common.dateSelector.selectDate": {
    "defaultMessage": "Selecionar data"
  },
  "common.dateStart": {
    "defaultMessage": "Data inicial"
  },
  "common.datetime": {
    "defaultMessage": "Data e hora"
  },
  "common.datetimeRange": {
    "defaultMessage": "Período"
  },
  "common.delete": {
    "defaultMessage": "Excluir"
  },
  "common.disabled": {
    "defaultMessage": "Desabilitado"
  },
  "common.download": {
    "defaultMessage": "Baixar"
  },
  "common.edit": {
    "defaultMessage": "Editar"
  },
  "common.email": {
    "defaultMessage": "E-mail"
  },
  "common.enabled": {
    "defaultMessage": "Habilitado"
  },
  "common.entities.fragments": {
    "defaultMessage": "fragmentos"
  },
  "common.entities.group": {
    "defaultMessage": "Grupo"
  },
  "common.entities.groups": {
    "defaultMessage": "groups"
  },
  "common.entities.station": {
    "defaultMessage": "Emissora"
  },
  "common.entities.stations": {
    "defaultMessage": "Emissoras"
  },
  "common.entities.user": {
    "defaultMessage": "usuário"
  },
  "common.error": {
    "defaultMessage": "Erro"
  },
  "common.errorOccurredTryAgain": {
    "defaultMessage": "Ocorreu um erro, tente novamente"
  },
  "common.form.errorNotification": {
    "defaultMessage": "Ocorreu um erro. Verifique todos os campos e tente novamente. Se o erro persistir, entre em contato com o suporte"
  },
  "common.form.saveBtnText": {
    "defaultMessage": "Save"
  },
  "common.frameSelector.frameSelected": {
    "defaultMessage": "Frame selecionado:"
  },
  "common.frameSelector.useThisFrame": {
    "defaultMessage": "Usar este frame"
  },
  "common.groupBy": {
    "defaultMessage": "Agrupar por"
  },
  "common.help": {
    "defaultMessage": "Ajuda"
  },
  "common.insertContentHere": {
    "defaultMessage": "Inserir conteúdo aqui"
  },
  "common.jobFailed": {
    "defaultMessage": "Falha no trabalho"
  },
  "common.jobInProgress": {
    "defaultMessage": "Trabalho em andamento"
  },
  "common.jobStatus.CANCELLED": {
    "defaultMessage": "Cancelado"
  },
  "common.jobStatus.COMPLETED": {
    "defaultMessage": "Concluído"
  },
  "common.jobStatus.FAILED": {
    "defaultMessage": "Falhou"
  },
  "common.jobStatus.IN_PROGRESS": {
    "defaultMessage": "Em progresso"
  },
  "common.jobStatus.SCHEDULED": {
    "defaultMessage": "Agendado"
  },
  "common.jobStatus.WAITING": {
    "defaultMessage": "Na fila"
  },
  "common.languageSelect.defaultLabel": {
    "defaultMessage": "Idioma"
  },
  "common.listView.clearAllFilters": {
    "defaultMessage": "Limpar todos os filtros"
  },
  "common.listView.noMoreResults": {
    "defaultMessage": "No hay más resultados"
  },
  "common.listView.noResults": {
    "defaultMessage": "Sem resultados"
  },
  "common.listView.totalResults": {
    "defaultMessage": "{count, number} resultados"
  },
  "common.listView.tryOtherFiltersOrClear": {
    "defaultMessage": "Tente buscar com outros filtros ou remova os aplicados para ver mais resultados."
  },
  "common.listView.useFiltersToFindMore": {
    "defaultMessage": "Use os filtros para encontrar mais resultados"
  },
  "common.loadFile": {
    "defaultMessage": "Carregar arquivo"
  },
  "common.loadImage": {
    "defaultMessage": "Carregar imagem"
  },
  "common.loading": {
    "defaultMessage": "Loading..."
  },
  "common.loadingEntity": {
    "defaultMessage": "Carregando entidade"
  },
  "common.loadMore": {
    "defaultMessage": "Mostrar anteriores"
  },
  "common.loadThumbnail": {
    "defaultMessage": "Carregar miniatura"
  },
  "common.name": {
    "defaultMessage": "Nome"
  },
  "common.no": {
    "defaultMessage": "Não"
  },
  "common.noOptions": {
    "defaultMessage": "No se encontraron resultados"
  },
  "common.noResults": {
    "defaultMessage": "Nenhum resultado"
  },
  "common.noStations.message": {
    "defaultMessage": "Esta tela será atualizada automaticamente quando estiverem disponíveis."
  },
  "common.noStations.title": {
    "defaultMessage": "Nenhuma estação atribuída ainda"
  },
  "common.notes": {
    "defaultMessage": "Notas"
  },
  "common.notifications.deleted": {
    "defaultMessage": "Excluído com sucesso"
  },
  "common.notifications.deleteError": {
    "defaultMessage": "Erro ao excluir"
  },
  "common.notifications.updated": {
    "defaultMessage": "{entity} atualizado"
  },
  "common.optional": {
    "defaultMessage": "(opcional)"
  },
  "common.pause": {
    "defaultMessage": "Pausar"
  },
  "common.play": {
    "defaultMessage": "Reproduzir"
  },
  "common.prose.showLess": {
    "defaultMessage": "Mostrar menos"
  },
  "common.prose.showMore": {
    "defaultMessage": "Mostrar mais"
  },
  "common.quantity": {
    "defaultMessage": "Quantidade"
  },
  "common.refresh": {
    "defaultMessage": "Atualizar"
  },
  "common.remove": {
    "defaultMessage": "Remover"
  },
  "common.removeFilter": {
    "defaultMessage": "Remover filtro"
  },
  "common.required": {
    "defaultMessage": "Obrigatório"
  },
  "common.routeNotFound.help": {
    "defaultMessage": "O link pode estar quebrado ou a página pode ter sido movida."
  },
  "common.routeNotFound.title": {
    "defaultMessage": "Esta página não existe"
  },
  "common.selectFileLabel": {
    "defaultMessage": "Selecionar arquivo {extensions}"
  },
  "common.show": {
    "defaultMessage": "Mostrar"
  },
  "common.simpleTableAriaLabel": {
    "defaultMessage": "Tabela de dados"
  },
  "common.station": {
    "defaultMessage": "Emissora"
  },
  "common.stationNotFound.help": {
    "defaultMessage": "Pode não existir ou você pode não ter acesso a ela."
  },
  "common.stationNotFound.text": {
    "defaultMessage": "Emissora não encontrada"
  },
  "common.stations": {
    "defaultMessage": "Emissoras"
  },
  "common.stations.shared.tooltip": {
    "defaultMessage": "Emissora externa"
  },
  "common.stations.type.AFFILIATE": {
    "defaultMessage": "Afiliada"
  },
  "common.stations.type.HEADER": {
    "defaultMessage": "Cabeçalho"
  },
  "common.stations.type.REPEATER": {
    "defaultMessage": "Repetidora"
  },
  "common.stations.type.STANDALONE": {
    "defaultMessage": "Independente"
  },
  "common.stations.youtubeNative.tooltip": {
    "defaultMessage": "Emissora nativa do YouTube"
  },
  "common.status": {
    "defaultMessage": "Estado"
  },
  "common.status.active": {
    "defaultMessage": "Ativa"
  },
  "common.status.inactive": {
    "defaultMessage": "Inativa"
  },
  "common.text": {
    "defaultMessage": "Texto"
  },
  "common.text.actions": {
    "defaultMessage": "Ações"
  },
  "common.text.addFilter": {
    "defaultMessage": "Filtro"
  },
  "common.text.all": {
    "defaultMessage": "Todos"
  },
  "common.text.back": {
    "defaultMessage": "Voltar"
  },
  "common.text.content": {
    "defaultMessage": "Conteúdo"
  },
  "common.text.count": {
    "defaultMessage": "Quantidade"
  },
  "common.text.date": {
    "defaultMessage": "Data"
  },
  "common.text.description": {
    "defaultMessage": "Descrição"
  },
  "common.text.duration": {
    "defaultMessage": "duração"
  },
  "common.text.language": {
    "defaultMessage": "Idioma"
  },
  "common.text.name": {
    "defaultMessage": "Nome"
  },
  "common.text.next": {
    "defaultMessage": "Próximo"
  },
  "common.text.no": {
    "defaultMessage": "Não"
  },
  "common.text.notSet": {
    "defaultMessage": "Não definido"
  },
  "common.text.subtitle": {
    "defaultMessage": "Subtítulo"
  },
  "common.text.time": {
    "defaultMessage": "Hora"
  },
  "common.text.timezone": {
    "defaultMessage": "Timezone"
  },
  "common.text.title": {
    "defaultMessage": "Título"
  },
  "common.text.type": {
    "defaultMessage": "Tipo"
  },
  "common.text.yes": {
    "defaultMessage": "Sim"
  },
  "common.thumbnail": {
    "defaultMessage": "Miniatura"
  },
  "common.thumbType": {
    "defaultMessage": "Tipo de miniatura"
  },
  "common.timeEnd": {
    "defaultMessage": "Hora final"
  },
  "common.timeStart": {
    "defaultMessage": "Hora inicial"
  },
  "common.title": {
    "defaultMessage": "Título"
  },
  "common.truncate.hide": {
    "defaultMessage": "Ocultar"
  },
  "common.truncate.showAll": {
    "defaultMessage": "Mostrar tudo"
  },
  "common.type": {
    "defaultMessage": "Tipo"
  },
  "common.updatedAt": {
    "defaultMessage": "Atualizado"
  },
  "common.users": {
    "defaultMessage": "Usuários"
  },
  "common.video": {
    "defaultMessage": "vídeo"
  },
  "common.videoFrame": {
    "defaultMessage": "Frame do vídeo"
  },
  "common.visualize": {
    "defaultMessage": "Visualize"
  },
  "common.wizard.back": {
    "defaultMessage": "Voltar"
  },
  "common.wizard.finish": {
    "defaultMessage": "Finalizar"
  },
  "common.wizard.next": {
    "defaultMessage": "Próximo"
  },
  "common.yes": {
    "defaultMessage": "Sim"
  },
  "compose.createComposition.action": {
    "defaultMessage": "Criar composição"
  },
  "compose.createPage.fieldName": {
    "defaultMessage": "Nome"
  },
  "compose.createPage.successToast": {
    "defaultMessage": "Composição criada"
  },
  "compose.createPage.title": {
    "defaultMessage": "Criar composição"
  },
  "compose.delete.message": {
    "defaultMessage": "Tem certeza de que deseja excluir a composição \"{name}\"? Esta ação não pode ser desfeita."
  },
  "compose.delete.successToast": {
    "defaultMessage": "Composição excluída"
  },
  "compose.delete.title": {
    "defaultMessage": "Excluir composição"
  },
  "compose.editPage.successToast": {
    "defaultMessage": "Composição atualizada"
  },
  "compose.editPage.title": {
    "defaultMessage": "Editar composição"
  },
  "compose.filters.compositionName": {
    "defaultMessage": "Nome da composição"
  },
  "compose.listCard.editsCount": {
    "defaultMessage": "{count, plural, one {# edit} other {# edits}}"
  },
  "compose.listCard.unpublished": {
    "defaultMessage": "Sin publicar"
  },
  "compose.listEmptyState.message": {
    "defaultMessage": "Não há composições"
  },
  "compose.listScreen.hubLabel": {
    "defaultMessage": "Compose"
  },
  "compose.listScreen.title": {
    "defaultMessage": "Compose"
  },
  "compose.navTitle": {
    "defaultMessage": "Compose"
  },
  "compose.publish.tabTitle": {
    "defaultMessage": "Redes"
  },
  "compose.videoEditions.tabTitle": {
    "defaultMessage": "Edits"
  },
  "contentAi.articleNumber": {
    "defaultMessage": "ARTIGO {number}"
  },
  "contentAi.articles.generateContent": {
    "defaultMessage": "Gerar conteúdo"
  },
  "contentAi.articles.instructions": {
    "defaultMessage": "Instruções"
  },
  "contentAi.backToArticleSelection": {
    "defaultMessage": "Voltar à seleção de artigos"
  },
  "contentAi.configPerStation": {
    "defaultMessage": "Config por emissora"
  },
  "contentAi.configTitle": {
    "defaultMessage": "Config Content AI"
  },
  "contentAi.contentOrigin": {
    "defaultMessage": "Origem do conteúdo:"
  },
  "contentAi.contentsList.fragment": {
    "defaultMessage": "Fragmento"
  },
  "contentAi.contentsList.source": {
    "defaultMessage": "Origem"
  },
  "contentAi.contentsList.title": {
    "defaultMessage": "Content AI - Conteúdos"
  },
  "contentAi.contentsList.view": {
    "defaultMessage": "Ver"
  },
  "contentAi.copyToClipboard": {
    "defaultMessage": "Copiar para a área de transferência"
  },
  "contentAi.externalExportEnabled": {
    "defaultMessage": "Export externo ativado"
  },
  "contentAi.fragment": {
    "defaultMessage": "Fragmento"
  },
  "contentAi.fragmentContentExists": {
    "defaultMessage": "Já existe um conteúdo criado para este fragmento"
  },
  "contentAi.goToContent": {
    "defaultMessage": "Ir ao conteúdo"
  },
  "contentAi.instructionsOptional": {
    "defaultMessage": "Instruções (opcional)"
  },
  "contentAi.instructionsPlaceholder": {
    "defaultMessage": "Digite as instruções aqui."
  },
  "contentAi.placeholder.tone": {
    "defaultMessage": "Positivo, negativo, neutro"
  },
  "contentAi.preparingMedia": {
    "defaultMessage": "Preparando mídia para análise"
  },
  "contentAi.regenerateArticles": {
    "defaultMessage": "Regenerar artigos"
  },
  "contentAi.saveAndContinue": {
    "defaultMessage": "Salvar e continuar"
  },
  "contentAi.socialVersion.generatedFor": {
    "defaultMessage": "Conteúdo gerado para {platform}"
  },
  "contentAi.socialVersion.generateFor": {
    "defaultMessage": "Gerar conteúdo para {platform}"
  },
  "contentAi.socialVersion.publishContent": {
    "defaultMessage": "Publicar conteúdo"
  },
  "contentAi.socialVersion.publishError": {
    "defaultMessage": "Ocorreu um erro ao publicar a versão, tente novamente"
  },
  "contentAi.socialVersion.regenerate": {
    "defaultMessage": "Regenerar"
  },
  "contentAi.stationConfig.addPrompt": {
    "defaultMessage": "Adicionar novo prompt"
  },
  "contentAi.stationConfig.promptsTitle": {
    "defaultMessage": "Prompts"
  },
  "contentAi.stationConfig.updated": {
    "defaultMessage": "Config Content AI para {stationName} atualizada"
  },
  "contentAi.steps.adaptAndPublish": {
    "defaultMessage": "Adaptar e publicar nas redes"
  },
  "contentAi.steps.aiArticles.choosePrompt": {
    "defaultMessage": "Escolher Prompt"
  },
  "contentAi.steps.editContent": {
    "defaultMessage": "Editar conteúdo"
  },
  "contentAi.steps.generateArticles": {
    "defaultMessage": "Gerar artigos"
  },
  "contentAi.title": {
    "defaultMessage": "IA de Conteúdo"
  },
  "contentAi.userArticle.generatedForWeb": {
    "defaultMessage": "Conteúdo gerado para Web"
  },
  "contentAi.userArticle.primaryArticle": {
    "defaultMessage": "Artigo primário"
  },
  "contentAi.userArticle.useFooter": {
    "defaultMessage": "Usar rodapé:"
  },
  "contentAi.useThisArticle": {
    "defaultMessage": "Usar este artigo"
  },
  "contentAi.viewFullArticle": {
    "defaultMessage": "Ver artigo completo"
  },
  "contentAi.wizard.adaptContentTitle": {
    "defaultMessage": "Adapte o conteúdo e publique nas redes."
  },
  "contentAi.wizard.almostThereTitle": {
    "defaultMessage": "Quase lá! Apenas {count} passos restantes."
  },
  "contentAi.wizard.createFragmentStep": {
    "defaultMessage": "Criar fragmento"
  },
  "contentAi.wizard.editArticleTitle": {
    "defaultMessage": "Edite seu artigo para publicá-lo."
  },
  "core.screen.hotkeys.modalTitle": {
    "defaultMessage": "Hotkeys"
  },
  "core.screen.hotkeys.showBtnText": {
    "defaultMessage": "Hotkeys"
  },
  "core.sidenav.adminIndicatorText": {
    "defaultMessage": "Admin"
  },
  "core.sidenav.collapseTooltip": {
    "defaultMessage": "Fechar menu"
  },
  "core.sidenav.darkModeTooltip": {
    "defaultMessage": "Escuro"
  },
  "core.sidenav.defaultModeLabel": {
    "defaultMessage": "Default"
  },
  "core.sidenav.expandTooltip": {
    "defaultMessage": "Abrir menu"
  },
  "core.sidenav.lightModeTooltip": {
    "defaultMessage": "Claro"
  },
  "core.sidenav.logoutBtnText": {
    "defaultMessage": "Fechar sessão"
  },
  "core.sidenav.notificationsEmpty": {
    "defaultMessage": "Não há notificações"
  },
  "core.sidenav.settingsBtnText": {
    "defaultMessage": "Configurações do usuário"
  },
  "core.sidenav.themeToggle.tour.description": {
    "defaultMessage": "Abra o menu da conta para escolher Default, Escuro ou Claro."
  },
  "core.sidenav.themeToggle.tour.title": {
    "defaultMessage": "Opções de tema disponíveis"
  },
  "date.justNow": {
    "defaultMessage": "Há instantes"
  },
  "fleet.devices.card.lastSeen": {
    "defaultMessage": "Visto pela última vez {relativeTime}"
  },
  "fleet.devices.card.mapAlt": {
    "defaultMessage": "Mapa de {name}"
  },
  "fleet.devices.card.noLastSeen": {
    "defaultMessage": "Nunca visto online"
  },
  "fleet.devices.card.openAdminPanel": {
    "defaultMessage": "Abrir painel de administração"
  },
  "fleet.devices.card.viewOnMap": {
    "defaultMessage": "Ver no mapa"
  },
  "fleet.devices.filters.id": {
    "defaultMessage": "ID"
  },
  "fleet.devices.filters.idPlaceholder": {
    "defaultMessage": "Buscar por ID"
  },
  "fleet.devices.filters.name": {
    "defaultMessage": "Nome"
  },
  "fleet.devices.filters.namePlaceholder": {
    "defaultMessage": "Buscar por nome"
  },
  "fleet.devices.filters.status": {
    "defaultMessage": "Status"
  },
  "fleet.devices.listScreen.title": {
    "defaultMessage": "Devices"
  },
  "fleet.devices.status.offline": {
    "defaultMessage": "Offline"
  },
  "fleet.devices.status.online": {
    "defaultMessage": "Online"
  },
  "fleet.devices.type.airnode": {
    "defaultMessage": "AirNode"
  },
  "fleet.devices.type.streamBox": {
    "defaultMessage": "StreamBox"
  },
  "fleet.nav.title": {
    "defaultMessage": "Devices"
  },
  "form.array.addButtonLabel": {
    "defaultMessage": "Adicionar"
  },
  "form.array.emptyMessage": {
    "defaultMessage": "Ainda não há itens definidos"
  },
  "form.array.fieldError": {
    "defaultMessage": "Erro no campo"
  },
  "form.frameThumbnailLabel": {
    "defaultMessage": "Frame a utilizar como miniatura"
  },
  "fragmentMedia.audio.chunkPill.unlabeledChunk": {
    "defaultMessage": "Segmento {n}"
  },
  "fragments.addScreen.createAndGoShort": {
    "defaultMessage": "Criar e ir"
  },
  "fragments.addScreen.createAndOpen": {
    "defaultMessage": "Criar e ir ao fragmento"
  },
  "fragments.addScreen.created": {
    "defaultMessage": "Fragmento criado"
  },
  "fragments.addScreen.createError": {
    "defaultMessage": "Não foi possível criar o fragmento"
  },
  "fragments.addScreen.createOnly": {
    "defaultMessage": "Criar"
  },
  "fragments.addScreen.exportError": {
    "defaultMessage": "Não foi possível iniciar o export externo"
  },
  "fragments.addScreen.exportMissingConnection": {
    "defaultMessage": "Não foi possível iniciar o export: falta a conta de publicação"
  },
  "fragments.addScreen.externalExportError": {
    "defaultMessage": "Não foi possível iniciar o export externo"
  },
  "fragments.addScreen.goTo": {
    "defaultMessage": "Ir para o fragmento"
  },
  "fragments.addScreen.splitSubmit.tour.description": {
    "defaultMessage": "Use este menu para criar o fragmento e ir ao detalhe em um só passo."
  },
  "fragments.addScreen.splitSubmit.tour.title": {
    "defaultMessage": "Criar e ir ao fragmento"
  },
  "fragments.card.posterProcessing": {
    "defaultMessage": "Processando"
  },
  "fragments.cloneScreen.cloned": {
    "defaultMessage": "Fragmento clonado"
  },
  "fragments.cloneScreen.cloneError": {
    "defaultMessage": "Não foi possível clonar o fragmento"
  },
  "fragments.cloneScreen.defaultTitle": {
    "defaultMessage": "{title} (cópia)"
  },
  "fragments.cloneScreen.inputLabel": {
    "defaultMessage": "Novo título"
  },
  "fragments.cloneScreen.inputRequired": {
    "defaultMessage": "O título é obrigatório"
  },
  "fragments.cloneScreen.title": {
    "defaultMessage": "Clonar fragmento"
  },
  "fragments.contentAi.generateFromFragment": {
    "defaultMessage": "Gerar conteúdo a partir deste fragmento"
  },
  "fragments.contentAi.noPermission": {
    "defaultMessage": "Você não tem permissão para criar conteúdo"
  },
  "fragments.deleteScreen.deleted": {
    "defaultMessage": "Fragmento excluído"
  },
  "fragments.deleteScreen.deleteError": {
    "defaultMessage": "Não foi possível excluir o fragmento"
  },
  "fragments.deleteScreen.prompt": {
    "defaultMessage": "Você deseja excluir o fragmento <b>{title}</b>? {br} Esta ação não pode ser desfeita."
  },
  "fragments.deleteScreen.title": {
    "defaultMessage": "Excluir fragmento"
  },
  "fragments.delivery.destinationStation": {
    "defaultMessage": "Emissora de destino"
  },
  "fragments.delivery.exportStarted": {
    "defaultMessage": "Exportação iniciada"
  },
  "fragments.delivery.exportStartError": {
    "defaultMessage": "Ocorreu um erro ao iniciar a exportação, entre em contato com o suporte (status: {status})"
  },
  "fragments.delivery.savedAt": {
    "defaultMessage": "Salvo em {uri}"
  },
  "fragments.deliveryStatus.destinationStationLabel": {
    "defaultMessage": "Emissora destino"
  },
  "fragments.deliveryStatus.enable": {
    "defaultMessage": "Ativar export externo"
  },
  "fragments.deliveryStatus.none": {
    "defaultMessage": "Fragmento não exportado"
  },
  "fragments.deliveryStatus.start": {
    "defaultMessage": "Iniciar export externo"
  },
  "fragments.export.audioMp3GeneratingTooltip": {
    "defaultMessage": "Geração de MP3 em curso"
  },
  "fragments.export.downloadAudioMp3": {
    "defaultMessage": "Descarregar áudio (MP3)"
  },
  "fragments.export.downloadMedia": {
    "defaultMessage": "Baixar {type}"
  },
  "fragments.export.downloadMediaAudioAac": {
    "defaultMessage": "Baixar {type} (aac)"
  },
  "fragments.export.publishError": {
    "defaultMessage": "Ocorreu um erro ao publicar"
  },
  "fragments.export.publishingInProgress": {
    "defaultMessage": "Publicação em curso..."
  },
  "fragments.exportStatus.externalExportNotEnabled": {
    "defaultMessage": "O export externo não está habilitado, entre em contato com o suporte."
  },
  "fragments.exportStatus.ready": {
    "defaultMessage": "Pronto"
  },
  "fragments.exportView.tabExternalExport": {
    "defaultMessage": "Export"
  },
  "fragments.exportView.tabFiles": {
    "defaultMessage": "Arquivos"
  },
  "fragments.exportView.tabPublish": {
    "defaultMessage": "Redes"
  },
  "fragments.filter.hasContentAi": {
    "defaultMessage": "Contenido AI"
  },
  "fragments.filter.hasExternalDelivery": {
    "defaultMessage": "Exportação externa"
  },
  "fragments.filter.onlyMine": {
    "defaultMessage": "Somente os meus"
  },
  "fragments.filter.publishedPlatforms": {
    "defaultMessage": "Plataformas publicadas"
  },
  "fragments.form.addEmoji": {
    "defaultMessage": "Add emoji"
  },
  "fragments.form.description.placeholder": {
    "defaultMessage": "Ex.: Gravado no estádio Luzhniki em Moscou durante a Copa do Mundo"
  },
  "fragments.form.emojiPickerOk": {
    "defaultMessage": "OK"
  },
  "fragments.form.emojiSearchPlaceholder": {
    "defaultMessage": "Buscar"
  },
  "fragments.form.footer.placeholder": {
    "defaultMessage": "Add footer"
  },
  "fragments.form.header": {
    "defaultMessage": "Criar fragmento"
  },
  "fragments.form.header.noRangeSelected": {
    "defaultMessage": "Nenhum intervalo selecionado"
  },
  "fragments.form.publishOn": {
    "defaultMessage": "Publicar rápido"
  },
  "fragments.form.tags.placeholder": {
    "defaultMessage": "Ex.: entrevista, messi, copa do mundo, moscou"
  },
  "fragments.form.title.placeholder": {
    "defaultMessage": "Ex.: Entrevista com Messi"
  },
  "fragments.listScreen.allFragments": {
    "defaultMessage": "Fragmentos"
  },
  "fragments.listScreen.failed": {
    "defaultMessage": "Falha ao enviar para"
  },
  "fragments.listScreen.scheduled": {
    "defaultMessage": "Programado"
  },
  "fragments.listScreen.sentTo": {
    "defaultMessage": "Enviado para"
  },
  "fragments.listScreen.unpublished": {
    "defaultMessage": "Sin publicar"
  },
  "fragments.listV3.section.previous": {
    "defaultMessage": "Anteriores"
  },
  "fragments.listV3.section.today": {
    "defaultMessage": "Hoje"
  },
  "fragments.listV3.section.yesterday": {
    "defaultMessage": "Ontem"
  },
  "fragments.listV3.tour.addFilter.description": {
    "defaultMessage": "Adicione filtros como Conteúdo AI, Exportação externa e Plataformas publicadas por este botão para refinar a lista de fragmentos."
  },
  "fragments.listV3.tour.addFilter.title": {
    "defaultMessage": "Novos filtros disponíveis"
  },
  "fragments.listV3.tour.viewToggle.description": {
    "defaultMessage": "Alterne entre lista e grade (ampla, normal ou compacta) para ver os fragmentos do seu jeito."
  },
  "fragments.listV3.tour.viewToggle.title": {
    "defaultMessage": "Visualização dos fragmentos"
  },
  "fragments.mediaStatus.regenerate": {
    "defaultMessage": "Sem progresso? Regenerar mídia"
  },
  "fragments.mediaStatus.regenerateError": {
    "defaultMessage": "Não foi possível regenerar a mídia"
  },
  "fragments.mediaStatus.regenerateStarted": {
    "defaultMessage": "Regeneração da mídia do fragmento iniciada"
  },
  "fragments.mediaStatus.title": {
    "defaultMessage": "Arquivo de mídia"
  },
  "fragments.mediaStatus.waiting": {
    "defaultMessage": "Geração da mídia em andamento"
  },
  "fragments.props.createdBy": {
    "defaultMessage": "Criado por"
  },
  "fragments.props.description": {
    "defaultMessage": "Descrição"
  },
  "fragments.props.tag": {
    "defaultMessage": "Tag"
  },
  "fragments.props.tags": {
    "defaultMessage": "Tags"
  },
  "fragments.props.title": {
    "defaultMessage": "Título"
  },
  "fragments.subtitlesStatus.add": {
    "defaultMessage": "Adicionar ID do speaker"
  },
  "fragments.subtitlesStatus.download": {
    "defaultMessage": "Baixar legendas"
  },
  "fragments.subtitlesStatus.formatJson": {
    "defaultMessage": ".JSON"
  },
  "fragments.subtitlesStatus.formatSrt": {
    "defaultMessage": ".SRT"
  },
  "fragments.subtitlesStatus.formatTxt": {
    "defaultMessage": ".TXT"
  },
  "fragments.subtitlesStatus.title": {
    "defaultMessage": "Legendas"
  },
  "fragments.title": {
    "defaultMessage": "Fragmentos"
  },
  "fragments.transcription.panelTitle": {
    "defaultMessage": "Transcrição"
  },
  "fragments.transcription.v2.editModeTooltipOff": {
    "defaultMessage": "Modo edição: desativado"
  },
  "fragments.transcription.v2.editModeTooltipOn": {
    "defaultMessage": "Modo edição: ativado"
  },
  "fragments.transcription.v2.editSaveError": {
    "defaultMessage": "Não foi possível salvar a palavra. Tente novamente."
  },
  "fragments.transcription.v2.efficiencyTooltipOff": {
    "defaultMessage": "Eficiência por palavra: desativado"
  },
  "fragments.transcription.v2.efficiencyTooltipOn": {
    "defaultMessage": "Eficiência por palavra: ativado"
  },
  "fragments.transcription.v2.searchNoMatches": {
    "defaultMessage": "Sem correspondências"
  },
  "fragments.transcription.v2.searchTooltipOff": {
    "defaultMessage": "Busca: desativada"
  },
  "fragments.transcription.v2.searchTooltipOn": {
    "defaultMessage": "Busca: ativada"
  },
  "fragments.transcription.v2.syncTooltipOff": {
    "defaultMessage": "Sincronizar transcrição com reprodução: desativado"
  },
  "fragments.transcription.v2.syncTooltipOn": {
    "defaultMessage": "Sincronizar transcrição com reprodução: ativado"
  },
  "fragments.video.subtitlesTrackLabel": {
    "defaultMessage": "Legendas"
  },
  "fragments.view.descriptionTitle": {
    "defaultMessage": "Descrição"
  },
  "fragments.view.metadata.openInLogger": {
    "defaultMessage": "Abrir no Logger:"
  },
  "fragments.view.metadata.goToStream": {
    "defaultMessage": "Início"
  },
  "fragments.view.metadata.goToStreamFromPlayback": {
    "defaultMessage": "Tempo atual"
  },
  "fragments.view.metadata.goToStreamWithSelection": {
    "defaultMessage": "Seleção"
  },
  "fragments.view.regenerateMedia": {
    "defaultMessage": "Regenerar mídia"
  },
  "fragments.viewScreen.mediaNotReadyTooltip": {
    "defaultMessage": "Aguardando mídia do fragmento"
  },
  "fragments.viewScreen.title": {
    "defaultMessage": "Informações"
  },
  "fragments.viewScreen.transcriptionNotReadyTooltip": {
    "defaultMessage": "Aguardando transcrição do fragmento"
  },
  "globalLivePlayer.title": {
    "defaultMessage": "Reprodutor em direto"
  },
  "impersonation.currentUserTitle": {
    "defaultMessage": "Usuário salvo"
  },
  "impersonation.tabDeepLinkUserTitle": {
    "defaultMessage": "Usuário desta aba"
  },
  "impersonation.clearTabAuthAsAriaLabel": {
    "defaultMessage": "Limpar usuário desta aba"
  },
  "impersonation.tabAuthAsBadgeLabel": {
    "defaultMessage": "Aba"
  },
  "impersonation.tabAuthAsBadgeTooltip": {
    "defaultMessage": "Impersonação apenas nesta aba"
  },
  "impersonation.openInNewTabAriaLabel": {
    "defaultMessage": "Impersonar em aba"
  },
  "impersonation.deleteAriaLabel": {
    "defaultMessage": "Excluir"
  },
  "impersonation.enterToSelect": {
    "defaultMessage": "Enter para selecionar"
  },
  "impersonation.clientAdminChip": {
    "defaultMessage": "Admin cliente"
  },
  "impersonation.groups.clientAdmins": {
    "defaultMessage": "Administradores de cliente"
  },
  "impersonation.groups.clientUsers": {
    "defaultMessage": "Usuários de cliente"
  },
  "impersonation.groups.mediainboxUsers": {
    "defaultMessage": "Usuários Mediainbox"
  },
  "impersonation.impersonateAriaLabel": {
    "defaultMessage": "Impersonar"
  },
  "impersonation.pageTitle": {
    "defaultMessage": "Impersonar usuário"
  },
  "impersonation.recentUsersTitle": {
    "defaultMessage": "Usuários impersonados recentemente"
  },
  "impersonation.searchHelper": {
    "defaultMessage": "Selecione um usuário para começar a impersoná-lo."
  },
  "impersonation.searchLabel": {
    "defaultMessage": "Buscar usuário para impersonar"
  },
  "itemsViewLayout.gridCompact": {
    "defaultMessage": "Grilla compacta"
  },
  "itemsViewLayout.gridNormal": {
    "defaultMessage": "Grilla normal"
  },
  "itemsViewLayout.gridWide": {
    "defaultMessage": "Grilla amplia"
  },
  "itemsViewLayout.list": {
    "defaultMessage": "Lista"
  },
  "jointFragments.chunkLabel.edit": {
    "defaultMessage": "Editar etiqueta"
  },
  "jointFragments.chunkLabel.field": {
    "defaultMessage": "New label"
  },
  "jointFragments.chunkLabel.modalTitle": {
    "defaultMessage": "Set segment label"
  },
  "jointFragments.editorScreen.chunkActions.delete": {
    "defaultMessage": "Delete this segment"
  },
  "jointFragments.editorScreen.chunkActions.moveAfter": {
    "defaultMessage": "Mover depois"
  },
  "jointFragments.editorScreen.chunkActions.moveBefore": {
    "defaultMessage": "Mover antes"
  },
  "jointFragments.editorScreen.noChunks": {
    "defaultMessage": "No segments added yet to the fragment"
  },
  "jointFragments.editorScreen.title": {
    "defaultMessage": "Editor"
  },
  "jointFragments.editorScreen.toolbar.create": {
    "defaultMessage": "Criar fragmento"
  },
  "jointFragments.form.externalExport.allowedLabel": {
    "defaultMessage": "Export externo"
  },
  "jointFragments.overview.closeEditor": {
    "defaultMessage": "Close editor"
  },
  "jointFragments.overview.createNew": {
    "defaultMessage": "Create new fragment"
  },
  "jointFragments.overview.detailLink": {
    "defaultMessage": "View fragment detail"
  },
  "jointFragments.overview.message": {
    "defaultMessage": "Fragment was saved"
  },
  "jointFragments.props.chunk": {
    "defaultMessage": "Segmento"
  },
  "livePlayer.toggle.mode.fullscreen": {
    "defaultMessage": "Abrir em tela cheia"
  },
  "livePlayer.toggle.mode.inline": {
    "defaultMessage": "Abrir em miniatura"
  },
  "livePlayer.toggle.tooltip": {
    "defaultMessage": "Abrir LIVE"
  },
  "logger.auditControls.audioMatches": {
    "defaultMessage": "Correspondências de áudio"
  },
  "logger.auditControls.mentionMatches": {
    "defaultMessage": "Correspondências de menções"
  },
  "logger.diarization.confidence": {
    "defaultMessage": "Confiança"
  },
  "logger.downloadingSegments": {
    "defaultMessage": "Downloading segments {progress}%"
  },
  "logger.liveMentions.showMention": {
    "defaultMessage": "Show mention"
  },
  "logger.navLabel": {
    "defaultMessage": "Logger"
  },
  "logger.persons.empty": {
    "defaultMessage": "Nenhuma pessoa detectada neste intervalo"
  },
  "logger.persons.filter.all": {
    "defaultMessage": "Todas"
  },
  "logger.persons.filter.face": {
    "defaultMessage": "Com rosto"
  },
  "logger.persons.filter.unknown": {
    "defaultMessage": "Não identificadas"
  },
  "logger.persons.filter.voice": {
    "defaultMessage": "Com voz"
  },
  "logger.persons.source.face": {
    "defaultMessage": "Rosto"
  },
  "logger.persons.source.voice": {
    "defaultMessage": "Voz"
  },
  "logger.persons.table.appearances": {
    "defaultMessage": "Aparições"
  },
  "logger.persons.table.appearancesDetail": {
    "defaultMessage": "Detalhe das aparições"
  },
  "logger.persons.table.confidence": {
    "defaultMessage": "Confiança"
  },
  "logger.persons.table.onScreen": {
    "defaultMessage": "Em tela"
  },
  "logger.persons.table.sources": {
    "defaultMessage": "Fontes"
  },
  "logger.persons.table.speaking": {
    "defaultMessage": "Falando"
  },
  "logger.persons.table.timeline": {
    "defaultMessage": "Aparições no foco"
  },
  "logger.persons.track.collapse": {
    "defaultMessage": "Compactar"
  },
  "logger.persons.track.lanes": {
    "defaultMessage": "Ver por pessoa"
  },
  "logger.persons.track.title": {
    "defaultMessage": "Pessoas"
  },
  "logger.persons.unknown": {
    "defaultMessage": "Pessoa não identificada"
  },
  "logger.reports.loggerReportsTitle": {
    "defaultMessage": "Relatórios Logger"
  },
  "logger.reports.streamQuality.availability.rangeBrush.label": {
    "defaultMessage": "Ajustar intervalo"
  },
  "logger.reports.streamQuality.availability.rangeBrush.resetFullRange": {
    "defaultMessage": "Mostrar intervalo completo do relatório"
  },
  "logger.reports.streamQuality.availability.table.action.openLogger": {
    "defaultMessage": "Abrir o logger neste momento"
  },
  "logger.reports.streamQuality.availability.table.col.duration": {
    "defaultMessage": "Duração"
  },
  "logger.reports.streamQuality.availability.table.col.end": {
    "defaultMessage": "Fim"
  },
  "logger.reports.streamQuality.availability.table.col.issueType": {
    "defaultMessage": "Tipo"
  },
  "logger.reports.streamQuality.availability.table.col.start": {
    "defaultMessage": "Início"
  },
  "logger.reports.streamQuality.availability.table.col.station": {
    "defaultMessage": "Emissora"
  },
  "logger.reports.streamQuality.availability.tooltip.clickOpenLogger": {
    "defaultMessage": "Clique para abrir no Logger"
  },
  "logger.reports.streamQuality.availability.tooltip.duration": {
    "defaultMessage": "Duração: {duration}"
  },
  "logger.reports.streamQuality.availability.tooltip.gap": {
    "defaultMessage": "Sem transmissão"
  },
  "logger.reports.streamQuality.availability.tooltip.issueKind.poorQuality": {
    "defaultMessage": "Qualidade deficiente"
  },
  "logger.reports.streamQuality.availability.tooltip.issueKind.silent": {
    "defaultMessage": "Silêncio"
  },
  "logger.reports.streamQuality.availability.tooltip.range": {
    "defaultMessage": "{from} – {to}"
  },
  "logger.reports.streamQuality.emptyState.help": {
    "defaultMessage": "Escolha o intervalo e as emissoras para gerar o relatório."
  },
  "logger.reports.streamQuality.form.dateRangeLabel": {
    "defaultMessage": "Intervalo de datas"
  },
  "logger.reports.streamQuality.form.stationsLabel": {
    "defaultMessage": "Emissoras"
  },
  "logger.reports.streamQuality.form.stationsPlaceholder": {
    "defaultMessage": "Todas as estações"
  },
  "logger.reports.streamQuality.kpis.continuityIncidentDurationAvg": {
    "defaultMessage": "Duração média dos incidentes de continuidade"
  },
  "logger.reports.streamQuality.kpis.continuityIncidentsTotal": {
    "defaultMessage": "Incidentes de continuidade"
  },
  "logger.reports.streamQuality.kpis.healthScore": {
    "defaultMessage": "Pontuação de saúde"
  },
  "logger.reports.streamQuality.kpis.qualityAvgNotApplicable": {
    "defaultMessage": "—"
  },
  "logger.reports.streamQuality.kpis.qualityIncidentDurationAvg": {
    "defaultMessage": "Duração média dos incidentes de qualidade"
  },
  "logger.reports.streamQuality.kpis.qualityIncidentsTotal": {
    "defaultMessage": "Incidentes de qualidade"
  },
  "logger.reports.streamQuality.kpis.stationsWithContinuityIncidents": {
    "defaultMessage": "Estações com incidentes de continuidade"
  },
  "logger.reports.streamQuality.kpis.stationsWithIncidents": {
    "defaultMessage": "Estações com incidentes"
  },
  "logger.reports.streamQuality.kpis.stationsWithQualityIncidents": {
    "defaultMessage": "Estações com incidentes de qualidade"
  },
  "logger.reports.streamQuality.stationStatusFilter.disabledAnalysisIntervalsLegend": {
    "defaultMessage": "= Intervalo sem verificação de qualidade"
  },
  "logger.reports.streamQuality.stationStatusFilter.discontinuity": {
    "defaultMessage": "Descontinuidade"
  },
  "logger.reports.streamQuality.stationStatusFilter.filterByIncidentsLabel": {
    "defaultMessage": "Filtrar por incidentes: "
  },
  "logger.reports.streamQuality.stationStatusFilter.noIncidents": {
    "defaultMessage": "Sem incidentes"
  },
  "logger.reports.streamQuality.stationStatusFilter.noMatchingStations": {
    "defaultMessage": "Nenhuma emissora corresponde aos filtros selecionados. Escolha outra combinação."
  },
  "logger.reports.streamQuality.stationStatusFilter.poorQuality": {
    "defaultMessage": "Qualidade deficiente"
  },
  "logger.reports.streamQuality.stationStatusFilter.silent": {
    "defaultMessage": "Silêncio"
  },
  "logger.reports.streamQuality.tabLabel": {
    "defaultMessage": "Qualidade do stream"
  },
  "logger.sidenav.panorama": {
    "defaultMessage": "Panorama"
  },
  "logger.sidenav.reportes": {
    "defaultMessage": "Relatórios"
  },
  "logger.sidenav.youtube": {
    "defaultMessage": "YouTube"
  },
  "logger.status.filter.offline": {
    "defaultMessage": "Offline"
  },
  "logger.status.filter.online": {
    "defaultMessage": "Online"
  },
  "logger.statusScreen.cleanFilters": {
    "defaultMessage": "Limpar filtros"
  },
  "logger.statusScreen.count": {
    "defaultMessage": "{count, plural, =0 {No stations found} one {1 station found} other {# stations found} }"
  },
  "logger.statusScreen.enterFullscreen": {
    "defaultMessage": "Tela cheia"
  },
  "logger.statusScreen.exitFullscreen": {
    "defaultMessage": "Sair da tela cheia"
  },
  "logger.statusScreen.favoritesSection": {
    "defaultMessage": "Favoritas ({count})"
  },
  "logger.statusScreen.groupSection": {
    "defaultMessage": "{name} ({count})"
  },
  "logger.statusScreen.loading": {
    "defaultMessage": "Carregando estado do logger"
  },
  "logger.statusScreen.myStationsSection": {
    "defaultMessage": "Minhas emissoras ({count})"
  },
  "logger.statusScreen.noActivity": {
    "defaultMessage": "No recent activity registered"
  },
  "logger.statusScreen.sharedStationsSection": {
    "defaultMessage": "Emissoras externas ({count})"
  },
  "logger.statusScreen.stationAccess": {
    "defaultMessage": "Acesso às emissoras"
  },
  "logger.statusScreen.stationAccessOwned": {
    "defaultMessage": "Minhas emissoras"
  },
  "logger.statusScreen.stationAccessShared": {
    "defaultMessage": "Emissoras externas"
  },
  "logger.statusScreen.stationType": {
    "defaultMessage": "Tipo de emissora"
  },
  "logger.statusScreen.stationTypeRadio": {
    "defaultMessage": "Rádio"
  },
  "logger.statusScreen.stationTypeTv": {
    "defaultMessage": "TV"
  },
  "logger.statusScreen.stationTypeYoutube": {
    "defaultMessage": "YouTube"
  },
  "logger.statusScreen.statusActivity": {
    "defaultMessage": "Estado"
  },
  "logger.statusScreen.title": {
    "defaultMessage": "Panorama"
  },
  "logger.statusScreen.tour.viewToggle.description": {
    "defaultMessage": "Alterne entre lista e grade (ampla, normal ou compacta) para ver as estações do seu jeito."
  },
  "logger.statusScreen.tour.viewToggle.title": {
    "defaultMessage": "Visualização das estações"
  },
  "logger.statusScreen.youtubeNative.last24h": {
    "defaultMessage": "Últimas 24 horas"
  },
  "logger.statusScreen.youtubeNative.noEmissionInProgress": {
    "defaultMessage": "Nenhuma emissão em andamento"
  },
  "logger.statusScreen.youtubeNative.noRecentBroadcastsHelp": {
    "defaultMessage": "Não há transmissões registradas nas últimas 24 horas."
  },
  "logger.statusScreen.youtubeNative.offline": {
    "defaultMessage": "OFFLINE"
  },
  "logger.statusScreen.youtubeNative.peakViewersTooltip": {
    "defaultMessage": "{count} espectadores no pico"
  },
  "logger.statusScreen.youtubeNative.recentTransmissions": {
    "defaultMessage": "Transmissões Recentes"
  },
  "logger.statusScreen.youtubeNative.today": {
    "defaultMessage": "Hoje"
  },
  "logger.statusScreen.youtubeNative.yesterday": {
    "defaultMessage": "Ontem"
  },
  "logger.streamBox.goToDevice": {
    "defaultMessage": "Ir ao dispositivo"
  },
  "logger.streamScreen.audit.adOverlayLabel": {
    "defaultMessage": "Ad Overlay"
  },
  "logger.streamScreen.auditControls.adOverlay": {
    "defaultMessage": "Overlay de anúncio"
  },
  "logger.streamScreen.auditControls.youTubeViewers": {
    "defaultMessage": "Visualizadores do YouTube"
  },
  "logger.streamScreen.autoOpenFragment.never": {
    "defaultMessage": "Nunca"
  },
  "logger.streamScreen.autoOpenFragment.onStartAndEnd": {
    "defaultMessage": "Ao marcar início e fim"
  },
  "logger.streamScreen.autoOpenFragment.onStartOrEnd": {
    "defaultMessage": "Ao marcar início ou fim"
  },
  "logger.streamScreen.controls.liveIndicator": {
    "defaultMessage": "Ao vivo"
  },
  "logger.streamScreen.controls.loadLatestBtn": {
    "defaultMessage": "Ir para a transmissão atual"
  },
  "logger.streamScreen.controls.partialSegmentCoverage.tooltip": {
    "defaultMessage": "Não há emissão disponível para todo o intervalo selecionado. Apenas é mostrada a parte do intervalo em que houve transmissão. (Intervalo disponível: {fromTime} - {toTime})"
  },
  "logger.streamScreen.controls.playLive": {
    "defaultMessage": "Reproduzir stream ao vivo"
  },
  "logger.streamScreen.controls.stop": {
    "defaultMessage": "Parar"
  },
  "logger.streamScreen.controls.timeMove.back15m": {
    "defaultMessage": "-15m"
  },
  "logger.streamScreen.controls.timeMove.back1h": {
    "defaultMessage": "-1h"
  },
  "logger.streamScreen.controls.timeMove.forward15m": {
    "defaultMessage": "+15m"
  },
  "logger.streamScreen.controls.timeMove.forward1h": {
    "defaultMessage": "+1h"
  },
  "logger.streamScreen.controls.updated": {
    "defaultMessage": "Atualizado <time>{time}</time>"
  },
  "logger.streamScreen.controls.youtubeBroadcastsList": {
    "defaultMessage": "Ver todas as transmissões"
  },
  "logger.streamScreen.controls.youtubeLiveViewers": {
    "defaultMessage": "{count} visualizadores ao vivo"
  },
  "logger.streamScreen.copyCursorAt": {
    "defaultMessage": "Copiar link com marca de tempo {value}"
  },
  "logger.streamScreen.copyCursorLinkCopied": {
    "defaultMessage": "Link copiado para a área de transferência"
  },
  "logger.streamScreen.cursorMenu.cancel": {
    "defaultMessage": "Cancelar"
  },
  "logger.streamScreen.cursorMenu.endSelection": {
    "defaultMessage": "Terminar seleção aqui"
  },
  "logger.streamScreen.cursorMenu.startSelection": {
    "defaultMessage": "Iniciar seleção aqui"
  },
  "logger.streamScreen.downloadMedia.downloadError": {
    "defaultMessage": "Não foi possível obter o link de download"
  },
  "logger.streamScreen.downloadMedia.enqueueError": {
    "defaultMessage": "Não foi possível iniciar a exportação. Tente novamente."
  },
  "logger.streamScreen.downloadMedia.error": {
    "defaultMessage": "Erro ao carregar o status da exportação"
  },
  "logger.streamScreen.downloadMedia.fileGeneratedSuccessfully": {
    "defaultMessage": "Arquivo gerado corretamente"
  },
  "logger.streamScreen.downloadMedia.preparing": {
    "defaultMessage": "Preparando arquivo..."
  },
  "logger.streamScreen.focusTracks.hide": {
    "defaultMessage": "Ocultar faixa"
  },
  "logger.streamScreen.focusTracks.show": {
    "defaultMessage": "Mostrar faixa"
  },
  "logger.streamScreen.hotkeys.ADD_CHUNK_FROM_FOCUS_SELECTION.label": {
    "defaultMessage": "Adicionar seleção ao fragmento conjunto"
  },
  "logger.streamScreen.hotkeys.category.cursor": {
    "defaultMessage": "Cursor"
  },
  "logger.streamScreen.hotkeys.category.focus": {
    "defaultMessage": "Foco"
  },
  "logger.streamScreen.hotkeys.category.playback": {
    "defaultMessage": "Reprodução"
  },
  "logger.streamScreen.hotkeys.category.selection": {
    "defaultMessage": "Seleção"
  },
  "logger.streamScreen.hotkeys.CLEAR_SELECTION.label": {
    "defaultMessage": "Limpar seleção"
  },
  "logger.streamScreen.hotkeys.CREATE_FRAGMENT.label": {
    "defaultMessage": "Criar fragmento a partir da seleção"
  },
  "logger.streamScreen.hotkeys.CURSOR_BACK_1S.label": {
    "defaultMessage": "Mover cursor 1 segundo atrás"
  },
  "logger.streamScreen.hotkeys.CURSOR_BACK_5S.label": {
    "defaultMessage": "Mover cursor 5 segundos atrás"
  },
  "logger.streamScreen.hotkeys.CURSOR_FORWARD_1S.label": {
    "defaultMessage": "Mover cursor 1 segundo adiante"
  },
  "logger.streamScreen.hotkeys.CURSOR_FORWARD_5S.label": {
    "defaultMessage": "Mover cursor 5 segundos adiante"
  },
  "logger.streamScreen.hotkeys.DECREMENT_CURSOR_SELECTION.label": {
    "defaultMessage": "Reduzir intervalo de seleção 5 segundos"
  },
  "logger.streamScreen.hotkeys.DOWNLOAD_AUDIO_SELECTION_VIDEO_ONLY.label": {
    "defaultMessage": "Baixar áudio da seleção (apenas em emissoras de vídeo)"
  },
  "logger.streamScreen.hotkeys.DOWNLOAD_SELECTION.label": {
    "defaultMessage": "Baixar seleção"
  },
  "logger.streamScreen.hotkeys.END_CURSOR_SELECTION.label": {
    "defaultMessage": "Terminar seleção a partir do cursor"
  },
  "logger.streamScreen.hotkeys.END_PLAY_TS_SELECTION.label": {
    "defaultMessage": "Terminar seleção a partir do tempo atual"
  },
  "logger.streamScreen.hotkeys.FOCUS_BACK_5M.label": {
    "defaultMessage": "Mover foco 5 minutos atrás"
  },
  "logger.streamScreen.hotkeys.FOCUS_FORWARD_5M.label": {
    "defaultMessage": "Mover foco 5 minutos adiante"
  },
  "logger.streamScreen.hotkeys.FOCUS_FULL_IN.label": {
    "defaultMessage": "Zoom completo em cursor ou seleção"
  },
  "logger.streamScreen.hotkeys.FOCUS_FULL_OUT.label": {
    "defaultMessage": "Zoom completo para fora"
  },
  "logger.streamScreen.hotkeys.FOCUS_ZOOM_SELECTION_IN.label": {
    "defaultMessage": "Zoom no início da seleção"
  },
  "logger.streamScreen.hotkeys.FOCUS_ZOOM_SELECTION_OUT.label": {
    "defaultMessage": "Zoom no final da seleção"
  },
  "logger.streamScreen.hotkeys.INCREMENT_CURSOR_SELECTION.label": {
    "defaultMessage": "Aumentar intervalo de seleção 5 segundos"
  },
  "logger.streamScreen.hotkeys.PLAY_PAUSE.label": {
    "defaultMessage": "Reproduzir / pausar"
  },
  "logger.streamScreen.hotkeys.START_CURSOR_SELECTION.label": {
    "defaultMessage": "Iniciar seleção a partir do cursor"
  },
  "logger.streamScreen.hotkeys.START_PLAY_TS_SELECTION.label": {
    "defaultMessage": "Iniciar seleção a partir do tempo atual"
  },
  "logger.streamScreen.hotkeys.STREAM_BACK_1H.label": {
    "defaultMessage": "Mover foco 1 hora atrás"
  },
  "logger.streamScreen.hotkeys.STREAM_FORWARD_1H.label": {
    "defaultMessage": "Mover foco 1 hora adiante"
  },
  "logger.streamScreen.hotkeys.ZOOM_IN_FOCUS.label": {
    "defaultMessage": "Zoom in no foco"
  },
  "logger.streamScreen.hotkeys.ZOOM_OUT_FOCUS.label": {
    "defaultMessage": "Zoom out no foco"
  },
  "logger.streamScreen.liveTopic.comesFrom": {
    "defaultMessage": "Vem de: "
  },
  "logger.streamScreen.liveTopics.entities.orgs": {
    "defaultMessage": "Organizações"
  },
  "logger.streamScreen.liveTopics.entities.people": {
    "defaultMessage": "Pessoas"
  },
  "logger.streamScreen.liveTopics.entities.places": {
    "defaultMessage": "Lugares"
  },
  "logger.streamScreen.liveTopics.noTopicsForRange": {
    "defaultMessage": "Nenhum tópico detectado para este intervalo"
  },
  "logger.streamScreen.liveTopics.panel.categoryFilterLabel": {
    "defaultMessage": "Categoria"
  },
  "logger.streamScreen.liveTopics.panel.categoryFilterPlaceholder": {
    "defaultMessage": "Todas as categorias"
  },
  "logger.streamScreen.liveTopics.panel.goTo": {
    "defaultMessage": "Ir"
  },
  "logger.streamScreen.liveTopics.panel.itemDeveloping": {
    "defaultMessage": "Em desenvolvimento"
  },
  "logger.streamScreen.liveTopics.panel.itemNew": {
    "defaultMessage": "Novo"
  },
  "logger.streamScreen.liveTopics.panel.keyPoints": {
    "defaultMessage": "Pontos principais"
  },
  "logger.streamScreen.liveTopics.panel.loadMoreOtherDay": {
    "defaultMessage": "Mostrar anteriores a {date} {time}"
  },
  "logger.streamScreen.liveTopics.panel.loadMoreToday": {
    "defaultMessage": "Mostrar anteriores às {time}"
  },
  "logger.streamScreen.liveTopics.panel.newTopics": {
    "defaultMessage": "{count, plural, one {# tema novo} other {# temas novos}}"
  },
  "logger.streamScreen.liveTopics.panel.openPanel": {
    "defaultMessage": "Live Topics"
  },
  "logger.streamScreen.liveTopics.panel.textFilterClearButton": {
    "defaultMessage": "Limpar busca"
  },
  "logger.streamScreen.liveTopics.panel.textFilterLabel": {
    "defaultMessage": "Texto"
  },
  "logger.streamScreen.liveTopics.panel.title": {
    "defaultMessage": "Live Topics"
  },
  "logger.streamScreen.liveTopics.popup.openInPanel": {
    "defaultMessage": "Ver mais detalhes"
  },
  "logger.streamScreen.liveTopics.track.title": {
    "defaultMessage": "Live Topics"
  },
  "logger.streamScreen.modes.defaultMode": {
    "defaultMessage": "Modo padrão"
  },
  "logger.streamScreen.modes.editorMode": {
    "defaultMessage": "Modo editor"
  },
  "logger.streamScreen.screenSettings.autoOpenFragment": {
    "defaultMessage": "Abrir criação de fragmento ao selecionar (modo padrão)"
  },
  "logger.streamScreen.screenSettings.btn": {
    "defaultMessage": "Settings"
  },
  "logger.streamScreen.screenSettings.keepSelectionOnRangeChange": {
    "defaultMessage": "Manter seleção ao mudar o intervalo"
  },
  "logger.streamScreen.screenSettings.playOnCursorSet": {
    "defaultMessage": "Reproduzir ao marcar"
  },
  "logger.streamScreen.screenSettings.screenMode": {
    "defaultMessage": "Screen mode"
  },
  "logger.streamScreen.screenSettings.tooltip": {
    "defaultMessage": "Configurações de tela"
  },
  "logger.streamScreen.selection.clear": {
    "defaultMessage": "Limpar seleção"
  },
  "logger.streamScreen.selectionMenu.copyQuickShare": {
    "defaultMessage": "Copiar URL Quick Share"
  },
  "logger.streamScreen.selectionMenu.copyQuickShareDone": {
    "defaultMessage": "URL Quick Share copiada"
  },
  "logger.streamScreen.selectionMenu.createFragment": {
    "defaultMessage": "Criar fragmento"
  },
  "logger.streamScreen.selectionMenu.unselect": {
    "defaultMessage": "Desmarcar"
  },
  "logger.youtubeBroadcasts.noYoutubeNativeStations": {
    "defaultMessage": "Não há emissoras com integração YouTube Native"
  },
  "logger.youtubeBroadcasts.pageTitle": {
    "defaultMessage": "Transmissões do YouTube"
  },
  "logger.youtubePanorama.noRecentBroadcasts": {
    "defaultMessage": "Sem transmissões recentes"
  },
  "logger.youtubePanorama.recentTransmissionsTitle": {
    "defaultMessage": "Últimas transmissões"
  },
  "logger.youtubePanorama.recentTransmissionTitle": {
    "defaultMessage": "Última transmissão"
  },
  "logger.youtubePanorama.viewAll": {
    "defaultMessage": "Ver todas as transmissões"
  },
  "logger.youtubeStats.legend.channels": {
    "defaultMessage": "Canais"
  },
  "logger.youtubeStats.legend.otherChannels": {
    "defaultMessage": "Outros canais"
  },
  "logger.youtubeStats.legend.ownChannel": {
    "defaultMessage": "Canal próprio"
  },
  "logger.youtubeStats.legend.selectAll": {
    "defaultMessage": "Selecionar todos"
  },
  "logger.youtubeStats.legend.selectNone": {
    "defaultMessage": "Selecionar nenhum"
  },
  "logger.youtubeStats.noDataForPeriod": {
    "defaultMessage": "Nenhum dado disponível para este período"
  },
  "logger.youtubeStats.openYoutubeAtThisMoment": {
    "defaultMessage": "Clique para ir ao YouTube neste momento"
  },
  "modulesAdminLocaleEs.m.admin.groups.addScreen.title": {
    "defaultMessage": "Criar novo grupo"
  },
  "modulesAdminLocaleEs.m.admin.groups.editScreen.title": {
    "defaultMessage": "Editar grupo"
  },
  "notifications.feed.archive": {
    "defaultMessage": "Arquivar"
  },
  "notifications.feed.filterAll": {
    "defaultMessage": "Todas"
  },
  "notifications.feed.filterRead": {
    "defaultMessage": "Lidas"
  },
  "notifications.feed.filterUnread": {
    "defaultMessage": "Não lidas"
  },
  "notifications.feed.loadMore": {
    "defaultMessage": "Carregar mais"
  },
  "notifications.feed.markAllRead": {
    "defaultMessage": "Marcar todas como lidas"
  },
  "notifications.feed.title": {
    "defaultMessage": "Notificações"
  },
  "notifications.item.fallbackTitle": {
    "defaultMessage": "Notificação"
  },
  "notifications.item.openVideo": {
    "defaultMessage": "Ver vídeo"
  },
  "notifications.item.download": {
    "defaultMessage": "Baixar"
  },
  "notifications.preferences.category.audit": {
    "defaultMessage": "Auditoria"
  },
  "notifications.preferences.category.fragments": {
    "defaultMessage": "Fragmentos"
  },
  "notifications.preferences.category.socialUpload": {
    "defaultMessage": "Redes"
  },
  "notifications.preferences.channel.email": {
    "defaultMessage": "E-mail"
  },
  "notifications.preferences.channel.inApp": {
    "defaultMessage": "No app"
  },
  "notifications.preferences.saveError": {
    "defaultMessage": "Não foi possível salvar as preferências"
  },
  "notifications.preferences.title": {
    "defaultMessage": "Preferências de notificações"
  },
  "notifications.preferences.unavailable": {
    "defaultMessage": "As preferências de notificações não estão disponíveis."
  },
  "notifications.preferences.workflow.aodDeficiencyBreached.description": {
    "defaultMessage": "Quando uma execução de AOD não atinge o limiar mínimo de eficiência"
  },
  "notifications.preferences.workflow.aodDeficiencyBreached.title": {
    "defaultMessage": "Eficiência AOD insuficiente"
  },
  "notifications.preferences.workflow.evidenceExportCompleted.description": {
    "defaultMessage": "Quando o pacote de evidências de um relatório está pronto"
  },
  "notifications.preferences.workflow.evidenceExportCompleted.title": {
    "defaultMessage": "Evidências prontas para baixar"
  },
  "notifications.preferences.workflow.socialUploadCompleted.description": {
    "defaultMessage": "Quando um vídeo é publicado corretamente em uma rede social"
  },
  "notifications.preferences.workflow.socialUploadCompleted.title": {
    "defaultMessage": "Publicação bem-sucedida"
  },
  "notifications.preferences.workflow.socialUploadFailed.description": {
    "defaultMessage": "Quando falha a publicação de um vídeo em uma rede social"
  },
  "notifications.preferences.workflow.socialUploadFailed.title": {
    "defaultMessage": "Erro ao publicar"
  },
  "notifications.toast.close": {
    "defaultMessage": "Fechar"
  },
  "notifications.toast.story.showAgain": {
    "defaultMessage": "Mostrar de novo"
  },
  "notifications.toast.viewLink": {
    "defaultMessage": "Ver"
  },
  "notifications.tour.bell.description": {
    "defaultMessage": "Centralizamos o status dos seus exports, relatórios e alertas do sistema. Clique no sino para revisar sua atividade recente."
  },
  "notifications.tour.bell.title": {
    "defaultMessage": "Central de notificações"
  },
  "notifications.tour.demo.aod.body": {
    "defaultMessage": "Foi detectada uma deficiência na pauta programada."
  },
  "notifications.tour.demo.aod.title": {
    "defaultMessage": "Deficiência AOD: Campanha de verão"
  },
  "notifications.tour.demo.export.title": {
    "defaultMessage": "Exportação de evidências pronta"
  },
  "notifications.tour.demo.time.hourAgo": {
    "defaultMessage": "há 1 hora"
  },
  "notifications.tour.demo.time.recent": {
    "defaultMessage": "há 5 minutos"
  },
  "notifications.tour.demo.time.yesterday": {
    "defaultMessage": "ontem"
  },
  "notifications.tour.demo.upload.title": {
    "defaultMessage": "Publicação no Youtube concluída"
  },
  "notifications.tour.feed.description": {
    "defaultMessage": "Filtre, leia ou arquive seus alertas daqui. Use o ícone de engrenagem (⚙️) para personalizar quais avisos deseja receber."
  },
  "notifications.tour.feed.title": {
    "defaultMessage": "Gerencie suas notificações"
  },
  "permissions.empty.description": {
    "defaultMessage": "No permissions are available."
  },
  "permissions.empty.title": {
    "defaultMessage": "No permissions found"
  },
  "permissions.error.description": {
    "defaultMessage": "There was an error loading the permissions. Please try again."
  },
  "permissions.error.title": {
    "defaultMessage": "Error loading permissions"
  },
  "playback.rangeWaveformPlayer.noSegments": {
    "defaultMessage": "Não há áudio disponível para este intervalo."
  },
  "search.contactAdmin": {
    "defaultMessage": "Entre em contato com seu administrador"
  },
  "search.dateTime": {
    "defaultMessage": "Hora"
  },
  "search.featureNotAvailable": {
    "defaultMessage": "Este recurso não está disponível para"
  },
  "search.helpFistLine": {
    "defaultMessage": "For advanced search operations:"
  },
  "search.helpPlusOp": {
    "defaultMessage": "The symbol + corresponds to the logical operator AND"
  },
  "search.helpVertialBarOp": {
    "defaultMessage": "The symbol | corresponds to the logical operator OR`"
  },
  "search.preview": {
    "defaultMessage": "Visualizar"
  },
  "search.title": {
    "defaultMessage": "Pesquisar"
  },
  "search.transcription": {
    "defaultMessage": "Transcrição"
  },
  "segments.listScreen.futureRange": {
    "defaultMessage": "O intervalo selecionado é futuro"
  },
  "segments.listScreen.futureRange.help": {
    "defaultMessage": "Selecione um intervalo anterior para ver a emissão."
  },
  "segments.listScreen.noSegments": {
    "defaultMessage": "Sem emissão"
  },
  "segments.listScreen.noSegments.help": {
    "defaultMessage": "Tente alterar o intervalo de tempo selecionado."
  },
  "segments.listScreen.tooRecentRange": {
    "defaultMessage": "O intervalo é muito recente"
  },
  "segments.listScreen.tooRecentRange.help": {
    "defaultMessage": "Selecione um intervalo de pelo menos {minutes} minutos antes do momento atual."
  },
  "settings.userSettings.form.name.label": {
    "defaultMessage": "Name"
  },
  "settings.userSettings.form.surname.label": {
    "defaultMessage": "Surname"
  },
  "settings.userSettings.title": {
    "defaultMessage": "Configurações do usuário"
  },
  "socialExport.connect": {
    "defaultMessage": "Conectar"
  },
  "socialExport.connectAlternatives.dialogTitle": {
    "defaultMessage": "Escolha como conectar a {platform}"
  },
  "socialExport.connectAlternatives.permissionsLabel": {
    "defaultMessage": "Permissões"
  },
  "socialExport.connectAlternatives.recommendedBadge": {
    "defaultMessage": "Recomendado"
  },
  "socialExport.connectAlternatives.redirecting": {
    "defaultMessage": "Redirecionando para {platform} para conectar..."
  },
  "socialExport.connections.accountIdentification": {
    "defaultMessage": "Identificação da conta"
  },
  "socialExport.connections.connectedAccounts": {
    "defaultMessage": "Contas conectadas"
  },
  "socialExport.connections.connectedByPrefix": {
    "defaultMessage": "Conectado por"
  },
  "socialExport.connections.customName": {
    "defaultMessage": "Nome personalizado"
  },
  "socialExport.connections.customNameHelper": {
    "defaultMessage": "Opcional. Útil se houver mais de uma conexão ao mesmo perfil."
  },
  "socialExport.connections.defaultConnectionName": {
    "defaultMessage": "Padrão"
  },
  "socialExport.connections.disconnectConfirmDescription": {
    "defaultMessage": "Você está prestes a desconectar esta integração. Tem certeza?"
  },
  "socialExport.connections.disconnectWithStationsWarning": {
    "defaultMessage": "Esta conta está vinculada a {count, plural, one {# emissora} other {# emissoras}}. Ao desconectar, essas emissoras deixarão de poder publicar com ela. Tem certeza?"
  },
  "socialExport.connections.empty": {
    "defaultMessage": "Não há contas conectadas"
  },
  "socialExport.connections.emptyHelp": {
    "defaultMessage": "Conecte uma conta para começar a publicar nesta plataforma."
  },
  "socialExport.connections.linkedStationsCount": {
    "defaultMessage": "{count, plural, =0 {Nenhuma emissora vinculada} one {# emissora vinculada} other {# emissoras vinculadas}}"
  },
  "socialExport.connections.noLinkedStations": {
    "defaultMessage": "Ainda não há emissoras vinculadas"
  },
  "socialExport.connections.noneAssignedForStation": {
    "defaultMessage": "Não há contas conectadas atribuídas a esta emissora para esta plataforma."
  },
  "socialExport.connections.connectionDetail": {
    "defaultMessage": "Detalhe"
  },
  "socialExport.connections.selectConnection": {
    "defaultMessage": "Selecione uma conta para ver os detalhes"
  },
  "socialExport.connections.selectForPublish": {
    "defaultMessage": "Conta de publicação"
  },
  "socialExport.connections.selectStations": {
    "defaultMessage": "Emissoras"
  },
  "socialExport.connections.selectStationsHelper": {
    "defaultMessage": "Somente estas emissoras poderão publicar com esta conta."
  },
  "socialExport.connections.selectStationsPlaceholder": {
    "defaultMessage": "Selecione uma ou mais emissoras"
  },
  "socialExport.connections.settingsTitle": {
    "defaultMessage": "Configurar {name}"
  },
  "socialExport.connections.stationsPublishingWithAccount": {
    "defaultMessage": "Emissoras vinculadas"
  },
  "socialExport.connectionSuccess.linkStations": {
    "defaultMessage": "Vincule emissoras a esta conta e configure os valores padrão."
  },
  "socialExport.connectionSuccess.title": {
    "defaultMessage": "Conexão bem-sucedida com {name}"
  },
  "socialExport.dailymotion.apiKey": {
    "defaultMessage": "Chave API"
  },
  "socialExport.dailymotion.apiSecret": {
    "defaultMessage": "Segredo API"
  },
  "socialExport.dailymotion.channel.animals": {
    "defaultMessage": "Animais"
  },
  "socialExport.dailymotion.channel.auto": {
    "defaultMessage": "Automóveis"
  },
  "socialExport.dailymotion.channel.creation": {
    "defaultMessage": "Criação"
  },
  "socialExport.dailymotion.channel.fun": {
    "defaultMessage": "Diversão"
  },
  "socialExport.dailymotion.channel.kids": {
    "defaultMessage": "Crianças"
  },
  "socialExport.dailymotion.channel.lifestyle": {
    "defaultMessage": "Estilo de vida"
  },
  "socialExport.dailymotion.channel.music": {
    "defaultMessage": "Música"
  },
  "socialExport.dailymotion.channel.news": {
    "defaultMessage": "Notícias"
  },
  "socialExport.dailymotion.channel.people": {
    "defaultMessage": "Pessoas"
  },
  "socialExport.dailymotion.channel.school": {
    "defaultMessage": "Escola"
  },
  "socialExport.dailymotion.channel.shortfilms": {
    "defaultMessage": "Curtas-metragens"
  },
  "socialExport.dailymotion.channel.sport": {
    "defaultMessage": "Desporto"
  },
  "socialExport.dailymotion.channel.tech": {
    "defaultMessage": "Tecnologia"
  },
  "socialExport.dailymotion.channel.travel": {
    "defaultMessage": "Viagens"
  },
  "socialExport.dailymotion.channel.tv": {
    "defaultMessage": "TV"
  },
  "socialExport.dailymotion.channel.videogames": {
    "defaultMessage": "Videojogos"
  },
  "socialExport.dailymotion.channel.webcam": {
    "defaultMessage": "Webcam"
  },
  "socialExport.dailymotion.channelId": {
    "defaultMessage": "ID do canal"
  },
  "socialExport.dailymotion.channelIdHelper": {
    "defaultMessage": "Identificador de 7 caracteres"
  },
  "socialExport.dailymotion.connect.apiKeyDescription": {
    "defaultMessage": "Informe key, secret e ID do canal no Dailymotion Studio. Ideal para organizações."
  },
  "socialExport.dailymotion.connect.apiKeyName": {
    "defaultMessage": "API key privada"
  },
  "socialExport.dailymotion.connect.loginDescription": {
    "defaultMessage": "Redirecionamos você ao Dailymotion para iniciar sessão e autorizar o acesso ao seu canal."
  },
  "socialExport.dailymotion.connect.loginName": {
    "defaultMessage": "Conta Dailymotion"
  },
  "socialExport.dailymotion.connectApiKeyTitle": {
    "defaultMessage": "Conectar Dailymotion via API key"
  },
  "socialExport.facebook.connect.businessDescription": {
    "defaultMessage": "Publicar a partir de contas Facebook Business"
  },
  "socialExport.facebook.connect.businessName": {
    "defaultMessage": "Facebook Business"
  },
  "socialExport.facebook.connect.businessPermissions": {
    "defaultMessage": "Acesso a páginas via Facebook Business. IMPORTANTE: ao conceder permissões ao aplicativo, dê acesso apenas à página na qual deseja publicar."
  },
  "socialExport.facebook.connect.standardDescription": {
    "defaultMessage": "Publicar em páginas do Facebook"
  },
  "socialExport.facebook.connect.standardName": {
    "defaultMessage": "Facebook"
  },
  "socialExport.facebook.connect.standardPermissions": {
    "defaultMessage": "Acesso a páginas. IMPORTANTE: ao conceder permissões ao aplicativo, dê acesso apenas à página na qual deseja publicar."
  },
  "socialExport.form.category": {
    "defaultMessage": "Categoria"
  },
  "socialExport.form.commaSeparatedValues": {
    "defaultMessage": "Valores separados por vírgula"
  },
  "socialExport.form.content": {
    "defaultMessage": "Conteúdo"
  },
  "socialExport.form.defaultValuesUploads": {
    "defaultMessage": "Valores padrão para uploads"
  },
  "socialExport.form.deleteDelay": {
    "defaultMessage": "Atraso de exclusão (ms)"
  },
  "socialExport.form.deleteDelayHelper": {
    "defaultMessage": "Tempo de espera antes de excluir (0-60000 ms, padrão: 2000)"
  },
  "socialExport.form.demoConfig": {
    "defaultMessage": "Configuração de demonstração"
  },
  "socialExport.form.demoData": {
    "defaultMessage": "Dados de demonstração"
  },
  "socialExport.form.description": {
    "defaultMessage": "Descrição"
  },
  "socialExport.form.forKids": {
    "defaultMessage": "Conteúdo adequado para crianças"
  },
  "socialExport.form.idsSeparatedByComma": {
    "defaultMessage": "IDs separados por vírgula"
  },
  "socialExport.form.platform": {
    "defaultMessage": "Plataforma"
  },
  "socialExport.form.publishDateLabel": {
    "defaultMessage": "Data e hora de publicação"
  },
  "socialExport.form.publishDelay": {
    "defaultMessage": "Atraso de publicação (ms)"
  },
  "socialExport.form.publishDelayHelper": {
    "defaultMessage": "Tempo de espera antes de publicar (0-60000 ms, padrão: 10000)"
  },
  "socialExport.form.publishImmediately": {
    "defaultMessage": "Publicar imediatamente"
  },
  "socialExport.form.publishToFeed": {
    "defaultMessage": "Publicar também no feed"
  },
  "socialExport.form.replyConfig": {
    "defaultMessage": "Configuração de respostas"
  },
  "socialExport.form.schedule": {
    "defaultMessage": "Agendamento"
  },
  "socialExport.form.scheduling": {
    "defaultMessage": "Agendamento"
  },
  "socialExport.form.settings": {
    "defaultMessage": "Parâmetros de publicação"
  },
  "socialExport.form.shareToFeed": {
    "defaultMessage": "Compartilhar também no feed"
  },
  "socialExport.form.taggedUsers": {
    "defaultMessage": "Usuários marcados"
  },
  "socialExport.form.tags": {
    "defaultMessage": "Tags"
  },
  "socialExport.form.thumbnail": {
    "defaultMessage": "Miniatura"
  },
  "socialExport.form.thumbnailAndSettings": {
    "defaultMessage": "Miniatura e ajustes"
  },
  "socialExport.form.title": {
    "defaultMessage": "Título"
  },
  "socialExport.form.unsavedChangesLeavePrompt": {
    "defaultMessage": "Tem certeza de que deseja sair? As alterações não salvas serão perdidas."
  },
  "socialExport.form.uploadAsPrivate": {
    "defaultMessage": "Carregar como vídeo privado"
  },
  "socialExport.history": {
    "defaultMessage": "Histórico"
  },
  "socialExport.manage.configure": {
    "defaultMessage": "Configurar"
  },
  "socialExport.manage.disconnect": {
    "defaultMessage": "Desconectar"
  },
  "socialExport.mediaLimits.blocked": {
    "defaultMessage": "O vídeo excede a duração máxima permitida pela plataforma."
  },
  "socialExport.mediaLimits.blockedWithMax": {
    "defaultMessage": "O vídeo excede a duração máxima permitida pela plataforma ({maxMinutes} min)."
  },
  "socialExport.mediaLimits.needsTranscoding": {
    "defaultMessage": "O tamanho do vídeo excede o limite da plataforma; será reduzido para {quality}p para poder publicá-lo."
  },
  "socialExport.mediaLimits.platformDisplaysLower": {
    "defaultMessage": "{platformName} o exibirá em até {quality}p."
  },
  "socialExport.publish.chip.cancelled": {
    "defaultMessage": "Cancelado"
  },
  "socialExport.publish.chip.error": {
    "defaultMessage": "Erro"
  },
  "socialExport.publish.chip.errorCode": {
    "defaultMessage": "Código: {errorCode}"
  },
  "socialExport.publish.chip.inProgress": {
    "defaultMessage": "Em andamento"
  },
  "socialExport.publish.chip.published": {
    "defaultMessage": "Publicado"
  },
  "socialExport.publish.chip.scheduled": {
    "defaultMessage": "Programado"
  },
  "socialExport.publish.chip.waitingForMedia": {
    "defaultMessage": "Aguardando mídia"
  },
  "socialExport.publish.connectionNotReady": {
    "defaultMessage": "A conexão com a rede social ainda está carregando; tenta novamente em instantes."
  },
  "socialExport.publish.createdBy": {
    "defaultMessage": "Criado por {user}"
  },
  "socialExport.publish.deleteFromPlatform": {
    "defaultMessage": "Excluir de {platform}"
  },
  "socialExport.publish.deleteScheduledPublishMessage": {
    "defaultMessage": "Tem certeza de que deseja excluir esta publicação agendada? Esta ação não pode ser desfeita."
  },
  "socialExport.publish.deleteScheduledPublishTitle": {
    "defaultMessage": "Excluir publicação agendada"
  },
  "socialExport.publish.deleteVideoFromPlatformMessage": {
    "defaultMessage": "Tem certeza de que deseja excluir este vídeo da plataforma? Esta ação não pode ser desfeita."
  },
  "socialExport.publish.deleteVideoFromPlatformTitle": {
    "defaultMessage": "Excluir vídeo de {platform}"
  },
  "socialExport.publish.editionWithName": {
    "defaultMessage": "Edit: {name}"
  },
  "socialExport.publish.error.youtubeReconnectRequired": {
    "defaultMessage": "As credenciais do YouTube estão desatualizadas. É necessário reconectar a conta."
  },
  "socialExport.publish.errorDeletingPublication": {
    "defaultMessage": "Ocorreu um erro ao excluir a publicação"
  },
  "socialExport.publish.errorDeletingVideo": {
    "defaultMessage": "Ocorreu um erro ao excluir o vídeo"
  },
  "socialExport.publish.errorPublishingNow": {
    "defaultMessage": "Ocorreu um erro ao publicar imediatamente"
  },
  "socialExport.publish.forKidsDescription": {
    "defaultMessage": "Aplicam-se as restrições de conteúdo para menores da plataforma."
  },
  "socialExport.publish.manageVideo": {
    "defaultMessage": "Gerenciar vídeo em {platform}"
  },
  "socialExport.publish.mediaSelector.edition": {
    "defaultMessage": "Edit"
  },
  "socialExport.publish.mediaSelector.label": {
    "defaultMessage": "Vídeo a publicar"
  },
  "socialExport.publish.mediaSelector.originalMedia": {
    "defaultMessage": "Mídia original"
  },
  "socialExport.publish.mediaSelector.renderNotReadyComposition": {
    "defaultMessage": "O vídeo desta edição ainda não foi gerado. Gere-o na aba Edits."
  },
  "socialExport.publish.mediaSelector.renderNotReadyFragment": {
    "defaultMessage": "O vídeo deste edit ainda não foi gerado. Gere-o na aba edits."
  },
  "socialExport.publish.noAdditionalActions": {
    "defaultMessage": "A plataforma não permite nenhuma ação adicional"
  },
  "socialExport.publish.noAllowedSourceError": {
    "defaultMessage": "Não há uma fonte disponível para publicar nesta estação."
  },
  "socialExport.publish.noOAuthConnectionForPlatform": {
    "defaultMessage": "{platformName} não está conectado para esta estação."
  },
  "socialExport.publish.noPlatformsToPublish": {
    "defaultMessage": "Sem plataformas para publicar"
  },
  "socialExport.publish.noRenderedEdit": {
    "defaultMessage": "Não há edição com vídeo gerado para publicar."
  },
  "socialExport.publish.noStation": {
    "defaultMessage": "A composição não tem estação atribuída."
  },
  "socialExport.publish.panorama.goToEdits": {
    "defaultMessage": "Ir para edits"
  },
  "socialExport.publish.panorama.noConnectedPlatforms": {
    "defaultMessage": "Não há plataformas ligadas para publicar."
  },
  "socialExport.publish.panorama.noSourcesComposition": {
    "defaultMessage": "Para publicar nas redes sociais é necessário gerar um vídeo a partir de uma edição de vídeo."
  },
  "socialExport.publish.panorama.noSourcesFragment": {
    "defaultMessage": "Para publicar nas redes sociais, é necessário gerar um vídeo a partir do fragmento."
  },
  "socialExport.publish.panorama.notPublishedComposition": {
    "defaultMessage": "Você ainda não publicou esta composição nas redes sociais."
  },
  "socialExport.publish.panorama.notPublishedFragment": {
    "defaultMessage": "Você ainda não publicou este fragmento nas redes sociais."
  },
  "socialExport.publish.platformSwitcherLabel": {
    "defaultMessage": "Plataforma"
  },
  "socialExport.publish.postPublishProcessingNotice": {
    "defaultMessage": "Após publicar, o conteúdo pode levar alguns minutos para ser processado e aparecer no seu perfil."
  },
  "socialExport.publish.publicationDeleted": {
    "defaultMessage": "Publicação excluída"
  },
  "socialExport.publish.publicationsSectionTitle": {
    "defaultMessage": "Publicações ({count})"
  },
  "socialExport.publish.publicationStarted": {
    "defaultMessage": "Publicação iniciada"
  },
  "socialExport.publish.publishedOn": {
    "defaultMessage": "Publicado em:"
  },
  "socialExport.publish.publishImmediatelyDescription": {
    "defaultMessage": "Desative para escolher uma data e hora de publicação futura"
  },
  "socialExport.publish.publishNow": {
    "defaultMessage": "Publicar agora"
  },
  "socialExport.publish.publishNowConfirmMessage": {
    "defaultMessage": "Tem certeza de que deseja publicar este vídeo agora em vez de aguardar a data agendada?"
  },
  "socialExport.publish.publishNowConfirmTitle": {
    "defaultMessage": "Publicar agora"
  },
  "socialExport.publish.publishTo": {
    "defaultMessage": "Publicar em"
  },
  "socialExport.publish.publishToSectionTitle": {
    "defaultMessage": "Publicar em"
  },
  "socialExport.publish.publishToSocialNetworks": {
    "defaultMessage": "Publicar nas redes sociais"
  },
  "socialExport.publish.retry": {
    "defaultMessage": "Tentar novamente"
  },
  "socialExport.publish.scheduledAlertTitle": {
    "defaultMessage": "Publicação agendada"
  },
  "socialExport.publish.sectionTitle": {
    "defaultMessage": "Redes sociais"
  },
  "socialExport.publish.sendToPlatform": {
    "defaultMessage": "Publicar em {platformName}"
  },
  "socialExport.publish.shareToFeedDescription": {
    "defaultMessage": "Além do reel, a publicação aparecerá no feed principal da conta."
  },
  "socialExport.publish.startPublicationError": {
    "defaultMessage": "Ocurrió un error al iniciar la publicación, contacte a soporte"
  },
  "socialExport.publish.uploadAsPrivateDescription": {
    "defaultMessage": "O vídeo fica visível apenas na conta até ser publicado publicamente"
  },
  "socialExport.publish.uploadDetail.publishedTitle": {
    "defaultMessage": "Publicado"
  },
  "socialExport.publish.videoDeletedFromPlatform": {
    "defaultMessage": "Vídeo excluído da plataforma"
  },
  "socialExport.publish.videoPreview.title": {
    "defaultMessage": "Pré-visualização do vídeo"
  },
  "socialExport.publish.videoWillPublishAt": {
    "defaultMessage": "O vídeo será publicado em:"
  },
  "socialExport.publish.viewVideo": {
    "defaultMessage": "Ver vídeo"
  },
  "socialExport.publish.waitingPublicLink": {
    "defaultMessage": "Aguardando link público"
  },
  "socialExport.select.none": {
    "defaultMessage": "Nenhum"
  },
  "socialExport.settings.updated": {
    "defaultMessage": "Configuração atualizada com sucesso"
  },
  "socialExport.rudo.accessToken": {
    "defaultMessage": "Access token"
  },
  "socialExport.rudo.accessTokenHelper": {
    "defaultMessage": "Token estático da sua conta Rudo.video"
  },
  "socialExport.rudo.connectApiKeyTitle": {
    "defaultMessage": "Conectar Rudo com access token"
  },
  "socialExport.rudo.displayName": {
    "defaultMessage": "Nome de exibição"
  },
  "socialExport.rudo.displayNameHelper": {
    "defaultMessage": "Opcional. Útil se conectar mais de uma conta Rudo."
  },
  "socialExport.rudo.folder.create": {
    "defaultMessage": "Criar pasta"
  },
  "socialExport.rudo.folder.createCancel": {
    "defaultMessage": "Cancelar"
  },
  "socialExport.rudo.folder.createSubmit": {
    "defaultMessage": "Criar"
  },
  "socialExport.rudo.folder.createSuccess": {
    "defaultMessage": "Pasta criada"
  },
  "socialExport.rudo.folder.createTitle": {
    "defaultMessage": "Nova pasta"
  },
  "socialExport.rudo.folder.helper": {
    "defaultMessage": "Pasta de destino no Rudo"
  },
  "socialExport.rudo.folder.label": {
    "defaultMessage": "Pasta"
  },
  "socialExport.rudo.folder.name": {
    "defaultMessage": "Nome da pasta"
  },
  "socialExport.rudo.folder.noOptions": {
    "defaultMessage": "Nenhuma pasta disponível"
  },
  "socialExport.rudo.restriction.label": {
    "defaultMessage": "Restrição VOD"
  },
  "socialExport.rudo.restriction.none": {
    "defaultMessage": "Sem restrição"
  },
  "socialExport.rudo.restriction.premium": {
    "defaultMessage": "Premium"
  },
  "socialExport.rudo.restriction.registration": {
    "defaultMessage": "Apenas registrados"
  },
  "socialExport.tiktok.disclosure.brandedContent.description": {
    "defaultMessage": "Você está promovendo outra marca ou um terceiro. Este vídeo será classificado como Conteúdo de marca."
  },
  "socialExport.tiktok.disclosure.brandedContent.label": {
    "defaultMessage": "Conteúdo de marca"
  },
  "socialExport.tiktok.disclosure.brandedContentAndMusicAgree": {
    "defaultMessage": "Ao publicar, concorda com a {brandedContentLink} e a {musicLink} do TikTok."
  },
  "socialExport.tiktok.disclosure.brandedContentPolicyLink": {
    "defaultMessage": "Política de conteúdo de marca"
  },
  "socialExport.tiktok.disclosure.brandedContentVisibilityCannotBePrivate": {
    "defaultMessage": "A privacidade do conteúdo promocional de outra marca não pode ser \"Só eu\"."
  },
  "socialExport.tiktok.disclosure.brandedContentVisibilityTooltip": {
    "defaultMessage": "A visibilidade do conteúdo de marca não pode ser definida como privada."
  },
  "socialExport.tiktok.disclosure.description": {
    "defaultMessage": "Ative para declarar que este vídeo promove bens ou serviços em troca de algo de valor. O seu vídeo pode promover você, um terceiro ou ambos."
  },
  "socialExport.tiktok.disclosure.labelPaidPartnership": {
    "defaultMessage": "O seu vídeo será etiquetado como 'Parceria paga'."
  },
  "socialExport.tiktok.disclosure.labelPaidPartnershipAlert": {
    "defaultMessage": "O seu vídeo será etiquetado como 'Parceria paga'. Isto não pode ser alterado após a publicação."
  },
  "socialExport.tiktok.disclosure.labelPromotionalContent": {
    "defaultMessage": "O seu vídeo será etiquetado como 'Conteúdo promocional'."
  },
  "socialExport.tiktok.disclosure.musicUsageAgree": {
    "defaultMessage": "Ao publicar, você concorda com a nossa {link}."
  },
  "socialExport.tiktok.disclosure.musicUsageConfirmationLink": {
    "defaultMessage": "Confirmação de uso de música"
  },
  "socialExport.tiktok.disclosure.promotionalLabel": {
    "defaultMessage": "O seu vídeo será etiquetado como \"Conteúdo promocional\". Isto não pode ser alterado após a publicação."
  },
  "socialExport.tiktok.disclosure.selectAtLeastOneHint": {
    "defaultMessage": "Precisa de indicar se o seu conteúdo promove a si mesmo, um terceiro ou ambos."
  },
  "socialExport.tiktok.disclosure.toggle": {
    "defaultMessage": "Declarar conteúdo do vídeo"
  },
  "socialExport.tiktok.disclosure.yourBrand.description": {
    "defaultMessage": "Você está promovendo a si mesmo ou o seu próprio negócio. Este vídeo será classificado como Brand Organic."
  },
  "socialExport.tiktok.disclosure.yourBrand.label": {
    "defaultMessage": "Sua marca"
  },
  "socialExport.tiktok.privacy.followers": {
    "defaultMessage": "Seguidores"
  },
  "socialExport.tiktok.privacy.friends": {
    "defaultMessage": "Amigos"
  },
  "socialExport.tiktok.privacy.public": {
    "defaultMessage": "Público"
  },
  "socialExport.tiktok.privacy.self": {
    "defaultMessage": "Só eu"
  },
  "socialExport.tiktok.settings.allowComment": {
    "defaultMessage": "Comentar"
  },
  "socialExport.tiktok.settings.allowDuet": {
    "defaultMessage": "Duet"
  },
  "socialExport.tiktok.settings.allowStitch": {
    "defaultMessage": "Stitch"
  },
  "socialExport.tiktok.settings.allowUsersTo": {
    "defaultMessage": "Permitir aos usuários "
  },
  "socialExport.tiktok.settings.disabledByTiktokPrivacyTooltip": {
    "defaultMessage": "Desativado nas definições de privacidade da tua conta TikTok."
  },
  "socialExport.tiktok.settings.privacyLabel": {
    "defaultMessage": "Privacidade"
  },
  "socialExport.twitter.replyEveryone": {
    "defaultMessage": "Todos"
  },
  "socialExport.twitter.replyFollowing": {
    "defaultMessage": "Pessoas que você segue"
  },
  "socialExport.twitter.replyMentioned": {
    "defaultMessage": "Usuários mencionados"
  },
  "socialExport.twitter.replySubscribers": {
    "defaultMessage": "Assinantes"
  },
  "socialExport.twitter.replyVerified": {
    "defaultMessage": "Verificado"
  },
  "socialExport.uploaded.columnFragment": {
    "defaultMessage": "Fragmento"
  },
  "socialExport.uploaded.columnPublished": {
    "defaultMessage": "Publicado"
  },
  "socialExport.uploaded.columnStation": {
    "defaultMessage": "Estação"
  },
  "socialExport.uploaded.columnStatus": {
    "defaultMessage": "Estado"
  },
  "socialExport.uploaded.linkLabel": {
    "defaultMessage": "Vídeos publicados"
  },
  "socialExport.uploaded.title": {
    "defaultMessage": "Vídeos publicados recentemente"
  },
  "socialExport.youtube.category": {
    "defaultMessage": "Categoria"
  },
  "socialExport.youtube.connect.advancedDescription": {
    "defaultMessage": "Gerenciar playlists e excluir vídeos"
  },
  "socialExport.youtube.connect.advancedName": {
    "defaultMessage": "Modo avançado"
  },
  "socialExport.youtube.connect.advancedPermissions": {
    "defaultMessage": "Enviar vídeos, adicionar a playlists e excluir vídeos"
  },
  "socialExport.youtube.connect.basicDescription": {
    "defaultMessage": "Publicar vídeos sem gerenciar playlists nem excluir"
  },
  "socialExport.youtube.connect.basicName": {
    "defaultMessage": "Modo básico"
  },
  "socialExport.youtube.connect.basicPermissions": {
    "defaultMessage": "Apenas enviar vídeos"
  },
  "socialExport.youtube.idealSize": {
    "defaultMessage": "Tamanho ideal: 1280 x 720 px"
  },
  "socialExport.youtube.madeForKids": {
    "defaultMessage": "Conteúdo adequado para crianças"
  },
  "socialExport.youtube.playlist.helperText": {
    "defaultMessage": "Selecione uma ou mais playlists"
  },
  "socialExport.youtube.playlist.label": {
    "defaultMessage": "Playlists"
  },
  "socialExport.youtube.playlist.noManagePermissions": {
    "defaultMessage": "A conexão atual não tem permissões para gerenciar playlists. É necessário reconectar para conceder essas permissões."
  },
  "socialExport.youtube.playlist.noOptions": {
    "defaultMessage": "Nenhuma playlist disponível"
  },
  "socialExport.youtube.playlist.notFound": {
    "defaultMessage": "Playlist não encontrada?"
  },
  "socialExport.youtube.playlist.privacyStatus.private": {
    "defaultMessage": "Privada"
  },
  "socialExport.youtube.playlist.privacyStatus.public": {
    "defaultMessage": "Pública"
  },
  "socialExport.youtube.playlist.privacyStatus.unlisted": {
    "defaultMessage": "Não listada"
  },
  "socialExport.youtube.playlist.refresh": {
    "defaultMessage": "Atualizar lista"
  },
  "socialExport.youtube.playlist.videoCount": {
    "defaultMessage": "{count, plural, one {# vídeo} other {# vídeos}}"
  },
  "stationConfig.noPrompts": {
    "defaultMessage": "Sem prompts registados"
  },
  "stations.noVideoStations": {
    "defaultMessage": "Nenhuma emissora de vídeo registrada"
  },
  "stations.selector.favorites": {
    "defaultMessage": "Favoritas"
  },
  "stations.selector.myStations": {
    "defaultMessage": "Minhas emissoras"
  },
  "stations.selector.recent": {
    "defaultMessage": "Recentes"
  },
  "stations.selector.removeRecent": {
    "defaultMessage": "Remover dos recentes"
  },
  "stations.selector.shared": {
    "defaultMessage": "Emissoras externas"
  },
  "stations.selector.sharedGroup": {
    "defaultMessage": "{name}"
  },
  "streamBox.device.coords": {
    "defaultMessage": "(Lat. {lat}, Long. {lng})"
  },
  "streamBox.listScreen.manageBtn": {
    "defaultMessage": "Manage device"
  },
  "streamBox.listScreen.noDevices": {
    "defaultMessage": "No devices found"
  },
  "streamBox.listScreen.title": {
    "defaultMessage": "Dispositivos StreamBox"
  },
  "streamBox.nav.title": {
    "defaultMessage": "Stream Box"
  },
  "streamBox.props.device": {
    "defaultMessage": "Dispositivo"
  },
  "streamBox.props.id": {
    "defaultMessage": "ID"
  },
  "streamBox.props.location": {
    "defaultMessage": "Location"
  },
  "streamBox.props.service": {
    "defaultMessage": "Service"
  },
  "streamBox.props.services": {
    "defaultMessage": "Services"
  },
  "streamBox.props.status": {
    "defaultMessage": "Status"
  },
  "streamBox.viewScreen.actions.reboot.btn": {
    "defaultMessage": "Reboot"
  },
  "streamBox.viewScreen.actions.reboot.confirm": {
    "defaultMessage": "Do you really wish to restart the device?"
  },
  "streamBox.viewScreen.actions.reboot.done": {
    "defaultMessage": "Reinicialização do dispositivo solicitada"
  },
  "streamBox.viewScreen.actions.rename.btn": {
    "defaultMessage": "Rename"
  },
  "streamBox.viewScreen.actions.rename.done": {
    "defaultMessage": "Dispositivo renomeado"
  },
  "streamBox.viewScreen.actions.rename.label": {
    "defaultMessage": "New name"
  },
  "streamBox.viewScreen.actions.rename.title": {
    "defaultMessage": "Rename device"
  },
  "streamBox.viewScreen.actions.setCoords.button": {
    "defaultMessage": "Definir coordenadas"
  },
  "streamBox.viewScreen.actions.setCoords.done": {
    "defaultMessage": "Coordenadas atualizadas"
  },
  "streamBox.viewScreen.actions.setCoords.latitude": {
    "defaultMessage": "Latitude"
  },
  "streamBox.viewScreen.actions.setCoords.longitude": {
    "defaultMessage": "Longitude"
  },
  "streamBox.viewScreen.actions.setCoords.title": {
    "defaultMessage": "Set coordinates"
  },
  "streamBox.viewScreen.clickLocation": {
    "defaultMessage": "Click to show location on map"
  },
  "streamBox.viewScreen.loading": {
    "defaultMessage": "Carregando dispositivo"
  },
  "streamBox.viewScreen.services.actions.config.btn": {
    "defaultMessage": "Config"
  },
  "streamBox.viewScreen.services.actions.config.title": {
    "defaultMessage": "Configure service"
  },
  "streamBox.viewScreen.services.actions.restart.btn": {
    "defaultMessage": "Restart"
  },
  "streamBox.viewScreen.services.actions.restart.done": {
    "defaultMessage": "Reinicialização do serviço solicitada"
  },
  "streamBox.viewScreen.services.actions.restart.error": {
    "defaultMessage": "Não foi possível reinicializar o serviço"
  },
  "streamBox.viewScreen.services.actions.restart.prompt": {
    "defaultMessage": "Do you really wish to restart the service?"
  },
  "streamBox.viewScreen.services.actions.start.btn": {
    "defaultMessage": "Start"
  },
  "streamBox.viewScreen.services.actions.start.done": {
    "defaultMessage": "Inicialização do serviço solicitada"
  },
  "streamBox.viewScreen.services.actions.start.error": {
    "defaultMessage": "Não foi possível iniciar o serviço"
  },
  "streamBox.viewScreen.services.actions.start.prompt": {
    "defaultMessage": "Do you really wish to start the service?"
  },
  "streamBox.viewScreen.services.actions.stop.btn": {
    "defaultMessage": "Stop"
  },
  "streamBox.viewScreen.services.actions.stop.done": {
    "defaultMessage": "Parada do serviço solicitada"
  },
  "streamBox.viewScreen.services.actions.stop.error": {
    "defaultMessage": "Não foi possível parar o serviço"
  },
  "streamBox.viewScreen.services.actions.stop.prompt": {
    "defaultMessage": "Do you really wish to stop the service?"
  },
  "streamBox.viewScreen.services.config.done": {
    "defaultMessage": "Configuração do serviço atualizada"
  },
  "streamBox.viewScreen.services.config.error": {
    "defaultMessage": "Não foi possível atualizar a configuração do serviço"
  },
  "streamBox.viewScreen.services.config.noVars": {
    "defaultMessage": "There are no available variables for this service"
  },
  "streamBox.viewScreen.title": {
    "defaultMessage": "Dispositivo {deviceName} / StreamBox"
  },
  "tagGroups.defaultGroup": {
    "defaultMessage": "Grupo por defeito"
  },
  "tagGroups.groupName": {
    "defaultMessage": "Nome do grupo"
  },
  "tagGroups.tags": {
    "defaultMessage": "Tags"
  },
  "tagGroups.tagsPlaceholder": {
    "defaultMessage": "Escreva e prima Enter/vírgula para adicionar tags"
  },
  "tours.driver.done": {
    "defaultMessage": "Pronto"
  },
  "tours.driver.new": {
    "defaultMessage": "Novo"
  },
  "tours.driver.next": {
    "defaultMessage": "Próximo"
  },
  "tours.driver.previous": {
    "defaultMessage": "Anterior"
  },
  "tours.driver.progress": {
    "defaultMessage": "{current} de {total}"
  },
  "ui.copyUrlButton.copyLink": {
    "defaultMessage": "Copiar link para compartilhar"
  },
  "ui.stationsFilter.label": {
    "defaultMessage": "Filtro de emissoras"
  },
  "ui.stationsFilter.optionType.long.individualStation": {
    "defaultMessage": "Emissora individual"
  },
  "ui.stationsFilter.optionType.long.stationGroup": {
    "defaultMessage": "Grupo de emissoras"
  },
  "ui.stationsFilter.optionType.long.stationType": {
    "defaultMessage": "Tipo de emissora"
  },
  "ui.stationsFilter.optionType.short.individualStation": {
    "defaultMessage": "Emissora"
  },
  "ui.stationsFilter.optionType.short.stationGroup": {
    "defaultMessage": "Grupo"
  },
  "ui.stationsFilter.optionType.short.stationType": {
    "defaultMessage": "Tipo"
  },
  "ui.stationsFilter.placeholder": {
    "defaultMessage": "Selecionar uma ou mais opções"
  },
  "ui.stationsSelector.enterToGo": {
    "defaultMessage": "Enter para ir"
  },
  "ui.stationsSelector.searchPlaceholder": {
    "defaultMessage": "Buscar emissora"
  },
  "ui.versionChecker.appUpToDate": {
    "defaultMessage": "O app está atualizado ({version})"
  },
  "ui.versionChecker.newVersionAvailable": {
    "defaultMessage": "Uma nova versão do app está disponível"
  },
  "ui.versionChecker.newVersionAvailableExpand": {
    "defaultMessage": "Nova versão disponível, clique para expandir"
  },
  "ui.versionChecker.newVersionAvailableReload": {
    "defaultMessage": "Nova versão disponível, clique para atualizar"
  },
  "ui.versionChecker.update": {
    "defaultMessage": "Atualizar"
  },
  "userPermission.inheritsFromGroup": {
    "defaultMessage": "Herda do grupo"
  },
  "users.chipList.unknownUser": {
    "defaultMessage": "Usuário desconhecido"
  },
  "validateUpload.fileLabel": {
    "defaultMessage": "Arquivo:"
  },
  "validateUpload.itemsCreated": {
    "defaultMessage": "{count} itens criados"
  },
  "validateUpload.process": {
    "defaultMessage": "Processar"
  },
  "validateUpload.processNewFile": {
    "defaultMessage": "Processar novo arquivo"
  },
  "validateUpload.tryAgain": {
    "defaultMessage": "Tentar novamente"
  },
  "validateUpload.verifyError": {
    "defaultMessage": "Ocorreu um erro ao verificar o ficheiro"
  },
  "validation.maxValue60000": {
    "defaultMessage": "Deve ser menor ou igual a 60000"
  },
  "validation.minValueZero": {
    "defaultMessage": "Deve ser maior ou igual a 0"
  },
  "videoEditions.autoEditName": {
    "defaultMessage": "Edit {n}"
  },
  "videoEditions.category.draftChip": {
    "defaultMessage": "Rascunhos e em progresso ({count})"
  },
  "videoEditions.category.generatedChip": {
    "defaultMessage": "Gerados ({count})"
  },
  "videoEditions.clone": {
    "defaultMessage": "Clonar edit"
  },
  "videoEditions.cloneDialog.nameLabel": {
    "defaultMessage": "Nome"
  },
  "videoEditions.cloneDialog.submit": {
    "defaultMessage": "Clonar"
  },
  "videoEditions.cloneDialog.title": {
    "defaultMessage": "Clonar edit"
  },
  "videoEditions.createEdit": {
    "defaultMessage": "Criar edit"
  },
  "videoEditions.deleteConfirm": {
    "defaultMessage": "Excluir este edit? Esta ação não pode ser desfeita."
  },
  "videoEditions.editCard.publishedOn": {
    "defaultMessage": "Publicado em"
  },
  "videoEditions.emptyDraftTab": {
    "defaultMessage": "Não há rascunhos nem renders em curso nesta secção"
  },
  "videoEditions.emptyGeneratedTab": {
    "defaultMessage": "Ainda não há vídeos gerados"
  },
  "videoEditions.emptyHelp": {
    "defaultMessage": "Ainda não há edits"
  },
  "videoEditions.finishedOn": {
    "defaultMessage": "Gerado"
  },
  "videoEditions.status.generated": {
    "defaultMessage": "Pronto para publicar"
  },
  "videoEditions.status.notGenerated": {
    "defaultMessage": "Não gerado"
  },
  "videoEditions.tabTitle": {
    "defaultMessage": "edits"
  },
  "youtube.cuepoints.column.createdAt": {
    "defaultMessage": "Data/hora de inserção"
  },
  "youtube.cuepoints.column.cuepointId": {
    "defaultMessage": "ID do cuepoint"
  },
  "youtube.cuepoints.column.videoId": {
    "defaultMessage": "ID do vídeo"
  },
  "youtube.cuepoints.insert.button": {
    "defaultMessage": "Inserir cuepoint"
  },
  "youtube.cuepoints.insert.dialogTitle": {
    "defaultMessage": "Inserir cuepoint manualmente"
  },
  "youtube.cuepoints.insert.durationHelper": {
    "defaultMessage": "Entre 1 e 300 segundos"
  },
  "youtube.cuepoints.insert.durationLabel": {
    "defaultMessage": "Duração (segundos)"
  },
  "youtube.cuepoints.insert.durationMax": {
    "defaultMessage": "A duração máxima é de 300 segundos"
  },
  "youtube.cuepoints.insert.durationMin": {
    "defaultMessage": "A duração mínima é de 1 segundo"
  },
  "youtube.cuepoints.insert.durationRequired": {
    "defaultMessage": "A duração é obrigatória"
  },
  "youtube.cuepoints.insert.error": {
    "defaultMessage": "Não foi possível inserir o cuepoint"
  },
  "youtube.cuepoints.insert.submit": {
    "defaultMessage": "Inserir"
  },
  "youtube.cuepoints.insert.success": {
    "defaultMessage": "Cuepoint inserido com sucesso"
  },
  "youtube.cuepoints.manageCuepoints": {
    "defaultMessage": "Ver cuepoints registrados"
  },
  "youtube.cuepoints.manageCuepointsAlertTitle": {
    "defaultMessage": "Cuepoints do YouTube"
  },
  "youtube.cuepoints.pageTitle": {
    "defaultMessage": "Cuepoints"
  },
  "youtube.privacyStatus.label": {
    "defaultMessage": "Status de privacidade"
  },
  "youtube.privacyStatus.private": {
    "defaultMessage": "Privado"
  },
  "youtube.privacyStatus.public": {
    "defaultMessage": "Público"
  },
  "youtube.privacyStatus.unlisted": {
    "defaultMessage": "Não listado"
  }
}
